/*!
 * modernizr.min.js
 */
/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-objectfit-touchevents-setclasses !*/
/*!
 * stylehatch-standards.js
 */
function replaceUrlParam(e, t, n) {
    var i = new RegExp("(" + t + "=).*?(&|$)")
      , r = e;
    return r = e.search(i) >= 0 ? e.replace(i, "$1" + n + "$2") : r + (r.indexOf("?") > 0 ? "&" : "?") + t + "=" + n
}
function removeDataAttributes(e) {
    var t, n = $(e);
    if (n.length > 0) {
        var i = []
          , r = n.get(0).attributes
          , o = r.length;
        for (t = 0; t < o; t++)
            "data-" === r[t].name.substring(0, 5) && i.push(r[t].name);
        $.each(i, function(e, t) {
            n.removeAttr(t)
        })
    }
}
function wordWrapper(e, t, n) {
    if (e.length > t) {
        for (var i = t; i > 0 && " " != e[i]; i--)
            ;
        if (i > 0) {
            var r = e.substring(0, i)
              , o = e.substring(i + 1);
            return r + n + wordWrapper(o, t, n)
        }
    }
    return e
}
function isFocusable(e) {
    document.activeElement;
    return e.focus(),
    document.activeElement === e
}
function waitFor(e, t) {
    e() ? t() : window.setTimeout(waitFor.bind(null, e, t), 20)
}
function isUnfocusable(e) {
    var t = document.activeElement;
    return e.focus(),
    document.activeElement === t && (document.activeElement !== e && (!e.hasAttribute("tabindex") || "0" !== e.getAttribute("tabindex")))
}
!function(e, t, n) {
    function i(e, t) {
        return typeof e === t
    }
    function r() {
        var e, t, n, r, o, s, a;
        for (var l in b)
            if (b.hasOwnProperty(l)) {
                if (e = [],
                t = b[l],
                t.name && (e.push(t.name.toLowerCase()),
                t.options && t.options.aliases && t.options.aliases.length))
                    for (n = 0; n < t.options.aliases.length; n++)
                        e.push(t.options.aliases[n].toLowerCase());
                for (r = i(t.fn, "function") ? t.fn() : t.fn,
                o = 0; o < e.length; o++)
                    s = e[o],
                    a = s.split("."),
                    1 === a.length ? x[a[0]] = r : (!x[a[0]] || x[a[0]]instanceof Boolean || (x[a[0]] = new Boolean(x[a[0]])),
                    x[a[0]][a[1]] = r),
                    y.push((r ? "" : "no-") + a.join("-"))
            }
    }
    function o(e) {
        var t = _.className
          , n = x._config.classPrefix || "";
        if (C && (t = t.baseVal),
        x._config.enableJSClass) {
            var i = new RegExp("(^|\\s)" + n + "no-js(\\s|$)");
            t = t.replace(i, "$1" + n + "js$2")
        }
        x._config.enableClasses && (t += " " + n + e.join(" " + n),
        C ? _.className.baseVal = t : _.className = t)
    }
    function s(e) {
        return e.replace(/([a-z])-([a-z])/g, function(e, t, n) {
            return t + n.toUpperCase()
        }).replace(/^-/, "")
    }
    function a(e, t) {
        return !!~("" + e).indexOf(t)
    }
    function l() {
        return "function" != typeof t.createElement ? t.createElement(arguments[0]) : C ? t.createElementNS.call(t, "http://www.w3.org/2000/svg", arguments[0]) : t.createElement.apply(t, arguments)
    }
    function u(e, t) {
        return function() {
            return e.apply(t, arguments)
        }
    }
    function c(e, t, n) {
        var r;
        for (var o in e)
            if (e[o]in t)
                return n === !1 ? e[o] : (r = t[e[o]],
                i(r, "function") ? u(r, n || t) : r);
        return !1
    }
    function d(e) {
        return e.replace(/([A-Z])/g, function(e, t) {
            return "-" + t.toLowerCase()
        }).replace(/^ms-/, "-ms-")
    }
    function f(t, n, i) {
        var r;
        if ("getComputedStyle"in e) {
            r = getComputedStyle.call(e, t, n);
            var o = e.console;
            if (null !== r)
                i && (r = r.getPropertyValue(i));
            else if (o) {
                var s = o.error ? "error" : "log";
                o[s].call(o, "getComputedStyle returning null, its possible modernizr test results are inaccurate")
            }
        } else
            r = !n && t.currentStyle && t.currentStyle[i];
        return r
    }
    function h() {
        var e = t.body;
        return e || (e = l(C ? "svg" : "body"),
        e.fake = !0),
        e
    }
    function p(e, n, i, r) {
        var o, s, a, u, c = "modernizr", d = l("div"), f = h();
        if (parseInt(i, 10))
            for (; i--; )
                a = l("div"),
                a.id = r ? r[i] : c + (i + 1),
                d.appendChild(a);
        return o = l("style"),
        o.type = "text/css",
        o.id = "s" + c,
        (f.fake ? f : d).appendChild(o),
        f.appendChild(d),
        o.styleSheet ? o.styleSheet.cssText = e : o.appendChild(t.createTextNode(e)),
        d.id = c,
        f.fake && (f.style.background = "",
        f.style.overflow = "hidden",
        u = _.style.overflow,
        _.style.overflow = "hidden",
        _.appendChild(f)),
        s = n(d, e),
        f.fake ? (f.parentNode.removeChild(f),
        _.style.overflow = u,
        _.offsetHeight) : d.parentNode.removeChild(d),
        !!s
    }
    function m(t, i) {
        var r = t.length;
        if ("CSS"in e && "supports"in e.CSS) {
            for (; r--; )
                if (e.CSS.supports(d(t[r]), i))
                    return !0;
            return !1
        }
        if ("CSSSupportsRule"in e) {
            for (var o = []; r--; )
                o.push("(" + d(t[r]) + ":" + i + ")");
            return o = o.join(" or "),
            p("@supports (" + o + ") { #modernizr { position: absolute; } }", function(e) {
                return "absolute" == f(e, null, "position")
            })
        }
        return n
    }
    function g(e, t, r, o) {
        function u() {
            d && (delete I.style,
            delete I.modElem)
        }
        if (o = !i(o, "undefined") && o,
        !i(r, "undefined")) {
            var c = m(e, r);
            if (!i(c, "undefined"))
                return c
        }
        for (var d, f, h, p, g, v = ["modernizr", "tspan", "samp"]; !I.style && v.length; )
            d = !0,
            I.modElem = l(v.shift()),
            I.style = I.modElem.style;
        for (h = e.length,
        f = 0; h > f; f++)
            if (p = e[f],
            g = I.style[p],
            a(p, "-") && (p = s(p)),
            I.style[p] !== n) {
                if (o || i(r, "undefined"))
                    return u(),
                    "pfx" != t || p;
                try {
                    I.style[p] = r
                } catch (e) {}
                if (I.style[p] != g)
                    return u(),
                    "pfx" != t || p
            }
        return u(),
        !1
    }
    function v(e, t, n, r, o) {
        var s = e.charAt(0).toUpperCase() + e.slice(1)
          , a = (e + " " + S.join(s + " ") + s).split(" ");
        return i(t, "string") || i(t, "undefined") ? g(a, t, r, o) : (a = (e + " " + k.join(s + " ") + s).split(" "),
        c(a, t, n))
    }
    var y = []
      , b = []
      , w = {
        _version: "3.6.0",
        _config: {
            classPrefix: "",
            enableClasses: !0,
            enableJSClass: !0,
            usePrefixes: !0
        },
        _q: [],
        on: function(e, t) {
            var n = this;
            setTimeout(function() {
                t(n[e])
            }, 0)
        },
        addTest: function(e, t, n) {
            b.push({
                name: e,
                fn: t,
                options: n
            })
        },
        addAsyncTest: function(e) {
            b.push({
                name: null,
                fn: e
            })
        }
    }
      , x = function() {};
    x.prototype = w,
    x = new x;
    var _ = t.documentElement
      , C = "svg" === _.nodeName.toLowerCase()
      , E = "Moz O ms Webkit"
      , S = w._config.usePrefixes ? E.split(" ") : [];
    w._cssomPrefixes = S;
    var T = function(t) {
        var i, r = z.length, o = e.CSSRule;
        if ("undefined" == typeof o)
            return n;
        if (!t)
            return !1;
        if (t = t.replace(/^@/, ""),
        i = t.replace(/-/g, "_").toUpperCase() + "_RULE",
        i in o)
            return "@" + t;
        for (var s = 0; r > s; s++) {
            var a = z[s]
              , l = a.toUpperCase() + "_" + i;
            if (l in o)
                return "@-" + a.toLowerCase() + "-" + t
        }
        return !1
    };
    w.atRule = T;
    var k = w._config.usePrefixes ? E.toLowerCase().split(" ") : [];
    w._domPrefixes = k;
    var A = {
        elem: l("modernizr")
    };
    x._q.push(function() {
        delete A.elem
    });
    var I = {
        style: A.elem.style
    };
    x._q.unshift(function() {
        delete I.style
    }),
    w.testAllProps = v;
    var D = w.prefixed = function(e, t, n) {
        return 0 === e.indexOf("@") ? T(e) : (-1 != e.indexOf("-") && (e = s(e)),
        t ? v(e, t, n) : v(e, "pfx"))
    }
    ;
    x.addTest("objectfit", !!D("objectFit"), {
        aliases: ["object-fit"]
    });
    var L = w.testStyles = p
      , z = w._config.usePrefixes ? " -webkit- -moz- -o- -ms- ".split(" ") : ["", ""];
    w._prefixes = z,
    x.addTest("touchevents", function() {
        var n;
        if ("ontouchstart"in e || e.DocumentTouch && t instanceof DocumentTouch)
            n = !0;
        else {
            var i = ["@media (", z.join("touch-enabled),("), "heartz", ")", "{#modernizr{top:9px;position:absolute}}"].join("");
            L(i, function(e) {
                n = 9 === e.offsetTop
            })
        }
        return n
    }),
    r(),
    o(y),
    delete w.addTest,
    delete w.addAsyncTest;
    for (var P = 0; P < x._q.length; P++)
        x._q[P]();
    e.Modernizr = x
}(window, document),
/*!
 * log.js
 */
/*! log.js 0.1.5 */
function() {
    var e, t, n, i, r, o, s, a, l, u, c, d, f, h, p;
    window.console && window.console.log && (u = function() {
        var e;
        return e = [],
        c(arguments).forEach(function(t) {
            return "string" == typeof t ? e = e.concat(h(t)) : e.push(t)
        }),
        p.apply(window, e)
    }
    ,
    p = function() {
        return console.log.apply(console, c(arguments))
    }
    ,
    c = function(e) {
        return Array.prototype.slice.call(e)
    }
    ,
    n = [{
        regex: /\*([^\*]+)\*/,
        replacer: function(e, t) {
            return "%c" + t + "%c"
        },
        styles: function() {
            return ["font-style: italic", ""]
        }
    }, {
        regex: /\_([^\_]+)\_/,
        replacer: function(e, t) {
            return "%c" + t + "%c"
        },
        styles: function() {
            return ["font-weight: bold", ""]
        }
    }, {
        regex: /\`([^\`]+)\`/,
        replacer: function(e, t) {
            return "%c" + t + "%c"
        },
        styles: function() {
            return ["background: rgb(255, 255, 219); padding: 1px 5px; border: 1px solid rgba(0, 0, 0, 0.1)", ""]
        }
    }, {
        regex: /\[c\=(?:\"|\')?((?:(?!(?:\"|\')\]).)*)(?:\"|\')?\]((?:(?!\[c\]).)*)\[c\]/,
        replacer: function(e, t, n) {
            return "%c" + n + "%c"
        },
        styles: function(e) {
            return [e[1], ""]
        }
    }],
    r = function(e) {
        var t;
        return t = !1,
        n.forEach(function(n) {
            return n.regex.test(e) ? t = !0 : void 0
        }),
        t
    }
    ,
    i = function(e) {
        var t;
        return t = [],
        n.forEach(function(n) {
            var i;
            return i = e.match(n.regex),
            i ? t.push({
                format: n,
                match: i
            }) : void 0
        }),
        t.sort(function(e, t) {
            return e.match.index - t.match.index
        })
    }
    ,
    h = function(e) {
        var t, n, o;
        for (o = []; r(e); )
            n = i(e),
            t = n[0],
            e = e.replace(t.format.regex, t.format.replacer),
            o = o.concat(t.format.styles(t.match));
        return [e].concat(o)
    }
    ,
    l = function() {
        return /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor)
    }
    ,
    a = function() {
        return /OPR/.test(navigator.userAgent) && /Opera/.test(navigator.vendor)
    }
    ,
    o = function() {
        return /Firefox/.test(navigator.userAgent)
    }
    ,
    s = function() {
        return /MSIE/.test(navigator.userAgent)
    }
    ,
    f = function() {
        var e;
        return e = navigator.userAgent.match(/AppleWebKit\/(\d+)\.(\d+)(\.|\+|\s)/),
        !!e && 537.38 <= parseInt(e[1], 10) + parseInt(e[2], 10) / 100
    }
    ,
    d = function() {
        var e;
        return e = navigator.userAgent.match(/OPR\/(\d+)\./),
        !!e && 15 <= parseInt(e[1], 10)
    }
    ,
    t = function() {
        return window.console.firebug || window.console.exception
    }
    ,
    e = s() || o() && !t() || a() && !d() || l() && !f() ? p : u,
    e.l = p,
    "function" == typeof define && define.amd ? define(e) : "undefined" != typeof exports ? module.exports = e : window.log = e)
}
.call(this),
/*!
 * jquery-2.2.3.min.js
 */
/*! jQuery v3.3.1 | (c) JS Foundation and other contributors | jquery.org/license */
!function(e, t) {
    "use strict";
    "object" == typeof module && "object" == typeof module.exports ? module.exports = e.document ? t(e, !0) : function(e) {
        if (!e.document)
            throw new Error("jQuery requires a window with a document");
        return t(e)
    }
    : t(e)
}("undefined" != typeof window ? window : this, function(e, t) {
    "use strict";
    function n(e, t, n) {
        var i, r = (t = t || se).createElement("script");
        if (r.text = e,
        n)
            for (i in we)
                n[i] && (r[i] = n[i]);
        t.head.appendChild(r).parentNode.removeChild(r)
    }
    function i(e) {
        return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? fe[he.call(e)] || "object" : typeof e
    }
    function r(e) {
        var t = !!e && "length"in e && e.length
          , n = i(e);
        return !ye(e) && !be(e) && ("array" === n || 0 === t || "number" == typeof t && t > 0 && t - 1 in e)
    }
    function o(e, t) {
        return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase()
    }
    function s(e, t, n) {
        return ye(t) ? xe.grep(e, function(e, i) {
            return !!t.call(e, i, e) !== n
        }) : t.nodeType ? xe.grep(e, function(e) {
            return e === t !== n
        }) : "string" != typeof t ? xe.grep(e, function(e) {
            return de.call(t, e) > -1 !== n
        }) : xe.filter(t, e, n)
    }
    function a(e, t) {
        for (; (e = e[t]) && 1 !== e.nodeType; )
            ;
        return e
    }
    function l(e) {
        var t = {};
        return xe.each(e.match(ze) || [], function(e, n) {
            t[n] = !0
        }),
        t
    }
    function u(e) {
        return e
    }
    function c(e) {
        throw e
    }
    function d(e, t, n, i) {
        var r;
        try {
            e && ye(r = e.promise) ? r.call(e).done(t).fail(n) : e && ye(r = e.then) ? r.call(e, t, n) : t.apply(void 0, [e].slice(i))
        } catch (e) {
            n.apply(void 0, [e])
        }
    }
    function f() {
        se.removeEventListener("DOMContentLoaded", f),
        e.removeEventListener("load", f),
        xe.ready()
    }
    function h(e, t) {
        return t.toUpperCase()
    }
    function p(e) {
        return e.replace(Me, "ms-").replace(Oe, h)
    }
    function m() {
        this.expando = xe.expando + m.uid++
    }
    function g(e) {
        return "true" === e || "false" !== e && ("null" === e ? null : e === +e + "" ? +e : He.test(e) ? JSON.parse(e) : e)
    }
    function v(e, t, n) {
        var i;
        if (void 0 === n && 1 === e.nodeType)
            if (i = "data-" + t.replace(Re, "-$&").toLowerCase(),
            "string" == typeof (n = e.getAttribute(i))) {
                try {
                    n = g(n)
                } catch (e) {}
                Be.set(e, t, n)
            } else
                n = void 0;
        return n
    }
    function y(e, t, n, i) {
        var r, o, s = 20, a = i ? function() {
            return i.cur()
        }
        : function() {
            return xe.css(e, t, "")
        }
        , l = a(), u = n && n[3] || (xe.cssNumber[t] ? "" : "px"), c = (xe.cssNumber[t] || "px" !== u && +l) && Ue.exec(xe.css(e, t));
        if (c && c[3] !== u) {
            for (l /= 2,
            u = u || c[3],
            c = +l || 1; s--; )
                xe.style(e, t, c + u),
                (1 - o) * (1 - (o = a() / l || .5)) <= 0 && (s = 0),
                c /= o;
            c *= 2,
            xe.style(e, t, c + u),
            n = n || []
        }
        return n && (c = +c || +l || 0,
        r = n[1] ? c + (n[1] + 1) * n[2] : +n[2],
        i && (i.unit = u,
        i.start = c,
        i.end = r)),
        r
    }
    function b(e) {
        var t, n = e.ownerDocument, i = e.nodeName, r = Ye[i];
        return r || (t = n.body.appendChild(n.createElement(i)),
        r = xe.css(t, "display"),
        t.parentNode.removeChild(t),
        "none" === r && (r = "block"),
        Ye[i] = r,
        r)
    }
    function w(e, t) {
        for (var n, i, r = [], o = 0, s = e.length; o < s; o++)
            (i = e[o]).style && (n = i.style.display,
            t ? ("none" === n && (r[o] = qe.get(i, "display") || null,
            r[o] || (i.style.display = "")),
            "" === i.style.display && Ve(i) && (r[o] = b(i))) : "none" !== n && (r[o] = "none",
            qe.set(i, "display", n)));
        for (o = 0; o < s; o++)
            null != r[o] && (e[o].style.display = r[o]);
        return e
    }
    function x(e, t) {
        var n;
        return n = "undefined" != typeof e.getElementsByTagName ? e.getElementsByTagName(t || "*") : "undefined" != typeof e.querySelectorAll ? e.querySelectorAll(t || "*") : [],
        void 0 === t || t && o(e, t) ? xe.merge([e], n) : n
    }
    function _(e, t) {
        for (var n = 0, i = e.length; n < i; n++)
            qe.set(e[n], "globalEval", !t || qe.get(t[n], "globalEval"))
    }
    function C(e, t, n, r, o) {
        for (var s, a, l, u, c, d, f = t.createDocumentFragment(), h = [], p = 0, m = e.length; p < m; p++)
            if ((s = e[p]) || 0 === s)
                if ("object" === i(s))
                    xe.merge(h, s.nodeType ? [s] : s);
                else if (Ke.test(s)) {
                    for (a = a || f.appendChild(t.createElement("div")),
                    l = (Ge.exec(s) || ["", ""])[1].toLowerCase(),
                    u = Ze[l] || Ze._default,
                    a.innerHTML = u[1] + xe.htmlPrefilter(s) + u[2],
                    d = u[0]; d--; )
                        a = a.lastChild;
                    xe.merge(h, a.childNodes),
                    (a = f.firstChild).textContent = ""
                } else
                    h.push(t.createTextNode(s));
        for (f.textContent = "",
        p = 0; s = h[p++]; )
            if (r && xe.inArray(s, r) > -1)
                o && o.push(s);
            else if (c = xe.contains(s.ownerDocument, s),
            a = x(f.appendChild(s), "script"),
            c && _(a),
            n)
                for (d = 0; s = a[d++]; )
                    Je.test(s.type || "") && n.push(s);
        return f
    }
    function E() {
        return !0
    }
    function S() {
        return !1
    }
    function T() {
        try {
            return se.activeElement
        } catch (e) {}
    }
    function k(e, t, n, i, r, o) {
        var s, a;
        if ("object" == typeof t) {
            "string" != typeof n && (i = i || n,
            n = void 0);
            for (a in t)
                k(e, a, n, i, t[a], o);
            return e
        }
        if (null == i && null == r ? (r = n,
        i = n = void 0) : null == r && ("string" == typeof n ? (r = i,
        i = void 0) : (r = i,
        i = n,
        n = void 0)),
        !1 === r)
            r = S;
        else if (!r)
            return e;
        return 1 === o && (s = r,
        (r = function(e) {
            return xe().off(e),
            s.apply(this, arguments)
        }
        ).guid = s.guid || (s.guid = xe.guid++)),
        e.each(function() {
            xe.event.add(this, t, r, i, n)
        })
    }
    function A(e, t) {
        return o(e, "table") && o(11 !== t.nodeType ? t : t.firstChild, "tr") ? xe(e).children("tbody")[0] || e : e
    }
    function I(e) {
        return e.type = (null !== e.getAttribute("type")) + "/" + e.type,
        e
    }
    function D(e) {
        return "true/" === (e.type || "").slice(0, 5) ? e.type = e.type.slice(5) : e.removeAttribute("type"),
        e
    }
    function L(e, t) {
        var n, i, r, o, s, a, l, u;
        if (1 === t.nodeType) {
            if (qe.hasData(e) && (o = qe.access(e),
            s = qe.set(t, o),
            u = o.events)) {
                delete s.handle,
                s.events = {};
                for (r in u)
                    for (n = 0,
                    i = u[r].length; n < i; n++)
                        xe.event.add(t, r, u[r][n])
            }
            Be.hasData(e) && (a = Be.access(e),
            l = xe.extend({}, a),
            Be.set(t, l))
        }
    }
    function z(e, t) {
        var n = t.nodeName.toLowerCase();
        "input" === n && Xe.test(e.type) ? t.checked = e.checked : "input" !== n && "textarea" !== n || (t.defaultValue = e.defaultValue)
    }
    function P(e, t, i, r) {
        t = ue.apply([], t);
        var o, s, a, l, u, c, d = 0, f = e.length, h = f - 1, p = t[0], m = ye(p);
        if (m || f > 1 && "string" == typeof p && !ve.checkClone && st.test(p))
            return e.each(function(n) {
                var o = e.eq(n);
                m && (t[0] = p.call(this, n, o.html())),
                P(o, t, i, r)
            });
        if (f && (o = C(t, e[0].ownerDocument, !1, e, r),
        s = o.firstChild,
        1 === o.childNodes.length && (o = s),
        s || r)) {
            for (l = (a = xe.map(x(o, "script"), I)).length; d < f; d++)
                u = o,
                d !== h && (u = xe.clone(u, !0, !0),
                l && xe.merge(a, x(u, "script"))),
                i.call(e[d], u, d);
            if (l)
                for (c = a[a.length - 1].ownerDocument,
                xe.map(a, D),
                d = 0; d < l; d++)
                    u = a[d],
                    Je.test(u.type || "") && !qe.access(u, "globalEval") && xe.contains(c, u) && (u.src && "module" !== (u.type || "").toLowerCase() ? xe._evalUrl && xe._evalUrl(u.src) : n(u.textContent.replace(at, ""), c, u))
        }
        return e
    }
    function N(e, t, n) {
        for (var i, r = t ? xe.filter(t, e) : e, o = 0; null != (i = r[o]); o++)
            n || 1 !== i.nodeType || xe.cleanData(x(i)),
            i.parentNode && (n && xe.contains(i.ownerDocument, i) && _(x(i, "script")),
            i.parentNode.removeChild(i));
        return e
    }
    function j(e, t, n) {
        var i, r, o, s, a = e.style;
        return (n = n || ut(e)) && ("" !== (s = n.getPropertyValue(t) || n[t]) || xe.contains(e.ownerDocument, e) || (s = xe.style(e, t)),
        !ve.pixelBoxStyles() && lt.test(s) && ct.test(t) && (i = a.width,
        r = a.minWidth,
        o = a.maxWidth,
        a.minWidth = a.maxWidth = a.width = s,
        s = n.width,
        a.width = i,
        a.minWidth = r,
        a.maxWidth = o)),
        void 0 !== s ? s + "" : s
    }
    function M(e, t) {
        return {
            get: function() {
                return e() ? void delete this.get : (this.get = t).apply(this, arguments)
            }
        }
    }
    function O(e) {
        if (e in gt)
            return e;
        for (var t = e[0].toUpperCase() + e.slice(1), n = mt.length; n--; )
            if ((e = mt[n] + t)in gt)
                return e
    }
    function F(e) {
        var t = xe.cssProps[e];
        return t || (t = xe.cssProps[e] = O(e) || e),
        t
    }
    function q(e, t, n) {
        var i = Ue.exec(t);
        return i ? Math.max(0, i[2] - (n || 0)) + (i[3] || "px") : t
    }
    function B(e, t, n, i, r, o) {
        var s = "width" === t ? 1 : 0
          , a = 0
          , l = 0;
        if (n === (i ? "border" : "content"))
            return 0;
        for (; s < 4; s += 2)
            "margin" === n && (l += xe.css(e, n + $e[s], !0, r)),
            i ? ("content" === n && (l -= xe.css(e, "padding" + $e[s], !0, r)),
            "margin" !== n && (l -= xe.css(e, "border" + $e[s] + "Width", !0, r))) : (l += xe.css(e, "padding" + $e[s], !0, r),
            "padding" !== n ? l += xe.css(e, "border" + $e[s] + "Width", !0, r) : a += xe.css(e, "border" + $e[s] + "Width", !0, r));
        return !i && o >= 0 && (l += Math.max(0, Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - o - l - a - .5))),
        l
    }
    function H(e, t, n) {
        var i = ut(e)
          , r = j(e, t, i)
          , o = "border-box" === xe.css(e, "boxSizing", !1, i)
          , s = o;
        if (lt.test(r)) {
            if (!n)
                return r;
            r = "auto"
        }
        return s = s && (ve.boxSizingReliable() || r === e.style[t]),
        ("auto" === r || !parseFloat(r) && "inline" === xe.css(e, "display", !1, i)) && (r = e["offset" + t[0].toUpperCase() + t.slice(1)],
        s = !0),
        (r = parseFloat(r) || 0) + B(e, t, n || (o ? "border" : "content"), s, i, r) + "px"
    }
    function R(e, t, n, i, r) {
        return new R.prototype.init(e,t,n,i,r)
    }
    function W() {
        yt && (!1 === se.hidden && e.requestAnimationFrame ? e.requestAnimationFrame(W) : e.setTimeout(W, xe.fx.interval),
        xe.fx.tick())
    }
    function U() {
        return e.setTimeout(function() {
            vt = void 0
        }),
        vt = Date.now()
    }
    function $(e, t) {
        var n, i = 0, r = {
            height: e
        };
        for (t = t ? 1 : 0; i < 4; i += 2 - t)
            r["margin" + (n = $e[i])] = r["padding" + n] = e;
        return t && (r.opacity = r.width = e),
        r
    }
    function V(e, t, n) {
        for (var i, r = (X.tweeners[t] || []).concat(X.tweeners["*"]), o = 0, s = r.length; o < s; o++)
            if (i = r[o].call(n, t, e))
                return i
    }
    function Q(e, t, n) {
        var i, r, o, s, a, l, u, c, d = "width"in t || "height"in t, f = this, h = {}, p = e.style, m = e.nodeType && Ve(e), g = qe.get(e, "fxshow");
        n.queue || (null == (s = xe._queueHooks(e, "fx")).unqueued && (s.unqueued = 0,
        a = s.empty.fire,
        s.empty.fire = function() {
            s.unqueued || a()
        }
        ),
        s.unqueued++,
        f.always(function() {
            f.always(function() {
                s.unqueued--,
                xe.queue(e, "fx").length || s.empty.fire()
            })
        }));
        for (i in t)
            if (r = t[i],
            bt.test(r)) {
                if (delete t[i],
                o = o || "toggle" === r,
                r === (m ? "hide" : "show")) {
                    if ("show" !== r || !g || void 0 === g[i])
                        continue;
                    m = !0
                }
                h[i] = g && g[i] || xe.style(e, i)
            }
        if ((l = !xe.isEmptyObject(t)) || !xe.isEmptyObject(h)) {
            d && 1 === e.nodeType && (n.overflow = [p.overflow, p.overflowX, p.overflowY],
            null == (u = g && g.display) && (u = qe.get(e, "display")),
            "none" === (c = xe.css(e, "display")) && (u ? c = u : (w([e], !0),
            u = e.style.display || u,
            c = xe.css(e, "display"),
            w([e]))),
            ("inline" === c || "inline-block" === c && null != u) && "none" === xe.css(e, "float") && (l || (f.done(function() {
                p.display = u
            }),
            null == u && (c = p.display,
            u = "none" === c ? "" : c)),
            p.display = "inline-block")),
            n.overflow && (p.overflow = "hidden",
            f.always(function() {
                p.overflow = n.overflow[0],
                p.overflowX = n.overflow[1],
                p.overflowY = n.overflow[2]
            })),
            l = !1;
            for (i in h)
                l || (g ? "hidden"in g && (m = g.hidden) : g = qe.access(e, "fxshow", {
                    display: u
                }),
                o && (g.hidden = !m),
                m && w([e], !0),
                f.done(function() {
                    m || w([e]),
                    qe.remove(e, "fxshow");
                    for (i in h)
                        xe.style(e, i, h[i])
                })),
                l = V(m ? g[i] : 0, i, f),
                i in g || (g[i] = l.start,
                m && (l.end = l.start,
                l.start = 0))
        }
    }
    function Y(e, t) {
        var n, i, r, o, s;
        for (n in e)
            if (i = p(n),
            r = t[i],
            o = e[n],
            Array.isArray(o) && (r = o[1],
            o = e[n] = o[0]),
            n !== i && (e[i] = o,
            delete e[n]),
            (s = xe.cssHooks[i]) && "expand"in s) {
                o = s.expand(o),
                delete e[i];
                for (n in o)
                    n in e || (e[n] = o[n],
                    t[n] = r)
            } else
                t[i] = r
    }
    function X(e, t, n) {
        var i, r, o = 0, s = X.prefilters.length, a = xe.Deferred().always(function() {
            delete l.elem
        }), l = function() {
            if (r)
                return !1;
            for (var t = vt || U(), n = Math.max(0, u.startTime + u.duration - t), i = 1 - (n / u.duration || 0), o = 0, s = u.tweens.length; o < s; o++)
                u.tweens[o].run(i);
            return a.notifyWith(e, [u, i, n]),
            i < 1 && s ? n : (s || a.notifyWith(e, [u, 1, 0]),
            a.resolveWith(e, [u]),
            !1)
        }, u = a.promise({
            elem: e,
            props: xe.extend({}, t),
            opts: xe.extend(!0, {
                specialEasing: {},
                easing: xe.easing._default
            }, n),
            originalProperties: t,
            originalOptions: n,
            startTime: vt || U(),
            duration: n.duration,
            tweens: [],
            createTween: function(t, n) {
                var i = xe.Tween(e, u.opts, t, n, u.opts.specialEasing[t] || u.opts.easing);
                return u.tweens.push(i),
                i
            },
            stop: function(t) {
                var n = 0
                  , i = t ? u.tweens.length : 0;
                if (r)
                    return this;
                for (r = !0; n < i; n++)
                    u.tweens[n].run(1);
                return t ? (a.notifyWith(e, [u, 1, 0]),
                a.resolveWith(e, [u, t])) : a.rejectWith(e, [u, t]),
                this
            }
        }), c = u.props;
        for (Y(c, u.opts.specialEasing); o < s; o++)
            if (i = X.prefilters[o].call(u, e, c, u.opts))
                return ye(i.stop) && (xe._queueHooks(u.elem, u.opts.queue).stop = i.stop.bind(i)),
                i;
        return xe.map(c, V, u),
        ye(u.opts.start) && u.opts.start.call(e, u),
        u.progress(u.opts.progress).done(u.opts.done, u.opts.complete).fail(u.opts.fail).always(u.opts.always),
        xe.fx.timer(xe.extend(l, {
            elem: e,
            anim: u,
            queue: u.opts.queue
        })),
        u
    }
    function G(e) {
        return (e.match(ze) || []).join(" ")
    }
    function J(e) {
        return e.getAttribute && e.getAttribute("class") || ""
    }
    function Z(e) {
        return Array.isArray(e) ? e : "string" == typeof e ? e.match(ze) || [] : []
    }
    function K(e, t, n, r) {
        var o;
        if (Array.isArray(t))
            xe.each(t, function(t, i) {
                n || Lt.test(e) ? r(e, i) : K(e + "[" + ("object" == typeof i && null != i ? t : "") + "]", i, n, r)
            });
        else if (n || "object" !== i(t))
            r(e, t);
        else
            for (o in t)
                K(e + "[" + o + "]", t[o], n, r)
    }
    function ee(e) {
        return function(t, n) {
            "string" != typeof t && (n = t,
            t = "*");
            var i, r = 0, o = t.toLowerCase().match(ze) || [];
            if (ye(n))
                for (; i = o[r++]; )
                    "+" === i[0] ? (i = i.slice(1) || "*",
                    (e[i] = e[i] || []).unshift(n)) : (e[i] = e[i] || []).push(n)
        }
    }
    function te(e, t, n, i) {
        function r(a) {
            var l;
            return o[a] = !0,
            xe.each(e[a] || [], function(e, a) {
                var u = a(t, n, i);
                return "string" != typeof u || s || o[u] ? s ? !(l = u) : void 0 : (t.dataTypes.unshift(u),
                r(u),
                !1)
            }),
            l
        }
        var o = {}
          , s = e === Wt;
        return r(t.dataTypes[0]) || !o["*"] && r("*")
    }
    function ne(e, t) {
        var n, i, r = xe.ajaxSettings.flatOptions || {};
        for (n in t)
            void 0 !== t[n] && ((r[n] ? e : i || (i = {}))[n] = t[n]);
        return i && xe.extend(!0, e, i),
        e
    }
    function ie(e, t, n) {
        for (var i, r, o, s, a = e.contents, l = e.dataTypes; "*" === l[0]; )
            l.shift(),
            void 0 === i && (i = e.mimeType || t.getResponseHeader("Content-Type"));
        if (i)
            for (r in a)
                if (a[r] && a[r].test(i)) {
                    l.unshift(r);
                    break
                }
        if (l[0]in n)
            o = l[0];
        else {
            for (r in n) {
                if (!l[0] || e.converters[r + " " + l[0]]) {
                    o = r;
                    break
                }
                s || (s = r)
            }
            o = o || s
        }
        if (o)
            return o !== l[0] && l.unshift(o),
            n[o]
    }
    function re(e, t, n, i) {
        var r, o, s, a, l, u = {}, c = e.dataTypes.slice();
        if (c[1])
            for (s in e.converters)
                u[s.toLowerCase()] = e.converters[s];
        for (o = c.shift(); o; )
            if (e.responseFields[o] && (n[e.responseFields[o]] = t),
            !l && i && e.dataFilter && (t = e.dataFilter(t, e.dataType)),
            l = o,
            o = c.shift())
                if ("*" === o)
                    o = l;
                else if ("*" !== l && l !== o) {
                    if (!(s = u[l + " " + o] || u["* " + o]))
                        for (r in u)
                            if ((a = r.split(" "))[1] === o && (s = u[l + " " + a[0]] || u["* " + a[0]])) {
                                !0 === s ? s = u[r] : !0 !== u[r] && (o = a[0],
                                c.unshift(a[1]));
                                break
                            }
                    if (!0 !== s)
                        if (s && e.throws)
                            t = s(t);
                        else
                            try {
                                t = s(t)
                            } catch (e) {
                                return {
                                    state: "parsererror",
                                    error: s ? e : "No conversion from " + l + " to " + o
                                }
                            }
                }
        return {
            state: "success",
            data: t
        }
    }
    var oe = []
      , se = e.document
      , ae = Object.getPrototypeOf
      , le = oe.slice
      , ue = oe.concat
      , ce = oe.push
      , de = oe.indexOf
      , fe = {}
      , he = fe.toString
      , pe = fe.hasOwnProperty
      , me = pe.toString
      , ge = me.call(Object)
      , ve = {}
      , ye = function(e) {
        return "function" == typeof e && "number" != typeof e.nodeType
    }
      , be = function(e) {
        return null != e && e === e.window
    }
      , we = {
        type: !0,
        src: !0,
        noModule: !0
    }
      , xe = function(e, t) {
        return new xe.fn.init(e,t)
    }
      , _e = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
    xe.fn = xe.prototype = {
        jquery: "3.3.1",
        constructor: xe,
        length: 0,
        toArray: function() {
            return le.call(this)
        },
        get: function(e) {
            return null == e ? le.call(this) : e < 0 ? this[e + this.length] : this[e]
        },
        pushStack: function(e) {
            var t = xe.merge(this.constructor(), e);
            return t.prevObject = this,
            t
        },
        each: function(e) {
            return xe.each(this, e)
        },
        map: function(e) {
            return this.pushStack(xe.map(this, function(t, n) {
                return e.call(t, n, t)
            }))
        },
        slice: function() {
            return this.pushStack(le.apply(this, arguments))
        },
        first: function() {
            return this.eq(0)
        },
        last: function() {
            return this.eq(-1)
        },
        eq: function(e) {
            var t = this.length
              , n = +e + (e < 0 ? t : 0);
            return this.pushStack(n >= 0 && n < t ? [this[n]] : [])
        },
        end: function() {
            return this.prevObject || this.constructor()
        },
        push: ce,
        sort: oe.sort,
        splice: oe.splice
    },
    xe.extend = xe.fn.extend = function() {
        var e, t, n, i, r, o, s = arguments[0] || {}, a = 1, l = arguments.length, u = !1;
        for ("boolean" == typeof s && (u = s,
        s = arguments[a] || {},
        a++),
        "object" == typeof s || ye(s) || (s = {}),
        a === l && (s = this,
        a--); a < l; a++)
            if (null != (e = arguments[a]))
                for (t in e)
                    n = s[t],
                    s !== (i = e[t]) && (u && i && (xe.isPlainObject(i) || (r = Array.isArray(i))) ? (r ? (r = !1,
                    o = n && Array.isArray(n) ? n : []) : o = n && xe.isPlainObject(n) ? n : {},
                    s[t] = xe.extend(u, o, i)) : void 0 !== i && (s[t] = i));
        return s
    }
    ,
    xe.extend({
        expando: "jQuery" + ("3.3.1" + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function(e) {
            throw new Error(e)
        },
        noop: function() {},
        isPlainObject: function(e) {
            var t, n;
            return !(!e || "[object Object]" !== he.call(e) || (t = ae(e)) && ("function" != typeof (n = pe.call(t, "constructor") && t.constructor) || me.call(n) !== ge))
        },
        isEmptyObject: function(e) {
            var t;
            for (t in e)
                return !1;
            return !0
        },
        globalEval: function(e) {
            n(e)
        },
        each: function(e, t) {
            var n, i = 0;
            if (r(e))
                for (n = e.length; i < n && !1 !== t.call(e[i], i, e[i]); i++)
                    ;
            else
                for (i in e)
                    if (!1 === t.call(e[i], i, e[i]))
                        break;
            return e
        },
        trim: function(e) {
            return null == e ? "" : (e + "").replace(_e, "")
        },
        makeArray: function(e, t) {
            var n = t || [];
            return null != e && (r(Object(e)) ? xe.merge(n, "string" == typeof e ? [e] : e) : ce.call(n, e)),
            n
        },
        inArray: function(e, t, n) {
            return null == t ? -1 : de.call(t, e, n)
        },
        merge: function(e, t) {
            for (var n = +t.length, i = 0, r = e.length; i < n; i++)
                e[r++] = t[i];
            return e.length = r,
            e
        },
        grep: function(e, t, n) {
            for (var i, r = [], o = 0, s = e.length, a = !n; o < s; o++)
                (i = !t(e[o], o)) !== a && r.push(e[o]);
            return r
        },
        map: function(e, t, n) {
            var i, o, s = 0, a = [];
            if (r(e))
                for (i = e.length; s < i; s++)
                    null != (o = t(e[s], s, n)) && a.push(o);
            else
                for (s in e)
                    null != (o = t(e[s], s, n)) && a.push(o);
            return ue.apply([], a)
        },
        guid: 1,
        support: ve
    }),
    "function" == typeof Symbol && (xe.fn[Symbol.iterator] = oe[Symbol.iterator]),
    xe.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(e, t) {
        fe["[object " + t + "]"] = t.toLowerCase()
    });
    var Ce = function(e) {
        function t(e, t, n, i) {
            var r, o, s, a, l, u, c, f = t && t.ownerDocument, p = t ? t.nodeType : 9;
            if (n = n || [],
            "string" != typeof e || !e || 1 !== p && 9 !== p && 11 !== p)
                return n;
            if (!i && ((t ? t.ownerDocument || t : H) !== P && z(t),
            t = t || P,
            j)) {
                if (11 !== p && (l = ve.exec(e)))
                    if (r = l[1]) {
                        if (9 === p) {
                            if (!(s = t.getElementById(r)))
                                return n;
                            if (s.id === r)
                                return n.push(s),
                                n
                        } else if (f && (s = f.getElementById(r)) && q(t, s) && s.id === r)
                            return n.push(s),
                            n
                    } else {
                        if (l[2])
                            return Z.apply(n, t.getElementsByTagName(e)),
                            n;
                        if ((r = l[3]) && _.getElementsByClassName && t.getElementsByClassName)
                            return Z.apply(n, t.getElementsByClassName(r)),
                            n
                    }
                if (_.qsa && !V[e + " "] && (!M || !M.test(e))) {
                    if (1 !== p)
                        f = t,
                        c = e;
                    else if ("object" !== t.nodeName.toLowerCase()) {
                        for ((a = t.getAttribute("id")) ? a = a.replace(xe, _e) : t.setAttribute("id", a = B),
                        o = (u = T(e)).length; o--; )
                            u[o] = "#" + a + " " + h(u[o]);
                        c = u.join(","),
                        f = ye.test(e) && d(t.parentNode) || t
                    }
                    if (c)
                        try {
                            return Z.apply(n, f.querySelectorAll(c)),
                            n
                        } catch (e) {} finally {
                            a === B && t.removeAttribute("id")
                        }
                }
            }
            return A(e.replace(ae, "$1"), t, n, i)
        }
        function n() {
            function e(n, i) {
                return t.push(n + " ") > C.cacheLength && delete e[t.shift()],
                e[n + " "] = i
            }
            var t = [];
            return e
        }
        function i(e) {
            return e[B] = !0,
            e
        }
        function r(e) {
            var t = P.createElement("fieldset");
            try {
                return !!e(t)
            } catch (e) {
                return !1
            } finally {
                t.parentNode && t.parentNode.removeChild(t),
                t = null
            }
        }
        function o(e, t) {
            for (var n = e.split("|"), i = n.length; i--; )
                C.attrHandle[n[i]] = t
        }
        function s(e, t) {
            var n = t && e
              , i = n && 1 === e.nodeType && 1 === t.nodeType && e.sourceIndex - t.sourceIndex;
            if (i)
                return i;
            if (n)
                for (; n = n.nextSibling; )
                    if (n === t)
                        return -1;
            return e ? 1 : -1
        }
        function a(e) {
            return function(t) {
                return "input" === t.nodeName.toLowerCase() && t.type === e
            }
        }
        function l(e) {
            return function(t) {
                var n = t.nodeName.toLowerCase();
                return ("input" === n || "button" === n) && t.type === e
            }
        }
        function u(e) {
            return function(t) {
                return "form"in t ? t.parentNode && !1 === t.disabled ? "label"in t ? "label"in t.parentNode ? t.parentNode.disabled === e : t.disabled === e : t.isDisabled === e || t.isDisabled !== !e && Ee(t) === e : t.disabled === e : "label"in t && t.disabled === e
            }
        }
        function c(e) {
            return i(function(t) {
                return t = +t,
                i(function(n, i) {
                    for (var r, o = e([], n.length, t), s = o.length; s--; )
                        n[r = o[s]] && (n[r] = !(i[r] = n[r]))
                })
            })
        }
        function d(e) {
            return e && "undefined" != typeof e.getElementsByTagName && e
        }
        function f() {}
        function h(e) {
            for (var t = 0, n = e.length, i = ""; t < n; t++)
                i += e[t].value;
            return i
        }
        function p(e, t, n) {
            var i = t.dir
              , r = t.next
              , o = r || i
              , s = n && "parentNode" === o
              , a = W++;
            return t.first ? function(t, n, r) {
                for (; t = t[i]; )
                    if (1 === t.nodeType || s)
                        return e(t, n, r);
                return !1
            }
            : function(t, n, l) {
                var u, c, d, f = [R, a];
                if (l) {
                    for (; t = t[i]; )
                        if ((1 === t.nodeType || s) && e(t, n, l))
                            return !0
                } else
                    for (; t = t[i]; )
                        if (1 === t.nodeType || s)
                            if (d = t[B] || (t[B] = {}),
                            c = d[t.uniqueID] || (d[t.uniqueID] = {}),
                            r && r === t.nodeName.toLowerCase())
                                t = t[i] || t;
                            else {
                                if ((u = c[o]) && u[0] === R && u[1] === a)
                                    return f[2] = u[2];
                                if (c[o] = f,
                                f[2] = e(t, n, l))
                                    return !0
                            }
                return !1
            }
        }
        function m(e) {
            return e.length > 1 ? function(t, n, i) {
                for (var r = e.length; r--; )
                    if (!e[r](t, n, i))
                        return !1;
                return !0
            }
            : e[0]
        }
        function g(e, n, i) {
            for (var r = 0, o = n.length; r < o; r++)
                t(e, n[r], i);
            return i
        }
        function v(e, t, n, i, r) {
            for (var o, s = [], a = 0, l = e.length, u = null != t; a < l; a++)
                (o = e[a]) && (n && !n(o, i, r) || (s.push(o),
                u && t.push(a)));
            return s
        }
        function y(e, t, n, r, o, s) {
            return r && !r[B] && (r = y(r)),
            o && !o[B] && (o = y(o, s)),
            i(function(i, s, a, l) {
                var u, c, d, f = [], h = [], p = s.length, m = i || g(t || "*", a.nodeType ? [a] : a, []), y = !e || !i && t ? m : v(m, f, e, a, l), b = n ? o || (i ? e : p || r) ? [] : s : y;
                if (n && n(y, b, a, l),
                r)
                    for (u = v(b, h),
                    r(u, [], a, l),
                    c = u.length; c--; )
                        (d = u[c]) && (b[h[c]] = !(y[h[c]] = d));
                if (i) {
                    if (o || e) {
                        if (o) {
                            for (u = [],
                            c = b.length; c--; )
                                (d = b[c]) && u.push(y[c] = d);
                            o(null, b = [], u, l)
                        }
                        for (c = b.length; c--; )
                            (d = b[c]) && (u = o ? ee(i, d) : f[c]) > -1 && (i[u] = !(s[u] = d))
                    }
                } else
                    b = v(b === s ? b.splice(p, b.length) : b),
                    o ? o(null, s, b, l) : Z.apply(s, b)
            })
        }
        function b(e) {
            for (var t, n, i, r = e.length, o = C.relative[e[0].type], s = o || C.relative[" "], a = o ? 1 : 0, l = p(function(e) {
                return e === t
            }, s, !0), u = p(function(e) {
                return ee(t, e) > -1
            }, s, !0), c = [function(e, n, i) {
                var r = !o && (i || n !== I) || ((t = n).nodeType ? l(e, n, i) : u(e, n, i));
                return t = null,
                r
            }
            ]; a < r; a++)
                if (n = C.relative[e[a].type])
                    c = [p(m(c), n)];
                else {
                    if ((n = C.filter[e[a].type].apply(null, e[a].matches))[B]) {
                        for (i = ++a; i < r && !C.relative[e[i].type]; i++)
                            ;
                        return y(a > 1 && m(c), a > 1 && h(e.slice(0, a - 1).concat({
                            value: " " === e[a - 2].type ? "*" : ""
                        })).replace(ae, "$1"), n, a < i && b(e.slice(a, i)), i < r && b(e = e.slice(i)), i < r && h(e))
                    }
                    c.push(n)
                }
            return m(c)
        }
        function w(e, n) {
            var r = n.length > 0
              , o = e.length > 0
              , s = function(i, s, a, l, u) {
                var c, d, f, h = 0, p = "0", m = i && [], g = [], y = I, b = i || o && C.find.TAG("*", u), w = R += null == y ? 1 : Math.random() || .1, x = b.length;
                for (u && (I = s === P || s || u); p !== x && null != (c = b[p]); p++) {
                    if (o && c) {
                        for (d = 0,
                        s || c.ownerDocument === P || (z(c),
                        a = !j); f = e[d++]; )
                            if (f(c, s || P, a)) {
                                l.push(c);
                                break
                            }
                        u && (R = w)
                    }
                    r && ((c = !f && c) && h--,
                    i && m.push(c))
                }
                if (h += p,
                r && p !== h) {
                    for (d = 0; f = n[d++]; )
                        f(m, g, s, a);
                    if (i) {
                        if (h > 0)
                            for (; p--; )
                                m[p] || g[p] || (g[p] = G.call(l));
                        g = v(g)
                    }
                    Z.apply(l, g),
                    u && !i && g.length > 0 && h + n.length > 1 && t.uniqueSort(l)
                }
                return u && (R = w,
                I = y),
                m
            };
            return r ? i(s) : s
        }
        var x, _, C, E, S, T, k, A, I, D, L, z, P, N, j, M, O, F, q, B = "sizzle" + 1 * new Date, H = e.document, R = 0, W = 0, U = n(), $ = n(), V = n(), Q = function(e, t) {
            return e === t && (L = !0),
            0
        }, Y = {}.hasOwnProperty, X = [], G = X.pop, J = X.push, Z = X.push, K = X.slice, ee = function(e, t) {
            for (var n = 0, i = e.length; n < i; n++)
                if (e[n] === t)
                    return n;
            return -1
        }, te = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", ne = "[\\x20\\t\\r\\n\\f]", ie = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+", re = "\\[" + ne + "*(" + ie + ")(?:" + ne + "*([*^$|!~]?=)" + ne + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + ie + "))|)" + ne + "*\\]", oe = ":(" + ie + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + re + ")*)|.*)\\)|)", se = new RegExp(ne + "+","g"), ae = new RegExp("^" + ne + "+|((?:^|[^\\\\])(?:\\\\.)*)" + ne + "+$","g"), le = new RegExp("^" + ne + "*," + ne + "*"), ue = new RegExp("^" + ne + "*([>+~]|" + ne + ")" + ne + "*"), ce = new RegExp("=" + ne + "*([^\\]'\"]*?)" + ne + "*\\]","g"), de = new RegExp(oe), fe = new RegExp("^" + ie + "$"), he = {
            ID: new RegExp("^#(" + ie + ")"),
            CLASS: new RegExp("^\\.(" + ie + ")"),
            TAG: new RegExp("^(" + ie + "|[*])"),
            ATTR: new RegExp("^" + re),
            PSEUDO: new RegExp("^" + oe),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + ne + "*(even|odd|(([+-]|)(\\d*)n|)" + ne + "*(?:([+-]|)" + ne + "*(\\d+)|))" + ne + "*\\)|)","i"),
            bool: new RegExp("^(?:" + te + ")$","i"),
            needsContext: new RegExp("^" + ne + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + ne + "*((?:-\\d)?\\d*)" + ne + "*\\)|)(?=[^-]|$)","i")
        }, pe = /^(?:input|select|textarea|button)$/i, me = /^h\d$/i, ge = /^[^{]+\{\s*\[native \w/, ve = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, ye = /[+~]/, be = new RegExp("\\\\([\\da-f]{1,6}" + ne + "?|(" + ne + ")|.)","ig"), we = function(e, t, n) {
            var i = "0x" + t - 65536;
            return i !== i || n ? t : i < 0 ? String.fromCharCode(i + 65536) : String.fromCharCode(i >> 10 | 55296, 1023 & i | 56320)
        }, xe = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g, _e = function(e, t) {
            return t ? "\0" === e ? "�" : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " " : "\\" + e
        }, Ce = function() {
            z()
        }, Ee = p(function(e) {
            return !0 === e.disabled && ("form"in e || "label"in e)
        }, {
            dir: "parentNode",
            next: "legend"
        });
        try {
            Z.apply(X = K.call(H.childNodes), H.childNodes),
            X[H.childNodes.length].nodeType
        } catch (e) {
            Z = {
                apply: X.length ? function(e, t) {
                    J.apply(e, K.call(t))
                }
                : function(e, t) {
                    for (var n = e.length, i = 0; e[n++] = t[i++]; )
                        ;
                    e.length = n - 1
                }
            }
        }
        _ = t.support = {},
        S = t.isXML = function(e) {
            var t = e && (e.ownerDocument || e).documentElement;
            return !!t && "HTML" !== t.nodeName
        }
        ,
        z = t.setDocument = function(e) {
            var t, n, i = e ? e.ownerDocument || e : H;
            return i !== P && 9 === i.nodeType && i.documentElement ? (P = i,
            N = P.documentElement,
            j = !S(P),
            H !== P && (n = P.defaultView) && n.top !== n && (n.addEventListener ? n.addEventListener("unload", Ce, !1) : n.attachEvent && n.attachEvent("onunload", Ce)),
            _.attributes = r(function(e) {
                return e.className = "i",
                !e.getAttribute("className")
            }),
            _.getElementsByTagName = r(function(e) {
                return e.appendChild(P.createComment("")),
                !e.getElementsByTagName("*").length
            }),
            _.getElementsByClassName = ge.test(P.getElementsByClassName),
            _.getById = r(function(e) {
                return N.appendChild(e).id = B,
                !P.getElementsByName || !P.getElementsByName(B).length
            }),
            _.getById ? (C.filter.ID = function(e) {
                var t = e.replace(be, we);
                return function(e) {
                    return e.getAttribute("id") === t
                }
            }
            ,
            C.find.ID = function(e, t) {
                if ("undefined" != typeof t.getElementById && j) {
                    var n = t.getElementById(e);
                    return n ? [n] : []
                }
            }
            ) : (C.filter.ID = function(e) {
                var t = e.replace(be, we);
                return function(e) {
                    var n = "undefined" != typeof e.getAttributeNode && e.getAttributeNode("id");
                    return n && n.value === t
                }
            }
            ,
            C.find.ID = function(e, t) {
                if ("undefined" != typeof t.getElementById && j) {
                    var n, i, r, o = t.getElementById(e);
                    if (o) {
                        if ((n = o.getAttributeNode("id")) && n.value === e)
                            return [o];
                        for (r = t.getElementsByName(e),
                        i = 0; o = r[i++]; )
                            if ((n = o.getAttributeNode("id")) && n.value === e)
                                return [o]
                    }
                    return []
                }
            }
            ),
            C.find.TAG = _.getElementsByTagName ? function(e, t) {
                return "undefined" != typeof t.getElementsByTagName ? t.getElementsByTagName(e) : _.qsa ? t.querySelectorAll(e) : void 0
            }
            : function(e, t) {
                var n, i = [], r = 0, o = t.getElementsByTagName(e);
                if ("*" === e) {
                    for (; n = o[r++]; )
                        1 === n.nodeType && i.push(n);
                    return i
                }
                return o
            }
            ,
            C.find.CLASS = _.getElementsByClassName && function(e, t) {
                if ("undefined" != typeof t.getElementsByClassName && j)
                    return t.getElementsByClassName(e)
            }
            ,
            O = [],
            M = [],
            (_.qsa = ge.test(P.querySelectorAll)) && (r(function(e) {
                N.appendChild(e).innerHTML = "<a id='" + B + "'></a><select id='" + B + "-\r\\' msallowcapture=''><option selected=''></option></select>",
                e.querySelectorAll("[msallowcapture^='']").length && M.push("[*^$]=" + ne + "*(?:''|\"\")"),
                e.querySelectorAll("[selected]").length || M.push("\\[" + ne + "*(?:value|" + te + ")"),
                e.querySelectorAll("[id~=" + B + "-]").length || M.push("~="),
                e.querySelectorAll(":checked").length || M.push(":checked"),
                e.querySelectorAll("a#" + B + "+*").length || M.push(".#.+[+~]")
            }),
            r(function(e) {
                e.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                var t = P.createElement("input");
                t.setAttribute("type", "hidden"),
                e.appendChild(t).setAttribute("name", "D"),
                e.querySelectorAll("[name=d]").length && M.push("name" + ne + "*[*^$|!~]?="),
                2 !== e.querySelectorAll(":enabled").length && M.push(":enabled", ":disabled"),
                N.appendChild(e).disabled = !0,
                2 !== e.querySelectorAll(":disabled").length && M.push(":enabled", ":disabled"),
                e.querySelectorAll("*,:x"),
                M.push(",.*:")
            })),
            (_.matchesSelector = ge.test(F = N.matches || N.webkitMatchesSelector || N.mozMatchesSelector || N.oMatchesSelector || N.msMatchesSelector)) && r(function(e) {
                _.disconnectedMatch = F.call(e, "*"),
                F.call(e, "[s!='']:x"),
                O.push("!=", oe)
            }),
            M = M.length && new RegExp(M.join("|")),
            O = O.length && new RegExp(O.join("|")),
            t = ge.test(N.compareDocumentPosition),
            q = t || ge.test(N.contains) ? function(e, t) {
                var n = 9 === e.nodeType ? e.documentElement : e
                  , i = t && t.parentNode;
                return e === i || !(!i || 1 !== i.nodeType || !(n.contains ? n.contains(i) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(i)))
            }
            : function(e, t) {
                if (t)
                    for (; t = t.parentNode; )
                        if (t === e)
                            return !0;
                return !1
            }
            ,
            Q = t ? function(e, t) {
                if (e === t)
                    return L = !0,
                    0;
                var n = !e.compareDocumentPosition - !t.compareDocumentPosition;
                return n || (1 & (n = (e.ownerDocument || e) === (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || !_.sortDetached && t.compareDocumentPosition(e) === n ? e === P || e.ownerDocument === H && q(H, e) ? -1 : t === P || t.ownerDocument === H && q(H, t) ? 1 : D ? ee(D, e) - ee(D, t) : 0 : 4 & n ? -1 : 1)
            }
            : function(e, t) {
                if (e === t)
                    return L = !0,
                    0;
                var n, i = 0, r = e.parentNode, o = t.parentNode, a = [e], l = [t];
                if (!r || !o)
                    return e === P ? -1 : t === P ? 1 : r ? -1 : o ? 1 : D ? ee(D, e) - ee(D, t) : 0;
                if (r === o)
                    return s(e, t);
                for (n = e; n = n.parentNode; )
                    a.unshift(n);
                for (n = t; n = n.parentNode; )
                    l.unshift(n);
                for (; a[i] === l[i]; )
                    i++;
                return i ? s(a[i], l[i]) : a[i] === H ? -1 : l[i] === H ? 1 : 0
            }
            ,
            P) : P
        }
        ,
        t.matches = function(e, n) {
            return t(e, null, null, n)
        }
        ,
        t.matchesSelector = function(e, n) {
            if ((e.ownerDocument || e) !== P && z(e),
            n = n.replace(ce, "='$1']"),
            _.matchesSelector && j && !V[n + " "] && (!O || !O.test(n)) && (!M || !M.test(n)))
                try {
                    var i = F.call(e, n);
                    if (i || _.disconnectedMatch || e.document && 11 !== e.document.nodeType)
                        return i
                } catch (e) {}
            return t(n, P, null, [e]).length > 0
        }
        ,
        t.contains = function(e, t) {
            return (e.ownerDocument || e) !== P && z(e),
            q(e, t)
        }
        ,
        t.attr = function(e, t) {
            (e.ownerDocument || e) !== P && z(e);
            var n = C.attrHandle[t.toLowerCase()]
              , i = n && Y.call(C.attrHandle, t.toLowerCase()) ? n(e, t, !j) : void 0;
            return void 0 !== i ? i : _.attributes || !j ? e.getAttribute(t) : (i = e.getAttributeNode(t)) && i.specified ? i.value : null
        }
        ,
        t.escape = function(e) {
            return (e + "").replace(xe, _e)
        }
        ,
        t.error = function(e) {
            throw new Error("Syntax error, unrecognized expression: " + e)
        }
        ,
        t.uniqueSort = function(e) {
            var t, n = [], i = 0, r = 0;
            if (L = !_.detectDuplicates,
            D = !_.sortStable && e.slice(0),
            e.sort(Q),
            L) {
                for (; t = e[r++]; )
                    t === e[r] && (i = n.push(r));
                for (; i--; )
                    e.splice(n[i], 1)
            }
            return D = null,
            e
        }
        ,
        E = t.getText = function(e) {
            var t, n = "", i = 0, r = e.nodeType;
            if (r) {
                if (1 === r || 9 === r || 11 === r) {
                    if ("string" == typeof e.textContent)
                        return e.textContent;
                    for (e = e.firstChild; e; e = e.nextSibling)
                        n += E(e)
                } else if (3 === r || 4 === r)
                    return e.nodeValue
            } else
                for (; t = e[i++]; )
                    n += E(t);
            return n
        }
        ,
        (C = t.selectors = {
            cacheLength: 50,
            createPseudo: i,
            match: he,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: !0
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: !0
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(e) {
                    return e[1] = e[1].replace(be, we),
                    e[3] = (e[3] || e[4] || e[5] || "").replace(be, we),
                    "~=" === e[2] && (e[3] = " " + e[3] + " "),
                    e.slice(0, 4)
                },
                CHILD: function(e) {
                    return e[1] = e[1].toLowerCase(),
                    "nth" === e[1].slice(0, 3) ? (e[3] || t.error(e[0]),
                    e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])),
                    e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && t.error(e[0]),
                    e
                },
                PSEUDO: function(e) {
                    var t, n = !e[6] && e[2];
                    return he.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] || "" : n && de.test(n) && (t = T(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && (e[0] = e[0].slice(0, t),
                    e[2] = n.slice(0, t)),
                    e.slice(0, 3))
                }
            },
            filter: {
                TAG: function(e) {
                    var t = e.replace(be, we).toLowerCase();
                    return "*" === e ? function() {
                        return !0
                    }
                    : function(e) {
                        return e.nodeName && e.nodeName.toLowerCase() === t
                    }
                },
                CLASS: function(e) {
                    var t = U[e + " "];
                    return t || (t = new RegExp("(^|" + ne + ")" + e + "(" + ne + "|$)")) && U(e, function(e) {
                        return t.test("string" == typeof e.className && e.className || "undefined" != typeof e.getAttribute && e.getAttribute("class") || "")
                    })
                },
                ATTR: function(e, n, i) {
                    return function(r) {
                        var o = t.attr(r, e);
                        return null == o ? "!=" === n : !n || (o += "",
                        "=" === n ? o === i : "!=" === n ? o !== i : "^=" === n ? i && 0 === o.indexOf(i) : "*=" === n ? i && o.indexOf(i) > -1 : "$=" === n ? i && o.slice(-i.length) === i : "~=" === n ? (" " + o.replace(se, " ") + " ").indexOf(i) > -1 : "|=" === n && (o === i || o.slice(0, i.length + 1) === i + "-"))
                    }
                },
                CHILD: function(e, t, n, i, r) {
                    var o = "nth" !== e.slice(0, 3)
                      , s = "last" !== e.slice(-4)
                      , a = "of-type" === t;
                    return 1 === i && 0 === r ? function(e) {
                        return !!e.parentNode
                    }
                    : function(t, n, l) {
                        var u, c, d, f, h, p, m = o !== s ? "nextSibling" : "previousSibling", g = t.parentNode, v = a && t.nodeName.toLowerCase(), y = !l && !a, b = !1;
                        if (g) {
                            if (o) {
                                for (; m; ) {
                                    for (f = t; f = f[m]; )
                                        if (a ? f.nodeName.toLowerCase() === v : 1 === f.nodeType)
                                            return !1;
                                    p = m = "only" === e && !p && "nextSibling"
                                }
                                return !0
                            }
                            if (p = [s ? g.firstChild : g.lastChild],
                            s && y) {
                                for (b = (h = (u = (c = (d = (f = g)[B] || (f[B] = {}))[f.uniqueID] || (d[f.uniqueID] = {}))[e] || [])[0] === R && u[1]) && u[2],
                                f = h && g.childNodes[h]; f = ++h && f && f[m] || (b = h = 0) || p.pop(); )
                                    if (1 === f.nodeType && ++b && f === t) {
                                        c[e] = [R, h, b];
                                        break
                                    }
                            } else if (y && (b = h = (u = (c = (d = (f = t)[B] || (f[B] = {}))[f.uniqueID] || (d[f.uniqueID] = {}))[e] || [])[0] === R && u[1]),
                            !1 === b)
                                for (; (f = ++h && f && f[m] || (b = h = 0) || p.pop()) && ((a ? f.nodeName.toLowerCase() !== v : 1 !== f.nodeType) || !++b || (y && ((c = (d = f[B] || (f[B] = {}))[f.uniqueID] || (d[f.uniqueID] = {}))[e] = [R, b]),
                                f !== t)); )
                                    ;
                            return (b -= r) === i || b % i == 0 && b / i >= 0
                        }
                    }
                },
                PSEUDO: function(e, n) {
                    var r, o = C.pseudos[e] || C.setFilters[e.toLowerCase()] || t.error("unsupported pseudo: " + e);
                    return o[B] ? o(n) : o.length > 1 ? (r = [e, e, "", n],
                    C.setFilters.hasOwnProperty(e.toLowerCase()) ? i(function(e, t) {
                        for (var i, r = o(e, n), s = r.length; s--; )
                            e[i = ee(e, r[s])] = !(t[i] = r[s])
                    }) : function(e) {
                        return o(e, 0, r)
                    }
                    ) : o
                }
            },
            pseudos: {
                not: i(function(e) {
                    var t = []
                      , n = []
                      , r = k(e.replace(ae, "$1"));
                    return r[B] ? i(function(e, t, n, i) {
                        for (var o, s = r(e, null, i, []), a = e.length; a--; )
                            (o = s[a]) && (e[a] = !(t[a] = o))
                    }) : function(e, i, o) {
                        return t[0] = e,
                        r(t, null, o, n),
                        t[0] = null,
                        !n.pop()
                    }
                }),
                has: i(function(e) {
                    return function(n) {
                        return t(e, n).length > 0
                    }
                }),
                contains: i(function(e) {
                    return e = e.replace(be, we),
                    function(t) {
                        return (t.textContent || t.innerText || E(t)).indexOf(e) > -1
                    }
                }),
                lang: i(function(e) {
                    return fe.test(e || "") || t.error("unsupported lang: " + e),
                    e = e.replace(be, we).toLowerCase(),
                    function(t) {
                        var n;
                        do
                            if (n = j ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang"))
                                return (n = n.toLowerCase()) === e || 0 === n.indexOf(e + "-");
                        while ((t = t.parentNode) && 1 === t.nodeType);return !1
                    }
                }),
                target: function(t) {
                    var n = e.location && e.location.hash;
                    return n && n.slice(1) === t.id
                },
                root: function(e) {
                    return e === N
                },
                focus: function(e) {
                    return e === P.activeElement && (!P.hasFocus || P.hasFocus()) && !!(e.type || e.href || ~e.tabIndex);
                },
                enabled: u(!1),
                disabled: u(!0),
                checked: function(e) {
                    var t = e.nodeName.toLowerCase();
                    return "input" === t && !!e.checked || "option" === t && !!e.selected
                },
                selected: function(e) {
                    return e.parentNode && e.parentNode.selectedIndex,
                    !0 === e.selected
                },
                empty: function(e) {
                    for (e = e.firstChild; e; e = e.nextSibling)
                        if (e.nodeType < 6)
                            return !1;
                    return !0
                },
                parent: function(e) {
                    return !C.pseudos.empty(e)
                },
                header: function(e) {
                    return me.test(e.nodeName)
                },
                input: function(e) {
                    return pe.test(e.nodeName)
                },
                button: function(e) {
                    var t = e.nodeName.toLowerCase();
                    return "input" === t && "button" === e.type || "button" === t
                },
                text: function(e) {
                    var t;
                    return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase())
                },
                first: c(function() {
                    return [0]
                }),
                last: c(function(e, t) {
                    return [t - 1]
                }),
                eq: c(function(e, t, n) {
                    return [n < 0 ? n + t : n]
                }),
                even: c(function(e, t) {
                    for (var n = 0; n < t; n += 2)
                        e.push(n);
                    return e
                }),
                odd: c(function(e, t) {
                    for (var n = 1; n < t; n += 2)
                        e.push(n);
                    return e
                }),
                lt: c(function(e, t, n) {
                    for (var i = n < 0 ? n + t : n; --i >= 0; )
                        e.push(i);
                    return e
                }),
                gt: c(function(e, t, n) {
                    for (var i = n < 0 ? n + t : n; ++i < t; )
                        e.push(i);
                    return e
                })
            }
        }).pseudos.nth = C.pseudos.eq;
        for (x in {
            radio: !0,
            checkbox: !0,
            file: !0,
            password: !0,
            image: !0
        })
            C.pseudos[x] = a(x);
        for (x in {
            submit: !0,
            reset: !0
        })
            C.pseudos[x] = l(x);
        return f.prototype = C.filters = C.pseudos,
        C.setFilters = new f,
        T = t.tokenize = function(e, n) {
            var i, r, o, s, a, l, u, c = $[e + " "];
            if (c)
                return n ? 0 : c.slice(0);
            for (a = e,
            l = [],
            u = C.preFilter; a; ) {
                i && !(r = le.exec(a)) || (r && (a = a.slice(r[0].length) || a),
                l.push(o = [])),
                i = !1,
                (r = ue.exec(a)) && (i = r.shift(),
                o.push({
                    value: i,
                    type: r[0].replace(ae, " ")
                }),
                a = a.slice(i.length));
                for (s in C.filter)
                    !(r = he[s].exec(a)) || u[s] && !(r = u[s](r)) || (i = r.shift(),
                    o.push({
                        value: i,
                        type: s,
                        matches: r
                    }),
                    a = a.slice(i.length));
                if (!i)
                    break
            }
            return n ? a.length : a ? t.error(e) : $(e, l).slice(0)
        }
        ,
        k = t.compile = function(e, t) {
            var n, i = [], r = [], o = V[e + " "];
            if (!o) {
                for (t || (t = T(e)),
                n = t.length; n--; )
                    (o = b(t[n]))[B] ? i.push(o) : r.push(o);
                (o = V(e, w(r, i))).selector = e
            }
            return o
        }
        ,
        A = t.select = function(e, t, n, i) {
            var r, o, s, a, l, u = "function" == typeof e && e, c = !i && T(e = u.selector || e);
            if (n = n || [],
            1 === c.length) {
                if ((o = c[0] = c[0].slice(0)).length > 2 && "ID" === (s = o[0]).type && 9 === t.nodeType && j && C.relative[o[1].type]) {
                    if (!(t = (C.find.ID(s.matches[0].replace(be, we), t) || [])[0]))
                        return n;
                    u && (t = t.parentNode),
                    e = e.slice(o.shift().value.length)
                }
                for (r = he.needsContext.test(e) ? 0 : o.length; r-- && (s = o[r],
                !C.relative[a = s.type]); )
                    if ((l = C.find[a]) && (i = l(s.matches[0].replace(be, we), ye.test(o[0].type) && d(t.parentNode) || t))) {
                        if (o.splice(r, 1),
                        !(e = i.length && h(o)))
                            return Z.apply(n, i),
                            n;
                        break
                    }
            }
            return (u || k(e, c))(i, t, !j, n, !t || ye.test(e) && d(t.parentNode) || t),
            n
        }
        ,
        _.sortStable = B.split("").sort(Q).join("") === B,
        _.detectDuplicates = !!L,
        z(),
        _.sortDetached = r(function(e) {
            return 1 & e.compareDocumentPosition(P.createElement("fieldset"))
        }),
        r(function(e) {
            return e.innerHTML = "<a href='#'></a>",
            "#" === e.firstChild.getAttribute("href")
        }) || o("type|href|height|width", function(e, t, n) {
            if (!n)
                return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2)
        }),
        _.attributes && r(function(e) {
            return e.innerHTML = "<input/>",
            e.firstChild.setAttribute("value", ""),
            "" === e.firstChild.getAttribute("value")
        }) || o("value", function(e, t, n) {
            if (!n && "input" === e.nodeName.toLowerCase())
                return e.defaultValue
        }),
        r(function(e) {
            return null == e.getAttribute("disabled")
        }) || o(te, function(e, t, n) {
            var i;
            if (!n)
                return !0 === e[t] ? t.toLowerCase() : (i = e.getAttributeNode(t)) && i.specified ? i.value : null
        }),
        t
    }(e);
    xe.find = Ce,
    xe.expr = Ce.selectors,
    xe.expr[":"] = xe.expr.pseudos,
    xe.uniqueSort = xe.unique = Ce.uniqueSort,
    xe.text = Ce.getText,
    xe.isXMLDoc = Ce.isXML,
    xe.contains = Ce.contains,
    xe.escapeSelector = Ce.escape;
    var Ee = function(e, t, n) {
        for (var i = [], r = void 0 !== n; (e = e[t]) && 9 !== e.nodeType; )
            if (1 === e.nodeType) {
                if (r && xe(e).is(n))
                    break;
                i.push(e)
            }
        return i
    }
      , Se = function(e, t) {
        for (var n = []; e; e = e.nextSibling)
            1 === e.nodeType && e !== t && n.push(e);
        return n
    }
      , Te = xe.expr.match.needsContext
      , ke = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    xe.filter = function(e, t, n) {
        var i = t[0];
        return n && (e = ":not(" + e + ")"),
        1 === t.length && 1 === i.nodeType ? xe.find.matchesSelector(i, e) ? [i] : [] : xe.find.matches(e, xe.grep(t, function(e) {
            return 1 === e.nodeType
        }))
    }
    ,
    xe.fn.extend({
        find: function(e) {
            var t, n, i = this.length, r = this;
            if ("string" != typeof e)
                return this.pushStack(xe(e).filter(function() {
                    for (t = 0; t < i; t++)
                        if (xe.contains(r[t], this))
                            return !0
                }));
            for (n = this.pushStack([]),
            t = 0; t < i; t++)
                xe.find(e, r[t], n);
            return i > 1 ? xe.uniqueSort(n) : n
        },
        filter: function(e) {
            return this.pushStack(s(this, e || [], !1))
        },
        not: function(e) {
            return this.pushStack(s(this, e || [], !0))
        },
        is: function(e) {
            return !!s(this, "string" == typeof e && Te.test(e) ? xe(e) : e || [], !1).length
        }
    });
    var Ae, Ie = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
    (xe.fn.init = function(e, t, n) {
        var i, r;
        if (!e)
            return this;
        if (n = n || Ae,
        "string" == typeof e) {
            if (!(i = "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3 ? [null, e, null] : Ie.exec(e)) || !i[1] && t)
                return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
            if (i[1]) {
                if (t = t instanceof xe ? t[0] : t,
                xe.merge(this, xe.parseHTML(i[1], t && t.nodeType ? t.ownerDocument || t : se, !0)),
                ke.test(i[1]) && xe.isPlainObject(t))
                    for (i in t)
                        ye(this[i]) ? this[i](t[i]) : this.attr(i, t[i]);
                return this
            }
            return (r = se.getElementById(i[2])) && (this[0] = r,
            this.length = 1),
            this
        }
        return e.nodeType ? (this[0] = e,
        this.length = 1,
        this) : ye(e) ? void 0 !== n.ready ? n.ready(e) : e(xe) : xe.makeArray(e, this)
    }
    ).prototype = xe.fn,
    Ae = xe(se);
    var De = /^(?:parents|prev(?:Until|All))/
      , Le = {
        children: !0,
        contents: !0,
        next: !0,
        prev: !0
    };
    xe.fn.extend({
        has: function(e) {
            var t = xe(e, this)
              , n = t.length;
            return this.filter(function() {
                for (var e = 0; e < n; e++)
                    if (xe.contains(this, t[e]))
                        return !0
            })
        },
        closest: function(e, t) {
            var n, i = 0, r = this.length, o = [], s = "string" != typeof e && xe(e);
            if (!Te.test(e))
                for (; i < r; i++)
                    for (n = this[i]; n && n !== t; n = n.parentNode)
                        if (n.nodeType < 11 && (s ? s.index(n) > -1 : 1 === n.nodeType && xe.find.matchesSelector(n, e))) {
                            o.push(n);
                            break
                        }
            return this.pushStack(o.length > 1 ? xe.uniqueSort(o) : o)
        },
        index: function(e) {
            return e ? "string" == typeof e ? de.call(xe(e), this[0]) : de.call(this, e.jquery ? e[0] : e) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
        },
        add: function(e, t) {
            return this.pushStack(xe.uniqueSort(xe.merge(this.get(), xe(e, t))))
        },
        addBack: function(e) {
            return this.add(null == e ? this.prevObject : this.prevObject.filter(e))
        }
    }),
    xe.each({
        parent: function(e) {
            var t = e.parentNode;
            return t && 11 !== t.nodeType ? t : null
        },
        parents: function(e) {
            return Ee(e, "parentNode")
        },
        parentsUntil: function(e, t, n) {
            return Ee(e, "parentNode", n)
        },
        next: function(e) {
            return a(e, "nextSibling")
        },
        prev: function(e) {
            return a(e, "previousSibling")
        },
        nextAll: function(e) {
            return Ee(e, "nextSibling")
        },
        prevAll: function(e) {
            return Ee(e, "previousSibling")
        },
        nextUntil: function(e, t, n) {
            return Ee(e, "nextSibling", n)
        },
        prevUntil: function(e, t, n) {
            return Ee(e, "previousSibling", n)
        },
        siblings: function(e) {
            return Se((e.parentNode || {}).firstChild, e)
        },
        children: function(e) {
            return Se(e.firstChild)
        },
        contents: function(e) {
            return o(e, "iframe") ? e.contentDocument : (o(e, "template") && (e = e.content || e),
            xe.merge([], e.childNodes))
        }
    }, function(e, t) {
        xe.fn[e] = function(n, i) {
            var r = xe.map(this, t, n);
            return "Until" !== e.slice(-5) && (i = n),
            i && "string" == typeof i && (r = xe.filter(i, r)),
            this.length > 1 && (Le[e] || xe.uniqueSort(r),
            De.test(e) && r.reverse()),
            this.pushStack(r)
        }
    });
    var ze = /[^\x20\t\r\n\f]+/g;
    xe.Callbacks = function(e) {
        e = "string" == typeof e ? l(e) : xe.extend({}, e);
        var t, n, r, o, s = [], a = [], u = -1, c = function() {
            for (o = o || e.once,
            r = t = !0; a.length; u = -1)
                for (n = a.shift(); ++u < s.length; )
                    !1 === s[u].apply(n[0], n[1]) && e.stopOnFalse && (u = s.length,
                    n = !1);
            e.memory || (n = !1),
            t = !1,
            o && (s = n ? [] : "")
        }, d = {
            add: function() {
                return s && (n && !t && (u = s.length - 1,
                a.push(n)),
                function t(n) {
                    xe.each(n, function(n, r) {
                        ye(r) ? e.unique && d.has(r) || s.push(r) : r && r.length && "string" !== i(r) && t(r)
                    })
                }(arguments),
                n && !t && c()),
                this
            },
            remove: function() {
                return xe.each(arguments, function(e, t) {
                    for (var n; (n = xe.inArray(t, s, n)) > -1; )
                        s.splice(n, 1),
                        n <= u && u--
                }),
                this
            },
            has: function(e) {
                return e ? xe.inArray(e, s) > -1 : s.length > 0
            },
            empty: function() {
                return s && (s = []),
                this
            },
            disable: function() {
                return o = a = [],
                s = n = "",
                this
            },
            disabled: function() {
                return !s
            },
            lock: function() {
                return o = a = [],
                n || t || (s = n = ""),
                this
            },
            locked: function() {
                return !!o
            },
            fireWith: function(e, n) {
                return o || (n = [e, (n = n || []).slice ? n.slice() : n],
                a.push(n),
                t || c()),
                this
            },
            fire: function() {
                return d.fireWith(this, arguments),
                this
            },
            fired: function() {
                return !!r
            }
        };
        return d
    }
    ,
    xe.extend({
        Deferred: function(t) {
            var n = [["notify", "progress", xe.Callbacks("memory"), xe.Callbacks("memory"), 2], ["resolve", "done", xe.Callbacks("once memory"), xe.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", xe.Callbacks("once memory"), xe.Callbacks("once memory"), 1, "rejected"]]
              , i = "pending"
              , r = {
                state: function() {
                    return i
                },
                always: function() {
                    return o.done(arguments).fail(arguments),
                    this
                },
                catch: function(e) {
                    return r.then(null, e)
                },
                pipe: function() {
                    var e = arguments;
                    return xe.Deferred(function(t) {
                        xe.each(n, function(n, i) {
                            var r = ye(e[i[4]]) && e[i[4]];
                            o[i[1]](function() {
                                var e = r && r.apply(this, arguments);
                                e && ye(e.promise) ? e.promise().progress(t.notify).done(t.resolve).fail(t.reject) : t[i[0] + "With"](this, r ? [e] : arguments)
                            })
                        }),
                        e = null
                    }).promise()
                },
                then: function(t, i, r) {
                    function o(t, n, i, r) {
                        return function() {
                            var a = this
                              , l = arguments
                              , d = function() {
                                var e, d;
                                if (!(t < s)) {
                                    if ((e = i.apply(a, l)) === n.promise())
                                        throw new TypeError("Thenable self-resolution");
                                    d = e && ("object" == typeof e || "function" == typeof e) && e.then,
                                    ye(d) ? r ? d.call(e, o(s, n, u, r), o(s, n, c, r)) : (s++,
                                    d.call(e, o(s, n, u, r), o(s, n, c, r), o(s, n, u, n.notifyWith))) : (i !== u && (a = void 0,
                                    l = [e]),
                                    (r || n.resolveWith)(a, l))
                                }
                            }
                              , f = r ? d : function() {
                                try {
                                    d()
                                } catch (e) {
                                    xe.Deferred.exceptionHook && xe.Deferred.exceptionHook(e, f.stackTrace),
                                    t + 1 >= s && (i !== c && (a = void 0,
                                    l = [e]),
                                    n.rejectWith(a, l))
                                }
                            }
                            ;
                            t ? f() : (xe.Deferred.getStackHook && (f.stackTrace = xe.Deferred.getStackHook()),
                            e.setTimeout(f))
                        }
                    }
                    var s = 0;
                    return xe.Deferred(function(e) {
                        n[0][3].add(o(0, e, ye(r) ? r : u, e.notifyWith)),
                        n[1][3].add(o(0, e, ye(t) ? t : u)),
                        n[2][3].add(o(0, e, ye(i) ? i : c))
                    }).promise()
                },
                promise: function(e) {
                    return null != e ? xe.extend(e, r) : r
                }
            }
              , o = {};
            return xe.each(n, function(e, t) {
                var s = t[2]
                  , a = t[5];
                r[t[1]] = s.add,
                a && s.add(function() {
                    i = a
                }, n[3 - e][2].disable, n[3 - e][3].disable, n[0][2].lock, n[0][3].lock),
                s.add(t[3].fire),
                o[t[0]] = function() {
                    return o[t[0] + "With"](this === o ? void 0 : this, arguments),
                    this
                }
                ,
                o[t[0] + "With"] = s.fireWith
            }),
            r.promise(o),
            t && t.call(o, o),
            o
        },
        when: function(e) {
            var t = arguments.length
              , n = t
              , i = Array(n)
              , r = le.call(arguments)
              , o = xe.Deferred()
              , s = function(e) {
                return function(n) {
                    i[e] = this,
                    r[e] = arguments.length > 1 ? le.call(arguments) : n,
                    --t || o.resolveWith(i, r)
                }
            };
            if (t <= 1 && (d(e, o.done(s(n)).resolve, o.reject, !t),
            "pending" === o.state() || ye(r[n] && r[n].then)))
                return o.then();
            for (; n--; )
                d(r[n], s(n), o.reject);
            return o.promise()
        }
    });
    var Pe = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    xe.Deferred.exceptionHook = function(t, n) {
        e.console && e.console.warn && t && Pe.test(t.name) && e.console.warn("jQuery.Deferred exception: " + t.message, t.stack, n)
    }
    ,
    xe.readyException = function(t) {
        e.setTimeout(function() {
            throw t
        })
    }
    ;
    var Ne = xe.Deferred();
    xe.fn.ready = function(e) {
        return Ne.then(e).catch(function(e) {
            xe.readyException(e)
        }),
        this
    }
    ,
    xe.extend({
        isReady: !1,
        readyWait: 1,
        ready: function(e) {
            (!0 === e ? --xe.readyWait : xe.isReady) || (xe.isReady = !0,
            !0 !== e && --xe.readyWait > 0 || Ne.resolveWith(se, [xe]))
        }
    }),
    xe.ready.then = Ne.then,
    "complete" === se.readyState || "loading" !== se.readyState && !se.documentElement.doScroll ? e.setTimeout(xe.ready) : (se.addEventListener("DOMContentLoaded", f),
    e.addEventListener("load", f));
    var je = function(e, t, n, r, o, s, a) {
        var l = 0
          , u = e.length
          , c = null == n;
        if ("object" === i(n)) {
            o = !0;
            for (l in n)
                je(e, t, l, n[l], !0, s, a)
        } else if (void 0 !== r && (o = !0,
        ye(r) || (a = !0),
        c && (a ? (t.call(e, r),
        t = null) : (c = t,
        t = function(e, t, n) {
            return c.call(xe(e), n)
        }
        )),
        t))
            for (; l < u; l++)
                t(e[l], n, a ? r : r.call(e[l], l, t(e[l], n)));
        return o ? e : c ? t.call(e) : u ? t(e[0], n) : s
    }
      , Me = /^-ms-/
      , Oe = /-([a-z])/g
      , Fe = function(e) {
        return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType
    };
    m.uid = 1,
    m.prototype = {
        cache: function(e) {
            var t = e[this.expando];
            return t || (t = {},
            Fe(e) && (e.nodeType ? e[this.expando] = t : Object.defineProperty(e, this.expando, {
                value: t,
                configurable: !0
            }))),
            t
        },
        set: function(e, t, n) {
            var i, r = this.cache(e);
            if ("string" == typeof t)
                r[p(t)] = n;
            else
                for (i in t)
                    r[p(i)] = t[i];
            return r
        },
        get: function(e, t) {
            return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][p(t)]
        },
        access: function(e, t, n) {
            return void 0 === t || t && "string" == typeof t && void 0 === n ? this.get(e, t) : (this.set(e, t, n),
            void 0 !== n ? n : t)
        },
        remove: function(e, t) {
            var n, i = e[this.expando];
            if (void 0 !== i) {
                if (void 0 !== t) {
                    n = (t = Array.isArray(t) ? t.map(p) : (t = p(t))in i ? [t] : t.match(ze) || []).length;
                    for (; n--; )
                        delete i[t[n]]
                }
                (void 0 === t || xe.isEmptyObject(i)) && (e.nodeType ? e[this.expando] = void 0 : delete e[this.expando])
            }
        },
        hasData: function(e) {
            var t = e[this.expando];
            return void 0 !== t && !xe.isEmptyObject(t)
        }
    };
    var qe = new m
      , Be = new m
      , He = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/
      , Re = /[A-Z]/g;
    xe.extend({
        hasData: function(e) {
            return Be.hasData(e) || qe.hasData(e)
        },
        data: function(e, t, n) {
            return Be.access(e, t, n)
        },
        removeData: function(e, t) {
            Be.remove(e, t)
        },
        _data: function(e, t, n) {
            return qe.access(e, t, n)
        },
        _removeData: function(e, t) {
            qe.remove(e, t)
        }
    }),
    xe.fn.extend({
        data: function(e, t) {
            var n, i, r, o = this[0], s = o && o.attributes;
            if (void 0 === e) {
                if (this.length && (r = Be.get(o),
                1 === o.nodeType && !qe.get(o, "hasDataAttrs"))) {
                    for (n = s.length; n--; )
                        s[n] && 0 === (i = s[n].name).indexOf("data-") && (i = p(i.slice(5)),
                        v(o, i, r[i]));
                    qe.set(o, "hasDataAttrs", !0)
                }
                return r
            }
            return "object" == typeof e ? this.each(function() {
                Be.set(this, e)
            }) : je(this, function(t) {
                var n;
                if (o && void 0 === t) {
                    if (void 0 !== (n = Be.get(o, e)))
                        return n;
                    if (void 0 !== (n = v(o, e)))
                        return n
                } else
                    this.each(function() {
                        Be.set(this, e, t)
                    })
            }, null, t, arguments.length > 1, null, !0)
        },
        removeData: function(e) {
            return this.each(function() {
                Be.remove(this, e)
            })
        }
    }),
    xe.extend({
        queue: function(e, t, n) {
            var i;
            if (e)
                return t = (t || "fx") + "queue",
                i = qe.get(e, t),
                n && (!i || Array.isArray(n) ? i = qe.access(e, t, xe.makeArray(n)) : i.push(n)),
                i || []
        },
        dequeue: function(e, t) {
            t = t || "fx";
            var n = xe.queue(e, t)
              , i = n.length
              , r = n.shift()
              , o = xe._queueHooks(e, t)
              , s = function() {
                xe.dequeue(e, t)
            };
            "inprogress" === r && (r = n.shift(),
            i--),
            r && ("fx" === t && n.unshift("inprogress"),
            delete o.stop,
            r.call(e, s, o)),
            !i && o && o.empty.fire()
        },
        _queueHooks: function(e, t) {
            var n = t + "queueHooks";
            return qe.get(e, n) || qe.access(e, n, {
                empty: xe.Callbacks("once memory").add(function() {
                    qe.remove(e, [t + "queue", n])
                })
            })
        }
    }),
    xe.fn.extend({
        queue: function(e, t) {
            var n = 2;
            return "string" != typeof e && (t = e,
            e = "fx",
            n--),
            arguments.length < n ? xe.queue(this[0], e) : void 0 === t ? this : this.each(function() {
                var n = xe.queue(this, e, t);
                xe._queueHooks(this, e),
                "fx" === e && "inprogress" !== n[0] && xe.dequeue(this, e)
            })
        },
        dequeue: function(e) {
            return this.each(function() {
                xe.dequeue(this, e)
            })
        },
        clearQueue: function(e) {
            return this.queue(e || "fx", [])
        },
        promise: function(e, t) {
            var n, i = 1, r = xe.Deferred(), o = this, s = this.length, a = function() {
                --i || r.resolveWith(o, [o])
            };
            for ("string" != typeof e && (t = e,
            e = void 0),
            e = e || "fx"; s--; )
                (n = qe.get(o[s], e + "queueHooks")) && n.empty && (i++,
                n.empty.add(a));
            return a(),
            r.promise(t)
        }
    });
    var We = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source
      , Ue = new RegExp("^(?:([+-])=|)(" + We + ")([a-z%]*)$","i")
      , $e = ["Top", "Right", "Bottom", "Left"]
      , Ve = function(e, t) {
        return "none" === (e = t || e).style.display || "" === e.style.display && xe.contains(e.ownerDocument, e) && "none" === xe.css(e, "display")
    }
      , Qe = function(e, t, n, i) {
        var r, o, s = {};
        for (o in t)
            s[o] = e.style[o],
            e.style[o] = t[o];
        r = n.apply(e, i || []);
        for (o in t)
            e.style[o] = s[o];
        return r
    }
      , Ye = {};
    xe.fn.extend({
        show: function() {
            return w(this, !0)
        },
        hide: function() {
            return w(this)
        },
        toggle: function(e) {
            return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each(function() {
                Ve(this) ? xe(this).show() : xe(this).hide()
            })
        }
    });
    var Xe = /^(?:checkbox|radio)$/i
      , Ge = /<([a-z][^\/\0>\x20\t\r\n\f]+)/i
      , Je = /^$|^module$|\/(?:java|ecma)script/i
      , Ze = {
        option: [1, "<select multiple='multiple'>", "</select>"],
        thead: [1, "<table>", "</table>"],
        col: [2, "<table><colgroup>", "</colgroup></table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        _default: [0, "", ""]
    };
    Ze.optgroup = Ze.option,
    Ze.tbody = Ze.tfoot = Ze.colgroup = Ze.caption = Ze.thead,
    Ze.th = Ze.td;
    var Ke = /<|&#?\w+;/;
    !function() {
        var e = se.createDocumentFragment().appendChild(se.createElement("div"))
          , t = se.createElement("input");
        t.setAttribute("type", "radio"),
        t.setAttribute("checked", "checked"),
        t.setAttribute("name", "t"),
        e.appendChild(t),
        ve.checkClone = e.cloneNode(!0).cloneNode(!0).lastChild.checked,
        e.innerHTML = "<textarea>x</textarea>",
        ve.noCloneChecked = !!e.cloneNode(!0).lastChild.defaultValue
    }();
    var et = se.documentElement
      , tt = /^key/
      , nt = /^(?:mouse|pointer|contextmenu|drag|drop)|click/
      , it = /^([^.]*)(?:\.(.+)|)/;
    xe.event = {
        global: {},
        add: function(e, t, n, i, r) {
            var o, s, a, l, u, c, d, f, h, p, m, g = qe.get(e);
            if (g)
                for (n.handler && (n = (o = n).handler,
                r = o.selector),
                r && xe.find.matchesSelector(et, r),
                n.guid || (n.guid = xe.guid++),
                (l = g.events) || (l = g.events = {}),
                (s = g.handle) || (s = g.handle = function(t) {
                    return "undefined" != typeof xe && xe.event.triggered !== t.type ? xe.event.dispatch.apply(e, arguments) : void 0
                }
                ),
                u = (t = (t || "").match(ze) || [""]).length; u--; )
                    h = m = (a = it.exec(t[u]) || [])[1],
                    p = (a[2] || "").split(".").sort(),
                    h && (d = xe.event.special[h] || {},
                    h = (r ? d.delegateType : d.bindType) || h,
                    d = xe.event.special[h] || {},
                    c = xe.extend({
                        type: h,
                        origType: m,
                        data: i,
                        handler: n,
                        guid: n.guid,
                        selector: r,
                        needsContext: r && xe.expr.match.needsContext.test(r),
                        namespace: p.join(".")
                    }, o),
                    (f = l[h]) || ((f = l[h] = []).delegateCount = 0,
                    d.setup && !1 !== d.setup.call(e, i, p, s) || e.addEventListener && e.addEventListener(h, s)),
                    d.add && (d.add.call(e, c),
                    c.handler.guid || (c.handler.guid = n.guid)),
                    r ? f.splice(f.delegateCount++, 0, c) : f.push(c),
                    xe.event.global[h] = !0)
        },
        remove: function(e, t, n, i, r) {
            var o, s, a, l, u, c, d, f, h, p, m, g = qe.hasData(e) && qe.get(e);
            if (g && (l = g.events)) {
                for (u = (t = (t || "").match(ze) || [""]).length; u--; )
                    if (a = it.exec(t[u]) || [],
                    h = m = a[1],
                    p = (a[2] || "").split(".").sort(),
                    h) {
                        for (d = xe.event.special[h] || {},
                        f = l[h = (i ? d.delegateType : d.bindType) || h] || [],
                        a = a[2] && new RegExp("(^|\\.)" + p.join("\\.(?:.*\\.|)") + "(\\.|$)"),
                        s = o = f.length; o--; )
                            c = f[o],
                            !r && m !== c.origType || n && n.guid !== c.guid || a && !a.test(c.namespace) || i && i !== c.selector && ("**" !== i || !c.selector) || (f.splice(o, 1),
                            c.selector && f.delegateCount--,
                            d.remove && d.remove.call(e, c));
                        s && !f.length && (d.teardown && !1 !== d.teardown.call(e, p, g.handle) || xe.removeEvent(e, h, g.handle),
                        delete l[h])
                    } else
                        for (h in l)
                            xe.event.remove(e, h + t[u], n, i, !0);
                xe.isEmptyObject(l) && qe.remove(e, "handle events")
            }
        },
        dispatch: function(e) {
            var t, n, i, r, o, s, a = xe.event.fix(e), l = new Array(arguments.length), u = (qe.get(this, "events") || {})[a.type] || [], c = xe.event.special[a.type] || {};
            for (l[0] = a,
            t = 1; t < arguments.length; t++)
                l[t] = arguments[t];
            if (a.delegateTarget = this,
            !c.preDispatch || !1 !== c.preDispatch.call(this, a)) {
                for (s = xe.event.handlers.call(this, a, u),
                t = 0; (r = s[t++]) && !a.isPropagationStopped(); )
                    for (a.currentTarget = r.elem,
                    n = 0; (o = r.handlers[n++]) && !a.isImmediatePropagationStopped(); )
                        a.rnamespace && !a.rnamespace.test(o.namespace) || (a.handleObj = o,
                        a.data = o.data,
                        void 0 !== (i = ((xe.event.special[o.origType] || {}).handle || o.handler).apply(r.elem, l)) && !1 === (a.result = i) && (a.preventDefault(),
                        a.stopPropagation()));
                return c.postDispatch && c.postDispatch.call(this, a),
                a.result
            }
        },
        handlers: function(e, t) {
            var n, i, r, o, s, a = [], l = t.delegateCount, u = e.target;
            if (l && u.nodeType && !("click" === e.type && e.button >= 1))
                for (; u !== this; u = u.parentNode || this)
                    if (1 === u.nodeType && ("click" !== e.type || !0 !== u.disabled)) {
                        for (o = [],
                        s = {},
                        n = 0; n < l; n++)
                            void 0 === s[r = (i = t[n]).selector + " "] && (s[r] = i.needsContext ? xe(r, this).index(u) > -1 : xe.find(r, this, null, [u]).length),
                            s[r] && o.push(i);
                        o.length && a.push({
                            elem: u,
                            handlers: o
                        })
                    }
            return u = this,
            l < t.length && a.push({
                elem: u,
                handlers: t.slice(l)
            }),
            a
        },
        addProp: function(e, t) {
            Object.defineProperty(xe.Event.prototype, e, {
                enumerable: !0,
                configurable: !0,
                get: ye(t) ? function() {
                    if (this.originalEvent)
                        return t(this.originalEvent)
                }
                : function() {
                    if (this.originalEvent)
                        return this.originalEvent[e]
                }
                ,
                set: function(t) {
                    Object.defineProperty(this, e, {
                        enumerable: !0,
                        configurable: !0,
                        writable: !0,
                        value: t
                    })
                }
            })
        },
        fix: function(e) {
            return e[xe.expando] ? e : new xe.Event(e)
        },
        special: {
            load: {
                noBubble: !0
            },
            focus: {
                trigger: function() {
                    if (this !== T() && this.focus)
                        return this.focus(),
                        !1
                },
                delegateType: "focusin"
            },
            blur: {
                trigger: function() {
                    if (this === T() && this.blur)
                        return this.blur(),
                        !1
                },
                delegateType: "focusout"
            },
            click: {
                trigger: function() {
                    if ("checkbox" === this.type && this.click && o(this, "input"))
                        return this.click(),
                        !1
                },
                _default: function(e) {
                    return o(e.target, "a")
                }
            },
            beforeunload: {
                postDispatch: function(e) {
                    void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result)
                }
            }
        }
    },
    xe.removeEvent = function(e, t, n) {
        e.removeEventListener && e.removeEventListener(t, n)
    }
    ,
    xe.Event = function(e, t) {
        return this instanceof xe.Event ? (e && e.type ? (this.originalEvent = e,
        this.type = e.type,
        this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && !1 === e.returnValue ? E : S,
        this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target,
        this.currentTarget = e.currentTarget,
        this.relatedTarget = e.relatedTarget) : this.type = e,
        t && xe.extend(this, t),
        this.timeStamp = e && e.timeStamp || Date.now(),
        this[xe.expando] = !0,
        void 0) : new xe.Event(e,t)
    }
    ,
    xe.Event.prototype = {
        constructor: xe.Event,
        isDefaultPrevented: S,
        isPropagationStopped: S,
        isImmediatePropagationStopped: S,
        isSimulated: !1,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = E,
            e && !this.isSimulated && e.preventDefault()
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = E,
            e && !this.isSimulated && e.stopPropagation()
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = E,
            e && !this.isSimulated && e.stopImmediatePropagation(),
            this.stopPropagation()
        }
    },
    xe.each({
        altKey: !0,
        bubbles: !0,
        cancelable: !0,
        changedTouches: !0,
        ctrlKey: !0,
        detail: !0,
        eventPhase: !0,
        metaKey: !0,
        pageX: !0,
        pageY: !0,
        shiftKey: !0,
        view: !0,
        char: !0,
        charCode: !0,
        key: !0,
        keyCode: !0,
        button: !0,
        buttons: !0,
        clientX: !0,
        clientY: !0,
        offsetX: !0,
        offsetY: !0,
        pointerId: !0,
        pointerType: !0,
        screenX: !0,
        screenY: !0,
        targetTouches: !0,
        toElement: !0,
        touches: !0,
        which: function(e) {
            var t = e.button;
            return null == e.which && tt.test(e.type) ? null != e.charCode ? e.charCode : e.keyCode : !e.which && void 0 !== t && nt.test(e.type) ? 1 & t ? 1 : 2 & t ? 3 : 4 & t ? 2 : 0 : e.which
        }
    }, xe.event.addProp),
    xe.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(e, t) {
        xe.event.special[e] = {
            delegateType: t,
            bindType: t,
            handle: function(e) {
                var n, i = this, r = e.relatedTarget, o = e.handleObj;
                return r && (r === i || xe.contains(i, r)) || (e.type = o.origType,
                n = o.handler.apply(this, arguments),
                e.type = t),
                n
            }
        }
    }),
    xe.fn.extend({
        on: function(e, t, n, i) {
            return k(this, e, t, n, i)
        },
        one: function(e, t, n, i) {
            return k(this, e, t, n, i, 1)
        },
        off: function(e, t, n) {
            var i, r;
            if (e && e.preventDefault && e.handleObj)
                return i = e.handleObj,
                xe(e.delegateTarget).off(i.namespace ? i.origType + "." + i.namespace : i.origType, i.selector, i.handler),
                this;
            if ("object" == typeof e) {
                for (r in e)
                    this.off(r, t, e[r]);
                return this
            }
            return !1 !== t && "function" != typeof t || (n = t,
            t = void 0),
            !1 === n && (n = S),
            this.each(function() {
                xe.event.remove(this, e, n, t)
            })
        }
    });
    var rt = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi
      , ot = /<script|<style|<link/i
      , st = /checked\s*(?:[^=]|=\s*.checked.)/i
      , at = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
    xe.extend({
        htmlPrefilter: function(e) {
            return e.replace(rt, "<$1></$2>")
        },
        clone: function(e, t, n) {
            var i, r, o, s, a = e.cloneNode(!0), l = xe.contains(e.ownerDocument, e);
            if (!(ve.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || xe.isXMLDoc(e)))
                for (s = x(a),
                i = 0,
                r = (o = x(e)).length; i < r; i++)
                    z(o[i], s[i]);
            if (t)
                if (n)
                    for (o = o || x(e),
                    s = s || x(a),
                    i = 0,
                    r = o.length; i < r; i++)
                        L(o[i], s[i]);
                else
                    L(e, a);
            return (s = x(a, "script")).length > 0 && _(s, !l && x(e, "script")),
            a
        },
        cleanData: function(e) {
            for (var t, n, i, r = xe.event.special, o = 0; void 0 !== (n = e[o]); o++)
                if (Fe(n)) {
                    if (t = n[qe.expando]) {
                        if (t.events)
                            for (i in t.events)
                                r[i] ? xe.event.remove(n, i) : xe.removeEvent(n, i, t.handle);
                        n[qe.expando] = void 0
                    }
                    n[Be.expando] && (n[Be.expando] = void 0)
                }
        }
    }),
    xe.fn.extend({
        detach: function(e) {
            return N(this, e, !0)
        },
        remove: function(e) {
            return N(this, e)
        },
        text: function(e) {
            return je(this, function(e) {
                return void 0 === e ? xe.text(this) : this.empty().each(function() {
                    1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = e)
                })
            }, null, e, arguments.length)
        },
        append: function() {
            return P(this, arguments, function(e) {
                1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || A(this, e).appendChild(e)
            })
        },
        prepend: function() {
            return P(this, arguments, function(e) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var t = A(this, e);
                    t.insertBefore(e, t.firstChild)
                }
            })
        },
        before: function() {
            return P(this, arguments, function(e) {
                this.parentNode && this.parentNode.insertBefore(e, this)
            })
        },
        after: function() {
            return P(this, arguments, function(e) {
                this.parentNode && this.parentNode.insertBefore(e, this.nextSibling)
            })
        },
        empty: function() {
            for (var e, t = 0; null != (e = this[t]); t++)
                1 === e.nodeType && (xe.cleanData(x(e, !1)),
                e.textContent = "");
            return this
        },
        clone: function(e, t) {
            return e = null != e && e,
            t = null == t ? e : t,
            this.map(function() {
                return xe.clone(this, e, t)
            })
        },
        html: function(e) {
            return je(this, function(e) {
                var t = this[0] || {}
                  , n = 0
                  , i = this.length;
                if (void 0 === e && 1 === t.nodeType)
                    return t.innerHTML;
                if ("string" == typeof e && !ot.test(e) && !Ze[(Ge.exec(e) || ["", ""])[1].toLowerCase()]) {
                    e = xe.htmlPrefilter(e);
                    try {
                        for (; n < i; n++)
                            1 === (t = this[n] || {}).nodeType && (xe.cleanData(x(t, !1)),
                            t.innerHTML = e);
                        t = 0
                    } catch (e) {}
                }
                t && this.empty().append(e)
            }, null, e, arguments.length)
        },
        replaceWith: function() {
            var e = [];
            return P(this, arguments, function(t) {
                var n = this.parentNode;
                xe.inArray(this, e) < 0 && (xe.cleanData(x(this)),
                n && n.replaceChild(t, this))
            }, e)
        }
    }),
    xe.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(e, t) {
        xe.fn[e] = function(e) {
            for (var n, i = [], r = xe(e), o = r.length - 1, s = 0; s <= o; s++)
                n = s === o ? this : this.clone(!0),
                xe(r[s])[t](n),
                ce.apply(i, n.get());
            return this.pushStack(i)
        }
    });
    var lt = new RegExp("^(" + We + ")(?!px)[a-z%]+$","i")
      , ut = function(t) {
        var n = t.ownerDocument.defaultView;
        return n && n.opener || (n = e),
        n.getComputedStyle(t)
    }
      , ct = new RegExp($e.join("|"),"i");
    !function() {
        function t() {
            if (u) {
                l.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",
                u.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",
                et.appendChild(l).appendChild(u);
                var t = e.getComputedStyle(u);
                i = "1%" !== t.top,
                a = 12 === n(t.marginLeft),
                u.style.right = "60%",
                s = 36 === n(t.right),
                r = 36 === n(t.width),
                u.style.position = "absolute",
                o = 36 === u.offsetWidth || "absolute",
                et.removeChild(l),
                u = null
            }
        }
        function n(e) {
            return Math.round(parseFloat(e))
        }
        var i, r, o, s, a, l = se.createElement("div"), u = se.createElement("div");
        u.style && (u.style.backgroundClip = "content-box",
        u.cloneNode(!0).style.backgroundClip = "",
        ve.clearCloneStyle = "content-box" === u.style.backgroundClip,
        xe.extend(ve, {
            boxSizingReliable: function() {
                return t(),
                r
            },
            pixelBoxStyles: function() {
                return t(),
                s
            },
            pixelPosition: function() {
                return t(),
                i
            },
            reliableMarginLeft: function() {
                return t(),
                a
            },
            scrollboxSize: function() {
                return t(),
                o
            }
        }))
    }();
    var dt = /^(none|table(?!-c[ea]).+)/
      , ft = /^--/
      , ht = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }
      , pt = {
        letterSpacing: "0",
        fontWeight: "400"
    }
      , mt = ["Webkit", "Moz", "ms"]
      , gt = se.createElement("div").style;
    xe.extend({
        cssHooks: {
            opacity: {
                get: function(e, t) {
                    if (t) {
                        var n = j(e, "opacity");
                        return "" === n ? "1" : n
                    }
                }
            }
        },
        cssNumber: {
            animationIterationCount: !0,
            columnCount: !0,
            fillOpacity: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0
        },
        cssProps: {},
        style: function(e, t, n, i) {
            if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                var r, o, s, a = p(t), l = ft.test(t), u = e.style;
                if (l || (t = F(a)),
                s = xe.cssHooks[t] || xe.cssHooks[a],
                void 0 === n)
                    return s && "get"in s && void 0 !== (r = s.get(e, !1, i)) ? r : u[t];
                "string" == (o = typeof n) && (r = Ue.exec(n)) && r[1] && (n = y(e, t, r),
                o = "number"),
                null != n && n === n && ("number" === o && (n += r && r[3] || (xe.cssNumber[a] ? "" : "px")),
                ve.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (u[t] = "inherit"),
                s && "set"in s && void 0 === (n = s.set(e, n, i)) || (l ? u.setProperty(t, n) : u[t] = n))
            }
        },
        css: function(e, t, n, i) {
            var r, o, s, a = p(t);
            return ft.test(t) || (t = F(a)),
            (s = xe.cssHooks[t] || xe.cssHooks[a]) && "get"in s && (r = s.get(e, !0, n)),
            void 0 === r && (r = j(e, t, i)),
            "normal" === r && t in pt && (r = pt[t]),
            "" === n || n ? (o = parseFloat(r),
            !0 === n || isFinite(o) ? o || 0 : r) : r
        }
    }),
    xe.each(["height", "width"], function(e, t) {
        xe.cssHooks[t] = {
            get: function(e, n, i) {
                if (n)
                    return !dt.test(xe.css(e, "display")) || e.getClientRects().length && e.getBoundingClientRect().width ? H(e, t, i) : Qe(e, ht, function() {
                        return H(e, t, i)
                    })
            },
            set: function(e, n, i) {
                var r, o = ut(e), s = "border-box" === xe.css(e, "boxSizing", !1, o), a = i && B(e, t, i, s, o);
                return s && ve.scrollboxSize() === o.position && (a -= Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - parseFloat(o[t]) - B(e, t, "border", !1, o) - .5)),
                a && (r = Ue.exec(n)) && "px" !== (r[3] || "px") && (e.style[t] = n,
                n = xe.css(e, t)),
                q(e, n, a)
            }
        }
    }),
    xe.cssHooks.marginLeft = M(ve.reliableMarginLeft, function(e, t) {
        if (t)
            return (parseFloat(j(e, "marginLeft")) || e.getBoundingClientRect().left - Qe(e, {
                marginLeft: 0
            }, function() {
                return e.getBoundingClientRect().left
            })) + "px"
    }),
    xe.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(e, t) {
        xe.cssHooks[e + t] = {
            expand: function(n) {
                for (var i = 0, r = {}, o = "string" == typeof n ? n.split(" ") : [n]; i < 4; i++)
                    r[e + $e[i] + t] = o[i] || o[i - 2] || o[0];
                return r
            }
        },
        "margin" !== e && (xe.cssHooks[e + t].set = q)
    }),
    xe.fn.extend({
        css: function(e, t) {
            return je(this, function(e, t, n) {
                var i, r, o = {}, s = 0;
                if (Array.isArray(t)) {
                    for (i = ut(e),
                    r = t.length; s < r; s++)
                        o[t[s]] = xe.css(e, t[s], !1, i);
                    return o
                }
                return void 0 !== n ? xe.style(e, t, n) : xe.css(e, t)
            }, e, t, arguments.length > 1)
        }
    }),
    xe.Tween = R,
    R.prototype = {
        constructor: R,
        init: function(e, t, n, i, r, o) {
            this.elem = e,
            this.prop = n,
            this.easing = r || xe.easing._default,
            this.options = t,
            this.start = this.now = this.cur(),
            this.end = i,
            this.unit = o || (xe.cssNumber[n] ? "" : "px")
        },
        cur: function() {
            var e = R.propHooks[this.prop];
            return e && e.get ? e.get(this) : R.propHooks._default.get(this)
        },
        run: function(e) {
            var t, n = R.propHooks[this.prop];
            return this.options.duration ? this.pos = t = xe.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : this.pos = t = e,
            this.now = (this.end - this.start) * t + this.start,
            this.options.step && this.options.step.call(this.elem, this.now, this),
            n && n.set ? n.set(this) : R.propHooks._default.set(this),
            this
        }
    },
    R.prototype.init.prototype = R.prototype,
    R.propHooks = {
        _default: {
            get: function(e) {
                var t;
                return 1 !== e.elem.nodeType || null != e.elem[e.prop] && null == e.elem.style[e.prop] ? e.elem[e.prop] : (t = xe.css(e.elem, e.prop, "")) && "auto" !== t ? t : 0
            },
            set: function(e) {
                xe.fx.step[e.prop] ? xe.fx.step[e.prop](e) : 1 !== e.elem.nodeType || null == e.elem.style[xe.cssProps[e.prop]] && !xe.cssHooks[e.prop] ? e.elem[e.prop] = e.now : xe.style(e.elem, e.prop, e.now + e.unit)
            }
        }
    },
    R.propHooks.scrollTop = R.propHooks.scrollLeft = {
        set: function(e) {
            e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now)
        }
    },
    xe.easing = {
        linear: function(e) {
            return e
        },
        swing: function(e) {
            return .5 - Math.cos(e * Math.PI) / 2
        },
        _default: "swing"
    },
    xe.fx = R.prototype.init,
    xe.fx.step = {};
    var vt, yt, bt = /^(?:toggle|show|hide)$/, wt = /queueHooks$/;
    xe.Animation = xe.extend(X, {
        tweeners: {
            "*": [function(e, t) {
                var n = this.createTween(e, t);
                return y(n.elem, e, Ue.exec(t), n),
                n
            }
            ]
        },
        tweener: function(e, t) {
            ye(e) ? (t = e,
            e = ["*"]) : e = e.match(ze);
            for (var n, i = 0, r = e.length; i < r; i++)
                n = e[i],
                X.tweeners[n] = X.tweeners[n] || [],
                X.tweeners[n].unshift(t)
        },
        prefilters: [Q],
        prefilter: function(e, t) {
            t ? X.prefilters.unshift(e) : X.prefilters.push(e)
        }
    }),
    xe.speed = function(e, t, n) {
        var i = e && "object" == typeof e ? xe.extend({}, e) : {
            complete: n || !n && t || ye(e) && e,
            duration: e,
            easing: n && t || t && !ye(t) && t
        };
        return xe.fx.off ? i.duration = 0 : "number" != typeof i.duration && (i.duration in xe.fx.speeds ? i.duration = xe.fx.speeds[i.duration] : i.duration = xe.fx.speeds._default),
        null != i.queue && !0 !== i.queue || (i.queue = "fx"),
        i.old = i.complete,
        i.complete = function() {
            ye(i.old) && i.old.call(this),
            i.queue && xe.dequeue(this, i.queue)
        }
        ,
        i
    }
    ,
    xe.fn.extend({
        fadeTo: function(e, t, n, i) {
            return this.filter(Ve).css("opacity", 0).show().end().animate({
                opacity: t
            }, e, n, i)
        },
        animate: function(e, t, n, i) {
            var r = xe.isEmptyObject(e)
              , o = xe.speed(t, n, i)
              , s = function() {
                var t = X(this, xe.extend({}, e), o);
                (r || qe.get(this, "finish")) && t.stop(!0)
            };
            return s.finish = s,
            r || !1 === o.queue ? this.each(s) : this.queue(o.queue, s)
        },
        stop: function(e, t, n) {
            var i = function(e) {
                var t = e.stop;
                delete e.stop,
                t(n)
            };
            return "string" != typeof e && (n = t,
            t = e,
            e = void 0),
            t && !1 !== e && this.queue(e || "fx", []),
            this.each(function() {
                var t = !0
                  , r = null != e && e + "queueHooks"
                  , o = xe.timers
                  , s = qe.get(this);
                if (r)
                    s[r] && s[r].stop && i(s[r]);
                else
                    for (r in s)
                        s[r] && s[r].stop && wt.test(r) && i(s[r]);
                for (r = o.length; r--; )
                    o[r].elem !== this || null != e && o[r].queue !== e || (o[r].anim.stop(n),
                    t = !1,
                    o.splice(r, 1));
                !t && n || xe.dequeue(this, e)
            })
        },
        finish: function(e) {
            return !1 !== e && (e = e || "fx"),
            this.each(function() {
                var t, n = qe.get(this), i = n[e + "queue"], r = n[e + "queueHooks"], o = xe.timers, s = i ? i.length : 0;
                for (n.finish = !0,
                xe.queue(this, e, []),
                r && r.stop && r.stop.call(this, !0),
                t = o.length; t--; )
                    o[t].elem === this && o[t].queue === e && (o[t].anim.stop(!0),
                    o.splice(t, 1));
                for (t = 0; t < s; t++)
                    i[t] && i[t].finish && i[t].finish.call(this);
                delete n.finish
            })
        }
    }),
    xe.each(["toggle", "show", "hide"], function(e, t) {
        var n = xe.fn[t];
        xe.fn[t] = function(e, i, r) {
            return null == e || "boolean" == typeof e ? n.apply(this, arguments) : this.animate($(t, !0), e, i, r)
        }
    }),
    xe.each({
        slideDown: $("show"),
        slideUp: $("hide"),
        slideToggle: $("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(e, t) {
        xe.fn[e] = function(e, n, i) {
            return this.animate(t, e, n, i)
        }
    }),
    xe.timers = [],
    xe.fx.tick = function() {
        var e, t = 0, n = xe.timers;
        for (vt = Date.now(); t < n.length; t++)
            (e = n[t])() || n[t] !== e || n.splice(t--, 1);
        n.length || xe.fx.stop(),
        vt = void 0
    }
    ,
    xe.fx.timer = function(e) {
        xe.timers.push(e),
        xe.fx.start()
    }
    ,
    xe.fx.interval = 13,
    xe.fx.start = function() {
        yt || (yt = !0,
        W())
    }
    ,
    xe.fx.stop = function() {
        yt = null
    }
    ,
    xe.fx.speeds = {
        slow: 600,
        fast: 200,
        _default: 400
    },
    xe.fn.delay = function(t, n) {
        return t = xe.fx ? xe.fx.speeds[t] || t : t,
        n = n || "fx",
        this.queue(n, function(n, i) {
            var r = e.setTimeout(n, t);
            i.stop = function() {
                e.clearTimeout(r)
            }
        })
    }
    ,
    function() {
        var e = se.createElement("input")
          , t = se.createElement("select").appendChild(se.createElement("option"));
        e.type = "checkbox",
        ve.checkOn = "" !== e.value,
        ve.optSelected = t.selected,
        (e = se.createElement("input")).value = "t",
        e.type = "radio",
        ve.radioValue = "t" === e.value
    }();
    var xt, _t = xe.expr.attrHandle;
    xe.fn.extend({
        attr: function(e, t) {
            return je(this, xe.attr, e, t, arguments.length > 1)
        },
        removeAttr: function(e) {
            return this.each(function() {
                xe.removeAttr(this, e)
            })
        }
    }),
    xe.extend({
        attr: function(e, t, n) {
            var i, r, o = e.nodeType;
            if (3 !== o && 8 !== o && 2 !== o)
                return "undefined" == typeof e.getAttribute ? xe.prop(e, t, n) : (1 === o && xe.isXMLDoc(e) || (r = xe.attrHooks[t.toLowerCase()] || (xe.expr.match.bool.test(t) ? xt : void 0)),
                void 0 !== n ? null === n ? void xe.removeAttr(e, t) : r && "set"in r && void 0 !== (i = r.set(e, n, t)) ? i : (e.setAttribute(t, n + ""),
                n) : r && "get"in r && null !== (i = r.get(e, t)) ? i : null == (i = xe.find.attr(e, t)) ? void 0 : i)
        },
        attrHooks: {
            type: {
                set: function(e, t) {
                    if (!ve.radioValue && "radio" === t && o(e, "input")) {
                        var n = e.value;
                        return e.setAttribute("type", t),
                        n && (e.value = n),
                        t
                    }
                }
            }
        },
        removeAttr: function(e, t) {
            var n, i = 0, r = t && t.match(ze);
            if (r && 1 === e.nodeType)
                for (; n = r[i++]; )
                    e.removeAttribute(n)
        }
    }),
    xt = {
        set: function(e, t, n) {
            return !1 === t ? xe.removeAttr(e, n) : e.setAttribute(n, n),
            n
        }
    },
    xe.each(xe.expr.match.bool.source.match(/\w+/g), function(e, t) {
        var n = _t[t] || xe.find.attr;
        _t[t] = function(e, t, i) {
            var r, o, s = t.toLowerCase();
            return i || (o = _t[s],
            _t[s] = r,
            r = null != n(e, t, i) ? s : null,
            _t[s] = o),
            r
        }
    });
    var Ct = /^(?:input|select|textarea|button)$/i
      , Et = /^(?:a|area)$/i;
    xe.fn.extend({
        prop: function(e, t) {
            return je(this, xe.prop, e, t, arguments.length > 1)
        },
        removeProp: function(e) {
            return this.each(function() {
                delete this[xe.propFix[e] || e]
            })
        }
    }),
    xe.extend({
        prop: function(e, t, n) {
            var i, r, o = e.nodeType;
            if (3 !== o && 8 !== o && 2 !== o)
                return 1 === o && xe.isXMLDoc(e) || (t = xe.propFix[t] || t,
                r = xe.propHooks[t]),
                void 0 !== n ? r && "set"in r && void 0 !== (i = r.set(e, n, t)) ? i : e[t] = n : r && "get"in r && null !== (i = r.get(e, t)) ? i : e[t]
        },
        propHooks: {
            tabIndex: {
                get: function(e) {
                    var t = xe.find.attr(e, "tabindex");
                    return t ? parseInt(t, 10) : Ct.test(e.nodeName) || Et.test(e.nodeName) && e.href ? 0 : -1
                }
            }
        },
        propFix: {
            for: "htmlFor",
            class: "className"
        }
    }),
    ve.optSelected || (xe.propHooks.selected = {
        get: function(e) {
            var t = e.parentNode;
            return t && t.parentNode && t.parentNode.selectedIndex,
            null
        },
        set: function(e) {
            var t = e.parentNode;
            t && (t.selectedIndex,
            t.parentNode && t.parentNode.selectedIndex)
        }
    }),
    xe.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
        xe.propFix[this.toLowerCase()] = this
    }),
    xe.fn.extend({
        addClass: function(e) {
            var t, n, i, r, o, s, a, l = 0;
            if (ye(e))
                return this.each(function(t) {
                    xe(this).addClass(e.call(this, t, J(this)))
                });
            if ((t = Z(e)).length)
                for (; n = this[l++]; )
                    if (r = J(n),
                    i = 1 === n.nodeType && " " + G(r) + " ") {
                        for (s = 0; o = t[s++]; )
                            i.indexOf(" " + o + " ") < 0 && (i += o + " ");
                        r !== (a = G(i)) && n.setAttribute("class", a)
                    }
            return this
        },
        removeClass: function(e) {
            var t, n, i, r, o, s, a, l = 0;
            if (ye(e))
                return this.each(function(t) {
                    xe(this).removeClass(e.call(this, t, J(this)))
                });
            if (!arguments.length)
                return this.attr("class", "");
            if ((t = Z(e)).length)
                for (; n = this[l++]; )
                    if (r = J(n),
                    i = 1 === n.nodeType && " " + G(r) + " ") {
                        for (s = 0; o = t[s++]; )
                            for (; i.indexOf(" " + o + " ") > -1; )
                                i = i.replace(" " + o + " ", " ");
                        r !== (a = G(i)) && n.setAttribute("class", a)
                    }
            return this
        },
        toggleClass: function(e, t) {
            var n = typeof e
              , i = "string" === n || Array.isArray(e);
            return "boolean" == typeof t && i ? t ? this.addClass(e) : this.removeClass(e) : ye(e) ? this.each(function(n) {
                xe(this).toggleClass(e.call(this, n, J(this), t), t)
            }) : this.each(function() {
                var t, r, o, s;
                if (i)
                    for (r = 0,
                    o = xe(this),
                    s = Z(e); t = s[r++]; )
                        o.hasClass(t) ? o.removeClass(t) : o.addClass(t);
                else
                    void 0 !== e && "boolean" !== n || ((t = J(this)) && qe.set(this, "__className__", t),
                    this.setAttribute && this.setAttribute("class", t || !1 === e ? "" : qe.get(this, "__className__") || ""))
            })
        },
        hasClass: function(e) {
            var t, n, i = 0;
            for (t = " " + e + " "; n = this[i++]; )
                if (1 === n.nodeType && (" " + G(J(n)) + " ").indexOf(t) > -1)
                    return !0;
            return !1
        }
    });
    var St = /\r/g;
    xe.fn.extend({
        val: function(e) {
            var t, n, i, r = this[0];
            return arguments.length ? (i = ye(e),
            this.each(function(n) {
                var r;
                1 === this.nodeType && (null == (r = i ? e.call(this, n, xe(this).val()) : e) ? r = "" : "number" == typeof r ? r += "" : Array.isArray(r) && (r = xe.map(r, function(e) {
                    return null == e ? "" : e + ""
                })),
                (t = xe.valHooks[this.type] || xe.valHooks[this.nodeName.toLowerCase()]) && "set"in t && void 0 !== t.set(this, r, "value") || (this.value = r))
            })) : r ? (t = xe.valHooks[r.type] || xe.valHooks[r.nodeName.toLowerCase()]) && "get"in t && void 0 !== (n = t.get(r, "value")) ? n : "string" == typeof (n = r.value) ? n.replace(St, "") : null == n ? "" : n : void 0
        }
    }),
    xe.extend({
        valHooks: {
            option: {
                get: function(e) {
                    var t = xe.find.attr(e, "value");
                    return null != t ? t : G(xe.text(e))
                }
            },
            select: {
                get: function(e) {
                    var t, n, i, r = e.options, s = e.selectedIndex, a = "select-one" === e.type, l = a ? null : [], u = a ? s + 1 : r.length;
                    for (i = s < 0 ? u : a ? s : 0; i < u; i++)
                        if (((n = r[i]).selected || i === s) && !n.disabled && (!n.parentNode.disabled || !o(n.parentNode, "optgroup"))) {
                            if (t = xe(n).val(),
                            a)
                                return t;
                            l.push(t)
                        }
                    return l
                },
                set: function(e, t) {
                    for (var n, i, r = e.options, o = xe.makeArray(t), s = r.length; s--; )
                        ((i = r[s]).selected = xe.inArray(xe.valHooks.option.get(i), o) > -1) && (n = !0);
                    return n || (e.selectedIndex = -1),
                    o
                }
            }
        }
    }),
    xe.each(["radio", "checkbox"], function() {
        xe.valHooks[this] = {
            set: function(e, t) {
                if (Array.isArray(t))
                    return e.checked = xe.inArray(xe(e).val(), t) > -1
            }
        },
        ve.checkOn || (xe.valHooks[this].get = function(e) {
            return null === e.getAttribute("value") ? "on" : e.value
        }
        )
    }),
    ve.focusin = "onfocusin"in e;
    var Tt = /^(?:focusinfocus|focusoutblur)$/
      , kt = function(e) {
        e.stopPropagation()
    };
    xe.extend(xe.event, {
        trigger: function(t, n, i, r) {
            var o, s, a, l, u, c, d, f, h = [i || se], p = pe.call(t, "type") ? t.type : t, m = pe.call(t, "namespace") ? t.namespace.split(".") : [];
            if (s = f = a = i = i || se,
            3 !== i.nodeType && 8 !== i.nodeType && !Tt.test(p + xe.event.triggered) && (p.indexOf(".") > -1 && (p = (m = p.split(".")).shift(),
            m.sort()),
            u = p.indexOf(":") < 0 && "on" + p,
            t = t[xe.expando] ? t : new xe.Event(p,"object" == typeof t && t),
            t.isTrigger = r ? 2 : 3,
            t.namespace = m.join("."),
            t.rnamespace = t.namespace ? new RegExp("(^|\\.)" + m.join("\\.(?:.*\\.|)") + "(\\.|$)") : null,
            t.result = void 0,
            t.target || (t.target = i),
            n = null == n ? [t] : xe.makeArray(n, [t]),
            d = xe.event.special[p] || {},
            r || !d.trigger || !1 !== d.trigger.apply(i, n))) {
                if (!r && !d.noBubble && !be(i)) {
                    for (l = d.delegateType || p,
                    Tt.test(l + p) || (s = s.parentNode); s; s = s.parentNode)
                        h.push(s),
                        a = s;
                    a === (i.ownerDocument || se) && h.push(a.defaultView || a.parentWindow || e)
                }
                for (o = 0; (s = h[o++]) && !t.isPropagationStopped(); )
                    f = s,
                    t.type = o > 1 ? l : d.bindType || p,
                    (c = (qe.get(s, "events") || {})[t.type] && qe.get(s, "handle")) && c.apply(s, n),
                    (c = u && s[u]) && c.apply && Fe(s) && (t.result = c.apply(s, n),
                    !1 === t.result && t.preventDefault());
                return t.type = p,
                r || t.isDefaultPrevented() || d._default && !1 !== d._default.apply(h.pop(), n) || !Fe(i) || u && ye(i[p]) && !be(i) && ((a = i[u]) && (i[u] = null),
                xe.event.triggered = p,
                t.isPropagationStopped() && f.addEventListener(p, kt),
                i[p](),
                t.isPropagationStopped() && f.removeEventListener(p, kt),
                xe.event.triggered = void 0,
                a && (i[u] = a)),
                t.result
            }
        },
        simulate: function(e, t, n) {
            var i = xe.extend(new xe.Event, n, {
                type: e,
                isSimulated: !0
            });
            xe.event.trigger(i, null, t)
        }
    }),
    xe.fn.extend({
        trigger: function(e, t) {
            return this.each(function() {
                xe.event.trigger(e, t, this)
            })
        },
        triggerHandler: function(e, t) {
            var n = this[0];
            if (n)
                return xe.event.trigger(e, t, n, !0)
        }
    }),
    ve.focusin || xe.each({
        focus: "focusin",
        blur: "focusout"
    }, function(e, t) {
        var n = function(e) {
            xe.event.simulate(t, e.target, xe.event.fix(e))
        };
        xe.event.special[t] = {
            setup: function() {
                var i = this.ownerDocument || this
                  , r = qe.access(i, t);
                r || i.addEventListener(e, n, !0),
                qe.access(i, t, (r || 0) + 1)
            },
            teardown: function() {
                var i = this.ownerDocument || this
                  , r = qe.access(i, t) - 1;
                r ? qe.access(i, t, r) : (i.removeEventListener(e, n, !0),
                qe.remove(i, t))
            }
        }
    });
    var At = e.location
      , It = Date.now()
      , Dt = /\?/;
    xe.parseXML = function(t) {
        var n;
        if (!t || "string" != typeof t)
            return null;
        try {
            n = (new e.DOMParser).parseFromString(t, "text/xml")
        } catch (e) {
            n = void 0
        }
        return n && !n.getElementsByTagName("parsererror").length || xe.error("Invalid XML: " + t),
        n
    }
    ;
    var Lt = /\[\]$/
      , zt = /\r?\n/g
      , Pt = /^(?:submit|button|image|reset|file)$/i
      , Nt = /^(?:input|select|textarea|keygen)/i;
    xe.param = function(e, t) {
        var n, i = [], r = function(e, t) {
            var n = ye(t) ? t() : t;
            i[i.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == n ? "" : n)
        };
        if (Array.isArray(e) || e.jquery && !xe.isPlainObject(e))
            xe.each(e, function() {
                r(this.name, this.value)
            });
        else
            for (n in e)
                K(n, e[n], t, r);
        return i.join("&")
    }
    ,
    xe.fn.extend({
        serialize: function() {
            return xe.param(this.serializeArray())
        },
        serializeArray: function() {
            return this.map(function() {
                var e = xe.prop(this, "elements");
                return e ? xe.makeArray(e) : this
            }).filter(function() {
                var e = this.type;
                return this.name && !xe(this).is(":disabled") && Nt.test(this.nodeName) && !Pt.test(e) && (this.checked || !Xe.test(e))
            }).map(function(e, t) {
                var n = xe(this).val();
                return null == n ? null : Array.isArray(n) ? xe.map(n, function(e) {
                    return {
                        name: t.name,
                        value: e.replace(zt, "\r\n")
                    }
                }) : {
                    name: t.name,
                    value: n.replace(zt, "\r\n")
                }
            }).get()
        }
    });
    var jt = /%20/g
      , Mt = /#.*$/
      , Ot = /([?&])_=[^&]*/
      , Ft = /^(.*?):[ \t]*([^\r\n]*)$/gm
      , qt = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/
      , Bt = /^(?:GET|HEAD)$/
      , Ht = /^\/\//
      , Rt = {}
      , Wt = {}
      , Ut = "*/".concat("*")
      , $t = se.createElement("a");
    $t.href = At.href,
    xe.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: At.href,
            type: "GET",
            isLocal: qt.test(At.protocol),
            global: !0,
            processData: !0,
            async: !0,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            accepts: {
                "*": Ut,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            converters: {
                "* text": String,
                "text html": !0,
                "text json": JSON.parse,
                "text xml": xe.parseXML
            },
            flatOptions: {
                url: !0,
                context: !0
            }
        },
        ajaxSetup: function(e, t) {
            return t ? ne(ne(e, xe.ajaxSettings), t) : ne(xe.ajaxSettings, e)
        },
        ajaxPrefilter: ee(Rt),
        ajaxTransport: ee(Wt),
        ajax: function(t, n) {
            function i(t, n, i, a) {
                var u, f, h, w, x, _ = n;
                c || (c = !0,
                l && e.clearTimeout(l),
                r = void 0,
                s = a || "",
                C.readyState = t > 0 ? 4 : 0,
                u = t >= 200 && t < 300 || 304 === t,
                i && (w = ie(p, C, i)),
                w = re(p, w, C, u),
                u ? (p.ifModified && ((x = C.getResponseHeader("Last-Modified")) && (xe.lastModified[o] = x),
                (x = C.getResponseHeader("etag")) && (xe.etag[o] = x)),
                204 === t || "HEAD" === p.type ? _ = "nocontent" : 304 === t ? _ = "notmodified" : (_ = w.state,
                f = w.data,
                u = !(h = w.error))) : (h = _,
                !t && _ || (_ = "error",
                t < 0 && (t = 0))),
                C.status = t,
                C.statusText = (n || _) + "",
                u ? v.resolveWith(m, [f, _, C]) : v.rejectWith(m, [C, _, h]),
                C.statusCode(b),
                b = void 0,
                d && g.trigger(u ? "ajaxSuccess" : "ajaxError", [C, p, u ? f : h]),
                y.fireWith(m, [C, _]),
                d && (g.trigger("ajaxComplete", [C, p]),
                --xe.active || xe.event.trigger("ajaxStop")))
            }
            "object" == typeof t && (n = t,
            t = void 0),
            n = n || {};
            var r, o, s, a, l, u, c, d, f, h, p = xe.ajaxSetup({}, n), m = p.context || p, g = p.context && (m.nodeType || m.jquery) ? xe(m) : xe.event, v = xe.Deferred(), y = xe.Callbacks("once memory"), b = p.statusCode || {}, w = {}, x = {}, _ = "canceled", C = {
                readyState: 0,
                getResponseHeader: function(e) {
                    var t;
                    if (c) {
                        if (!a)
                            for (a = {}; t = Ft.exec(s); )
                                a[t[1].toLowerCase()] = t[2];
                        t = a[e.toLowerCase()]
                    }
                    return null == t ? null : t
                },
                getAllResponseHeaders: function() {
                    return c ? s : null
                },
                setRequestHeader: function(e, t) {
                    return null == c && (e = x[e.toLowerCase()] = x[e.toLowerCase()] || e,
                    w[e] = t),
                    this
                },
                overrideMimeType: function(e) {
                    return null == c && (p.mimeType = e),
                    this
                },
                statusCode: function(e) {
                    var t;
                    if (e)
                        if (c)
                            C.always(e[C.status]);
                        else
                            for (t in e)
                                b[t] = [b[t], e[t]];
                    return this
                },
                abort: function(e) {
                    var t = e || _;
                    return r && r.abort(t),
                    i(0, t),
                    this
                }
            };
            if (v.promise(C),
            p.url = ((t || p.url || At.href) + "").replace(Ht, At.protocol + "//"),
            p.type = n.method || n.type || p.method || p.type,
            p.dataTypes = (p.dataType || "*").toLowerCase().match(ze) || [""],
            null == p.crossDomain) {
                u = se.createElement("a");
                try {
                    u.href = p.url,
                    u.href = u.href,
                    p.crossDomain = $t.protocol + "//" + $t.host != u.protocol + "//" + u.host
                } catch (e) {
                    p.crossDomain = !0
                }
            }
            if (p.data && p.processData && "string" != typeof p.data && (p.data = xe.param(p.data, p.traditional)),
            te(Rt, p, n, C),
            c)
                return C;
            (d = xe.event && p.global) && 0 == xe.active++ && xe.event.trigger("ajaxStart"),
            p.type = p.type.toUpperCase(),
            p.hasContent = !Bt.test(p.type),
            o = p.url.replace(Mt, ""),
            p.hasContent ? p.data && p.processData && 0 === (p.contentType || "").indexOf("application/x-www-form-urlencoded") && (p.data = p.data.replace(jt, "+")) : (h = p.url.slice(o.length),
            p.data && (p.processData || "string" == typeof p.data) && (o += (Dt.test(o) ? "&" : "?") + p.data,
            delete p.data),
            !1 === p.cache && (o = o.replace(Ot, "$1"),
            h = (Dt.test(o) ? "&" : "?") + "_=" + It++ + h),
            p.url = o + h),
            p.ifModified && (xe.lastModified[o] && C.setRequestHeader("If-Modified-Since", xe.lastModified[o]),
            xe.etag[o] && C.setRequestHeader("If-None-Match", xe.etag[o])),
            (p.data && p.hasContent && !1 !== p.contentType || n.contentType) && C.setRequestHeader("Content-Type", p.contentType),
            C.setRequestHeader("Accept", p.dataTypes[0] && p.accepts[p.dataTypes[0]] ? p.accepts[p.dataTypes[0]] + ("*" !== p.dataTypes[0] ? ", " + Ut + "; q=0.01" : "") : p.accepts["*"]);
            for (f in p.headers)
                C.setRequestHeader(f, p.headers[f]);
            if (p.beforeSend && (!1 === p.beforeSend.call(m, C, p) || c))
                return C.abort();
            if (_ = "abort",
            y.add(p.complete),
            C.done(p.success),
            C.fail(p.error),
            r = te(Wt, p, n, C)) {
                if (C.readyState = 1,
                d && g.trigger("ajaxSend", [C, p]),
                c)
                    return C;
                p.async && p.timeout > 0 && (l = e.setTimeout(function() {
                    C.abort("timeout")
                }, p.timeout));
                try {
                    c = !1,
                    r.send(w, i)
                } catch (e) {
                    if (c)
                        throw e;
                    i(-1, e)
                }
            } else
                i(-1, "No Transport");
            return C
        },
        getJSON: function(e, t, n) {
            return xe.get(e, t, n, "json")
        },
        getScript: function(e, t) {
            return xe.get(e, void 0, t, "script")
        }
    }),
    xe.each(["get", "post"], function(e, t) {
        xe[t] = function(e, n, i, r) {
            return ye(n) && (r = r || i,
            i = n,
            n = void 0),
            xe.ajax(xe.extend({
                url: e,
                type: t,
                dataType: r,
                data: n,
                success: i
            }, xe.isPlainObject(e) && e))
        }
    }),
    xe._evalUrl = function(e) {
        return xe.ajax({
            url: e,
            type: "GET",
            dataType: "script",
            cache: !0,
            async: !1,
            global: !1,
            throws: !0
        })
    }
    ,
    xe.fn.extend({
        wrapAll: function(e) {
            var t;
            return this[0] && (ye(e) && (e = e.call(this[0])),
            t = xe(e, this[0].ownerDocument).eq(0).clone(!0),
            this[0].parentNode && t.insertBefore(this[0]),
            t.map(function() {
                for (var e = this; e.firstElementChild; )
                    e = e.firstElementChild;
                return e
            }).append(this)),
            this
        },
        wrapInner: function(e) {
            return ye(e) ? this.each(function(t) {
                xe(this).wrapInner(e.call(this, t))
            }) : this.each(function() {
                var t = xe(this)
                  , n = t.contents();
                n.length ? n.wrapAll(e) : t.append(e)
            })
        },
        wrap: function(e) {
            var t = ye(e);
            return this.each(function(n) {
                xe(this).wrapAll(t ? e.call(this, n) : e)
            })
        },
        unwrap: function(e) {
            return this.parent(e).not("body").each(function() {
                xe(this).replaceWith(this.childNodes)
            }),
            this
        }
    }),
    xe.expr.pseudos.hidden = function(e) {
        return !xe.expr.pseudos.visible(e)
    }
    ,
    xe.expr.pseudos.visible = function(e) {
        return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length)
    }
    ,
    xe.ajaxSettings.xhr = function() {
        try {
            return new e.XMLHttpRequest
        } catch (e) {}
    }
    ;
    var Vt = {
        0: 200,
        1223: 204
    }
      , Qt = xe.ajaxSettings.xhr();
    ve.cors = !!Qt && "withCredentials"in Qt,
    ve.ajax = Qt = !!Qt,
    xe.ajaxTransport(function(t) {
        var n, i;
        if (ve.cors || Qt && !t.crossDomain)
            return {
                send: function(r, o) {
                    var s, a = t.xhr();
                    if (a.open(t.type, t.url, t.async, t.username, t.password),
                    t.xhrFields)
                        for (s in t.xhrFields)
                            a[s] = t.xhrFields[s];
                    t.mimeType && a.overrideMimeType && a.overrideMimeType(t.mimeType),
                    t.crossDomain || r["X-Requested-With"] || (r["X-Requested-With"] = "XMLHttpRequest");
                    for (s in r)
                        a.setRequestHeader(s, r[s]);
                    n = function(e) {
                        return function() {
                            n && (n = i = a.onload = a.onerror = a.onabort = a.ontimeout = a.onreadystatechange = null,
                            "abort" === e ? a.abort() : "error" === e ? "number" != typeof a.status ? o(0, "error") : o(a.status, a.statusText) : o(Vt[a.status] || a.status, a.statusText, "text" !== (a.responseType || "text") || "string" != typeof a.responseText ? {
                                binary: a.response
                            } : {
                                text: a.responseText
                            }, a.getAllResponseHeaders()))
                        }
                    }
                    ,
                    a.onload = n(),
                    i = a.onerror = a.ontimeout = n("error"),
                    void 0 !== a.onabort ? a.onabort = i : a.onreadystatechange = function() {
                        4 === a.readyState && e.setTimeout(function() {
                            n && i()
                        })
                    }
                    ,
                    n = n("abort");
                    try {
                        a.send(t.hasContent && t.data || null)
                    } catch (e) {
                        if (n)
                            throw e
                    }
                },
                abort: function() {
                    n && n()
                }
            }
    }),
    xe.ajaxPrefilter(function(e) {
        e.crossDomain && (e.contents.script = !1)
    }),
    xe.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(e) {
                return xe.globalEval(e),
                e
            }
        }
    }),
    xe.ajaxPrefilter("script", function(e) {
        void 0 === e.cache && (e.cache = !1),
        e.crossDomain && (e.type = "GET")
    }),
    xe.ajaxTransport("script", function(e) {
        if (e.crossDomain) {
            var t, n;
            return {
                send: function(i, r) {
                    t = xe("<script>").prop({
                        charset: e.scriptCharset,
                        src: e.url
                    }).on("load error", n = function(e) {
                        t.remove(),
                        n = null,
                        e && r("error" === e.type ? 404 : 200, e.type)
                    }
                    ),
                    se.head.appendChild(t[0])
                },
                abort: function() {
                    n && n()
                }
            }
        }
    });
    var Yt = []
      , Xt = /(=)\?(?=&|$)|\?\?/;
    xe.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var e = Yt.pop() || xe.expando + "_" + It++;
            return this[e] = !0,
            e
        }
    }),
    xe.ajaxPrefilter("json jsonp", function(t, n, i) {
        var r, o, s, a = !1 !== t.jsonp && (Xt.test(t.url) ? "url" : "string" == typeof t.data && 0 === (t.contentType || "").indexOf("application/x-www-form-urlencoded") && Xt.test(t.data) && "data");
        if (a || "jsonp" === t.dataTypes[0])
            return r = t.jsonpCallback = ye(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback,
            a ? t[a] = t[a].replace(Xt, "$1" + r) : !1 !== t.jsonp && (t.url += (Dt.test(t.url) ? "&" : "?") + t.jsonp + "=" + r),
            t.converters["script json"] = function() {
                return s || xe.error(r + " was not called"),
                s[0]
            }
            ,
            t.dataTypes[0] = "json",
            o = e[r],
            e[r] = function() {
                s = arguments
            }
            ,
            i.always(function() {
                void 0 === o ? xe(e).removeProp(r) : e[r] = o,
                t[r] && (t.jsonpCallback = n.jsonpCallback,
                Yt.push(r)),
                s && ye(o) && o(s[0]),
                s = o = void 0
            }),
            "script"
    }),
    ve.createHTMLDocument = function() {
        var e = se.implementation.createHTMLDocument("").body;
        return e.innerHTML = "<form></form><form></form>",
        2 === e.childNodes.length
    }(),
    xe.parseHTML = function(e, t, n) {
        if ("string" != typeof e)
            return [];
        "boolean" == typeof t && (n = t,
        t = !1);
        var i, r, o;
        return t || (ve.createHTMLDocument ? ((i = (t = se.implementation.createHTMLDocument("")).createElement("base")).href = se.location.href,
        t.head.appendChild(i)) : t = se),
        r = ke.exec(e),
        o = !n && [],
        r ? [t.createElement(r[1])] : (r = C([e], t, o),
        o && o.length && xe(o).remove(),
        xe.merge([], r.childNodes))
    }
    ,
    xe.fn.load = function(e, t, n) {
        var i, r, o, s = this, a = e.indexOf(" ");
        return a > -1 && (i = G(e.slice(a)),
        e = e.slice(0, a)),
        ye(t) ? (n = t,
        t = void 0) : t && "object" == typeof t && (r = "POST"),
        s.length > 0 && xe.ajax({
            url: e,
            type: r || "GET",
            dataType: "html",
            data: t
        }).done(function(e) {
            o = arguments,
            s.html(i ? xe("<div>").append(xe.parseHTML(e)).find(i) : e)
        }).always(n && function(e, t) {
            s.each(function() {
                n.apply(this, o || [e.responseText, t, e])
            })
        }
        ),
        this
    }
    ,
    xe.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(e, t) {
        xe.fn[t] = function(e) {
            return this.on(t, e)
        }
    }),
    xe.expr.pseudos.animated = function(e) {
        return xe.grep(xe.timers, function(t) {
            return e === t.elem
        }).length
    }
    ,
    xe.offset = {
        setOffset: function(e, t, n) {
            var i, r, o, s, a, l, u, c = xe.css(e, "position"), d = xe(e), f = {};
            "static" === c && (e.style.position = "relative"),
            a = d.offset(),
            o = xe.css(e, "top"),
            l = xe.css(e, "left"),
            (u = ("absolute" === c || "fixed" === c) && (o + l).indexOf("auto") > -1) ? (s = (i = d.position()).top,
            r = i.left) : (s = parseFloat(o) || 0,
            r = parseFloat(l) || 0),
            ye(t) && (t = t.call(e, n, xe.extend({}, a))),
            null != t.top && (f.top = t.top - a.top + s),
            null != t.left && (f.left = t.left - a.left + r),
            "using"in t ? t.using.call(e, f) : d.css(f)
        }
    },
    xe.fn.extend({
        offset: function(e) {
            if (arguments.length)
                return void 0 === e ? this : this.each(function(t) {
                    xe.offset.setOffset(this, e, t)
                });
            var t, n, i = this[0];
            return i ? i.getClientRects().length ? (t = i.getBoundingClientRect(),
            n = i.ownerDocument.defaultView,
            {
                top: t.top + n.pageYOffset,
                left: t.left + n.pageXOffset
            }) : {
                top: 0,
                left: 0
            } : void 0
        },
        position: function() {
            if (this[0]) {
                var e, t, n, i = this[0], r = {
                    top: 0,
                    left: 0
                };
                if ("fixed" === xe.css(i, "position"))
                    t = i.getBoundingClientRect();
                else {
                    for (t = this.offset(),
                    n = i.ownerDocument,
                    e = i.offsetParent || n.documentElement; e && (e === n.body || e === n.documentElement) && "static" === xe.css(e, "position"); )
                        e = e.parentNode;
                    e && e !== i && 1 === e.nodeType && ((r = xe(e).offset()).top += xe.css(e, "borderTopWidth", !0),
                    r.left += xe.css(e, "borderLeftWidth", !0))
                }
                return {
                    top: t.top - r.top - xe.css(i, "marginTop", !0),
                    left: t.left - r.left - xe.css(i, "marginLeft", !0)
                }
            }
        },
        offsetParent: function() {
            return this.map(function() {
                for (var e = this.offsetParent; e && "static" === xe.css(e, "position"); )
                    e = e.offsetParent;
                return e || et
            })
        }
    }),
    xe.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(e, t) {
        var n = "pageYOffset" === t;
        xe.fn[e] = function(i) {
            return je(this, function(e, i, r) {
                var o;
                return be(e) ? o = e : 9 === e.nodeType && (o = e.defaultView),
                void 0 === r ? o ? o[t] : e[i] : void (o ? o.scrollTo(n ? o.pageXOffset : r, n ? r : o.pageYOffset) : e[i] = r)
            }, e, i, arguments.length)
        }
    }),
    xe.each(["top", "left"], function(e, t) {
        xe.cssHooks[t] = M(ve.pixelPosition, function(e, n) {
            if (n)
                return n = j(e, t),
                lt.test(n) ? xe(e).position()[t] + "px" : n
        })
    }),
    xe.each({
        Height: "height",
        Width: "width"
    }, function(e, t) {
        xe.each({
            padding: "inner" + e,
            content: t,
            "": "outer" + e
        }, function(n, i) {
            xe.fn[i] = function(r, o) {
                var s = arguments.length && (n || "boolean" != typeof r)
                  , a = n || (!0 === r || !0 === o ? "margin" : "border");
                return je(this, function(t, n, r) {
                    var o;
                    return be(t) ? 0 === i.indexOf("outer") ? t["inner" + e] : t.document.documentElement["client" + e] : 9 === t.nodeType ? (o = t.documentElement,
                    Math.max(t.body["scroll" + e], o["scroll" + e], t.body["offset" + e], o["offset" + e], o["client" + e])) : void 0 === r ? xe.css(t, n, a) : xe.style(t, n, r, a)
                }, t, s ? r : void 0, s)
            }
        })
    }),
    xe.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(e, t) {
        xe.fn[t] = function(e, n) {
            return arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t)
        }
    }),
    xe.fn.extend({
        hover: function(e, t) {
            return this.mouseenter(e).mouseleave(t || e)
        }
    }),
    xe.fn.extend({
        bind: function(e, t, n) {
            return this.on(e, null, t, n)
        },
        unbind: function(e, t) {
            return this.off(e, null, t)
        },
        delegate: function(e, t, n, i) {
            return this.on(t, e, n, i)
        },
        undelegate: function(e, t, n) {
            return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n)
        }
    }),
    xe.proxy = function(e, t) {
        var n, i, r;
        if ("string" == typeof t && (n = e[t],
        t = e,
        e = n),
        ye(e))
            return i = le.call(arguments, 2),
            r = function() {
                return e.apply(t || this, i.concat(le.call(arguments)))
            }
            ,
            r.guid = e.guid = e.guid || xe.guid++,
            r
    }
    ,
    xe.holdReady = function(e) {
        e ? xe.readyWait++ : xe.ready(!0)
    }
    ,
    xe.isArray = Array.isArray,
    xe.parseJSON = JSON.parse,
    xe.nodeName = o,
    xe.isFunction = ye,
    xe.isWindow = be,
    xe.camelCase = p,
    xe.type = i,
    xe.now = Date.now,
    xe.isNumeric = function(e) {
        var t = xe.type(e);
        return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e))
    }
    ,
    "function" == typeof define && define.amd && define("jquery", [], function() {
        return xe
    });
    var Gt = e.jQuery
      , Jt = e.$;
    return xe.noConflict = function(t) {
        return e.$ === xe && (e.$ = Jt),
        t && e.jQuery === xe && (e.jQuery = Gt),
        xe
    }
    ,
    t || (e.jQuery = e.$ = xe),
    xe
});
var jq223 = jQuery.noConflict(!0)
  , $ = jq223;
!function(e) {
    var t = window.jQuery = e;
    /*!
   * querystring.js
   */
    !function(e) {
        e.QueryString = function(e) {
            if ("" == e)
                return {};
            for (var t = {}, n = 0; n < e.length; ++n) {
                var i = e[n].split("=");
                2 == i.length && (t[i[0]] = decodeURIComponent(i[1].replace(/\+/g, " ")))
            }
            return t
        }(window.location.search.substr(1).split("&"))
    }(t),
    /*!
   * detect-element-resize.js
   */
    function() {
        function e(e) {
            var t = e.__resizeTriggers__
              , n = t.firstElementChild
              , i = t.lastElementChild
              , r = n.firstElementChild;
            i.scrollLeft = i.scrollWidth,
            i.scrollTop = i.scrollHeight,
            r.style.width = n.offsetWidth + 1 + "px",
            r.style.height = n.offsetHeight + 1 + "px",
            n.scrollLeft = n.scrollWidth,
            n.scrollTop = n.scrollHeight
        }
        function t(e) {
            return e.offsetWidth != e.__resizeLast__.width || e.offsetHeight != e.__resizeLast__.height
        }
        function n(n) {
            var i = this;
            e(this),
            this.__resizeRAF__ && a(this.__resizeRAF__),
            this.__resizeRAF__ = s(function() {
                t(i) && (i.__resizeLast__.width = i.offsetWidth,
                i.__resizeLast__.height = i.offsetHeight,
                i.__resizeListeners__.forEach(function(e) {
                    e.call(i, n)
                }))
            })
        }
        function i() {
            if (!o) {
                var e = (y ? y : "") + ".resize-triggers { " + (b ? b : "") + 'visibility: hidden; opacity: 0; } .resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }'
                  , t = document.head || document.getElementsByTagName("head")[0]
                  , n = document.createElement("style");
                n.type = "text/css",
                n.styleSheet ? n.styleSheet.cssText = e : n.appendChild(document.createTextNode(e)),
                t.appendChild(n),
                o = !0
            }
        }
        var r = document.attachEvent
          , o = !1;
        if (!r) {
            var s = function() {
                var e = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function(e) {
                    return window.setTimeout(e, 20)
                }
                ;
                return function(t) {
                    return e(t)
                }
            }()
              , a = function() {
                var e = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame || window.clearTimeout;
                return function(t) {
                    return e(t)
                }
            }()
              , l = !1
              , u = "animation"
              , c = ""
              , d = "animationstart"
              , f = "Webkit Moz O ms".split(" ")
              , h = "webkitAnimationStart animationstart oAnimationStart MSAnimationStart".split(" ")
              , p = ""
              , m = document.createElement("fakeelement");
            if (void 0 !== m.style.animationName && (l = !0),
            l === !1)
                for (var g = 0; g < f.length; g++)
                    if (void 0 !== m.style[f[g] + "AnimationName"]) {
                        p = f[g],
                        u = p + "Animation",
                        c = "-" + p.toLowerCase() + "-",
                        d = h[g],
                        l = !0;
                        break
                    }
            var v = "resizeanim"
              , y = "@" + c + "keyframes " + v + " { from { opacity: 0; } to { opacity: 0; } } "
              , b = c + "animation: 1ms " + v + "; "
        }
        window.addResizeListener = function(t, o) {
            r ? t.attachEvent("onresize", o) : (t.__resizeTriggers__ || ("static" == getComputedStyle(t).position && (t.style.position = "relative"),
            i(),
            t.__resizeLast__ = {},
            t.__resizeListeners__ = [],
            (t.__resizeTriggers__ = document.createElement("div")).className = "resize-triggers",
            t.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div><div class="contract-trigger"></div>',
            t.appendChild(t.__resizeTriggers__),
            e(t),
            t.addEventListener("scroll", n, !0),
            d && t.__resizeTriggers__.addEventListener(d, function(n) {
                n.animationName == v && e(t)
            })),
            t.__resizeListeners__.push(o))
        }
        ,
        window.removeResizeListener = function(e, t) {
            r ? e.detachEvent("onresize", t) : (e.__resizeListeners__.splice(e.__resizeListeners__.indexOf(t), 1),
            e.__resizeListeners__.length || (e.removeEventListener("scroll", n),
            e.__resizeTriggers__ = !e.removeChild(e.__resizeTriggers__)))
        }
    }(),
    function(e) {
        function n(e) {
            var t = e.__resizeTriggers__
              , n = t.firstElementChild
              , i = t.lastElementChild
              , r = n.firstElementChild;
            i.scrollLeft = i.scrollWidth,
            i.scrollTop = i.scrollHeight,
            r.style.width = n.offsetWidth + 1 + "px",
            r.style.height = n.offsetHeight + 1 + "px",
            n.scrollLeft = n.scrollWidth,
            n.scrollTop = n.scrollHeight
        }
        function i(e) {
            return e.offsetWidth != e.__resizeLast__.width || e.offsetHeight != e.__resizeLast__.height
        }
        function r(e) {
            var t = this;
            n(this),
            this.__resizeRAF__ && c(this.__resizeRAF__),
            this.__resizeRAF__ = u(function() {
                i(t) && (t.__resizeLast__.width = t.offsetWidth,
                t.__resizeLast__.height = t.offsetHeight,
                t.__resizeListeners__.forEach(function(n) {
                    n.call(t, e)
                }))
            })
        }
        function o() {
            if (!a) {
                var e = (x ? x : "") + ".resize-triggers { " + (_ ? _ : "") + 'visibility: hidden; opacity: 0; } .resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }'
                  , t = document.head || document.getElementsByTagName("head")[0]
                  , n = document.createElement("style");
                n.type = "text/css",
                n.styleSheet ? n.styleSheet.cssText = e : n.appendChild(document.createTextNode(e)),
                t.appendChild(n),
                a = !0
            }
        }
        var s = document.attachEvent
          , a = !1
          , l = e.fn.resize;
        if (e.fn.resize = function(e) {
            return this.each(function() {
                this == window ? l.call(t(this), e) : addResizeListener(this, e)
            })
        }
        ,
        e.fn.removeResize = function(e) {
            return this.each(function() {
                removeResizeListener(this, e)
            })
        }
        ,
        !s) {
            var u = function() {
                var e = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function(e) {
                    return window.setTimeout(e, 20)
                }
                ;
                return function(t) {
                    return e(t)
                }
            }()
              , c = function() {
                var e = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame || window.clearTimeout;
                return function(t) {
                    return e(t)
                }
            }()
              , d = !1
              , f = "animation"
              , h = ""
              , p = "animationstart"
              , m = "Webkit Moz O ms".split(" ")
              , g = "webkitAnimationStart animationstart oAnimationStart MSAnimationStart".split(" ")
              , v = ""
              , y = document.createElement("fakeelement");
            if (void 0 !== y.style.animationName && (d = !0),
            d === !1)
                for (var b = 0; b < m.length; b++)
                    if (void 0 !== y.style[m[b] + "AnimationName"]) {
                        v = m[b],
                        f = v + "Animation",
                        h = "-" + v.toLowerCase() + "-",
                        p = g[b],
                        d = !0;
                        break
                    }
            var w = "resizeanim"
              , x = "@" + h + "keyframes " + w + " { from { opacity: 0; } to { opacity: 0; } } "
              , _ = h + "animation: 1ms " + w + "; "
        }
        window.addResizeListener = function(e, t) {
            s ? e.attachEvent("onresize", t) : (e.__resizeTriggers__ || ("static" == getComputedStyle(e).position && (e.style.position = "relative"),
            o(),
            e.__resizeLast__ = {},
            e.__resizeListeners__ = [],
            (e.__resizeTriggers__ = document.createElement("div")).className = "resize-triggers",
            e.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div><div class="contract-trigger"></div>',
            e.appendChild(e.__resizeTriggers__),
            n(e),
            e.addEventListener("scroll", r, !0),
            p && e.__resizeTriggers__.addEventListener(p, function(t) {
                t.animationName == w && n(e)
            })),
            e.__resizeListeners__.push(t))
        }
        ,
        window.removeResizeListener = function(e, t) {
            s ? e.detachEvent("onresize", t) : (e.__resizeListeners__.splice(e.__resizeListeners__.indexOf(t), 1),
            e.__resizeListeners__.length || (e.removeEventListener("scroll", r),
            e.__resizeTriggers__ = !e.removeChild(e.__resizeTriggers__)))
        }
    }(t);
    /*!
   * fixto.js
   * https://github.com/bbarakaci/fixto
   */
    /*! fixto - v0.5.0 - 2016-06-16
  * http://github.com/bbarakaci/fixto/*/
    (function(e, t, n) {
        function i() {
            this._vendor = null
        }
        function r() {
            var e = !1
              , t = n.createElement("div")
              , i = n.createElement("div");
            t.appendChild(i),
            t.style[h] = "translate(0)",
            t.style.marginTop = "10px",
            t.style.visibility = "hidden",
            i.style.position = "fixed",
            i.style.top = 0,
            n.body.appendChild(t);
            var r = i.getBoundingClientRect();
            return r.top > 0 && (e = !0),
            n.body.removeChild(t),
            e
        }
        function o() {
            var e = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
            return !!e && parseInt(e[2], 10)
        }
        function s(t, n, i) {
            this.child = t,
            this._$child = e(t),
            this.parent = n,
            this.options = {
                className: "fixto-fixed",
                top: 0,
                mindViewport: !1
            },
            this._setOptions(i)
        }
        function a(e, t, n) {
            s.call(this, e, t, n),
            this._replacer = new c.MimicNode(e),
            this._ghostNode = this._replacer.replacer,
            this._saveStyles(),
            this._saveViewportHeight(),
            this._proxied_onscroll = this._bind(this._onscroll, this),
            this._proxied_onresize = this._bind(this._onresize, this),
            this.start()
        }
        function l(e, t, n) {
            s.call(this, e, t, n),
            this.start()
        }
        /*! Computed Style - v0.1.0 - 2012-07-19
      * https://github.com/bbarakaci/computed-style
      * Copyright (c) 2012 Burak Barakaci; Licensed MIT */
        var u = function() {
            var e = {
                getAll: function(e) {
                    return n.defaultView.getComputedStyle(e)
                },
                get: function(e, t) {
                    return this.getAll(e)[t]
                },
                toFloat: function(e) {
                    return parseFloat(e, 10) || 0
                },
                getFloat: function(e, t) {
                    return this.toFloat(this.get(e, t))
                },
                _getAllCurrentStyle: function(e) {
                    return e.currentStyle
                }
            };
            return n.documentElement.currentStyle && (e.getAll = e._getAllCurrentStyle),
            e
        }()
          , c = function() {
            function t(e) {
                this.element = e,
                this.replacer = n.createElement("div"),
                this.replacer.style.visibility = "hidden",
                this.hide(),
                e.parentNode.insertBefore(this.replacer, e)
            }
            t.prototype = {
                replace: function() {
                    var e = this.replacer.style
                      , t = u.getAll(this.element);
                    e.width = this._width(),
                    e.height = this._height(),
                    e.marginTop = t.marginTop,
                    e.marginBottom = t.marginBottom,
                    e.marginLeft = t.marginLeft,
                    e.marginRight = t.marginRight,
                    e.cssFloat = t.cssFloat,
                    e.styleFloat = t.styleFloat,
                    e.position = t.position,
                    e.top = t.top,
                    e.right = t.right,
                    e.bottom = t.bottom,
                    e.left = t.left,
                    e.display = t.display
                },
                hide: function() {
                    this.replacer.style.display = "none"
                },
                _width: function() {
                    return this.element.getBoundingClientRect().width + "px"
                },
                _widthOffset: function() {
                    return this.element.offsetWidth + "px"
                },
                _height: function() {
                    return this.element.getBoundingClientRect().height + "px"
                },
                _heightOffset: function() {
                    return this.element.offsetHeight + "px"
                },
                destroy: function() {
                    e(this.replacer).remove();
                    for (var t in this)
                        this.hasOwnProperty(t) && (this[t] = null)
                }
            };
            var i = n.documentElement.getBoundingClientRect();
            return i.width || (t.prototype._width = t.prototype._widthOffset,
            t.prototype._height = t.prototype._heightOffset),
            {
                MimicNode: t,
                computedStyle: u
            }
        }();
        i.prototype = {
            _vendors: {
                webkit: {
                    cssPrefix: "-webkit-",
                    jsPrefix: "Webkit"
                },
                moz: {
                    cssPrefix: "-moz-",
                    jsPrefix: "Moz"
                },
                ms: {
                    cssPrefix: "-ms-",
                    jsPrefix: "ms"
                },
                opera: {
                    cssPrefix: "-o-",
                    jsPrefix: "O"
                }
            },
            _prefixJsProperty: function(e, t) {
                return e.jsPrefix + t[0].toUpperCase() + t.substr(1)
            },
            _prefixValue: function(e, t) {
                return e.cssPrefix + t
            },
            _valueSupported: function(e, t, n) {
                try {
                    return n.style[e] = t,
                    n.style[e] === t
                } catch (e) {
                    return !1
                }
            },
            propertySupported: function(e) {
                return void 0 !== n.documentElement.style[e]
            },
            getJsProperty: function(e) {
                if (this.propertySupported(e))
                    return e;
                if (this._vendor)
                    return this._prefixJsProperty(this._vendor, e);
                var t;
                for (var n in this._vendors)
                    if (t = this._prefixJsProperty(this._vendors[n], e),
                    this.propertySupported(t))
                        return this._vendor = this._vendors[n],
                        t;
                return null
            },
            getCssValue: function(e, t) {
                var i = n.createElement("div")
                  , r = this.getJsProperty(e);
                if (this._valueSupported(r, t, i))
                    return t;
                var o;
                if (this._vendor && (o = this._prefixValue(this._vendor, t),
                this._valueSupported(r, o, i)))
                    return o;
                for (var s in this._vendors)
                    if (o = this._prefixValue(this._vendors[s], t),
                    this._valueSupported(r, o, i))
                        return this._vendor = this._vendors[s],
                        o;
                return null
            }
        };
        var d, f = new i, h = f.getJsProperty("transform"), p = f.getCssValue("position", "sticky");
        "56" == o() && (p = null);
        var m, g = f.getCssValue("position", "fixed"), v = "Microsoft Internet Explorer" === navigator.appName;
        v && (m = parseFloat(navigator.appVersion.split("MSIE")[1])),
        s.prototype = {
            _mindtop: function() {
                var e = 0;
                if (this._$mind)
                    for (var t, n, i = 0, r = this._$mind.length; i < r; i++)
                        if (t = this._$mind[i],
                        n = t.getBoundingClientRect(),
                        n.height)
                            e += n.height;
                        else {
                            var o = u.getAll(t);
                            e += t.offsetHeight + u.toFloat(o.marginTop) + u.toFloat(o.marginBottom)
                        }
                return e
            },
            stop: function() {
                this._stop(),
                this._running = !1
            },
            start: function() {
                this._running || (this._start(),
                this._running = !0)
            },
            destroy: function() {
                this.stop(),
                this._destroy(),
                this._$child.removeData("fixto-instance");
                for (var e in this)
                    this.hasOwnProperty(e) && (this[e] = null)
            },
            _setOptions: function(t) {
                e.extend(this.options, t),
                this.options.mind && (this._$mind = e(this.options.mind)),
                this.options.zIndex && (this.child.style.zIndex = this.options.zIndex)
            },
            setOptions: function(e) {
                this._setOptions(e),
                this.refresh()
            },
            _stop: function() {},
            _start: function() {},
            _destroy: function() {},
            refresh: function() {}
        },
        a.prototype = new s,
        e.extend(a.prototype, {
            _bind: function(e, t) {
                return function() {
                    return e.call(t)
                }
            },
            _toresize: 8 === m ? n.documentElement : t,
            _onscroll: function() {
                if (this._scrollTop = n.documentElement.scrollTop || n.body.scrollTop,
                this._parentBottom = this.parent.offsetHeight + this._fullOffset("offsetTop", this.parent),
                this.options.mindBottomPadding !== !1 && (this._parentBottom -= u.getFloat(this.parent, "paddingBottom")),
                !this.fixed && this._shouldFix())
                    this._fix(),
                    this._adjust();
                else {
                    if (this._scrollTop > this._parentBottom || this._scrollTop < this._fullOffset("offsetTop", this._ghostNode) - this.options.top - this._mindtop())
                        return void this._unfix();
                    this._adjust()
                }
            },
            _shouldFix: function() {
                if (this._scrollTop < this._parentBottom && this._scrollTop > this._fullOffset("offsetTop", this.child) - this.options.top - this._mindtop())
                    return !(this.options.mindViewport && !this._isViewportAvailable())
            },
            _isViewportAvailable: function() {
                var e = u.getAll(this.child);
                return this._viewportHeight > this.child.offsetHeight + u.toFloat(e.marginTop) + u.toFloat(e.marginBottom)
            },
            _adjust: function() {
                var e = 0
                  , t = this._mindtop()
                  , n = 0
                  , i = u.getAll(this.child)
                  , r = null;
                d && (r = this._getContext(),
                r && (e = Math.abs(r.getBoundingClientRect().top))),
                n = this._parentBottom - this._scrollTop - (this.child.offsetHeight + u.toFloat(i.marginBottom) + t + this.options.top),
                n > 0 && (n = 0),
                this.child.style.top = n + t + e + this.options.top - u.toFloat(i.marginTop) + "px"
            },
            _fullOffset: function(e, t, n) {
                for (var i = t[e], r = t.offsetParent; null !== r && r !== n; )
                    i += r[e],
                    r = r.offsetParent;
                return i
            },
            _getContext: function() {
                for (var e, t, i = this.child, r = null; !r; ) {
                    if (e = i.parentNode,
                    e === n.documentElement)
                        return null;
                    if (t = u.getAll(e),
                    "none" !== t[h]) {
                        r = e;
                        break
                    }
                    i = e
                }
                return r
            },
            _fix: function() {
                var e = this.child
                  , t = e.style
                  , i = u.getAll(e)
                  , r = e.getBoundingClientRect().left
                  , o = i.width;
                if (this._saveStyles(),
                n.documentElement.currentStyle && (o = e.offsetWidth - (u.toFloat(i.paddingLeft) + u.toFloat(i.paddingRight) + u.toFloat(i.borderLeftWidth) + u.toFloat(i.borderRightWidth)) + "px"),
                d) {
                    var s = this._getContext();
                    s && (r = e.getBoundingClientRect().left - s.getBoundingClientRect().left)
                }
                this._replacer.replace(),
                t.left = r - u.toFloat(i.marginLeft) + "px",
                t.width = o,
                t.position = "fixed",
                t.top = this._mindtop() + this.options.top - u.toFloat(i.marginTop) + "px",
                this._$child.addClass(this.options.className),
                this.fixed = !0
            },
            _unfix: function() {
                var e = this.child.style;
                this._replacer.hide(),
                e.position = this._childOriginalPosition,
                e.top = this._childOriginalTop,
                e.width = this._childOriginalWidth,
                e.left = this._childOriginalLeft,
                this._$child.removeClass(this.options.className),
                this.fixed = !1
            },
            _saveStyles: function() {
                var e = this.child.style;
                this._childOriginalPosition = e.position,
                this._childOriginalTop = e.top,
                this._childOriginalWidth = e.width,
                this._childOriginalLeft = e.left
            },
            _onresize: function() {
                this.refresh()
            },
            _saveViewportHeight: function() {
                this._viewportHeight = t.innerHeight || n.documentElement.clientHeight
            },
            _stop: function() {
                this._unfix(),
                e(t).unbind("scroll", this._proxied_onscroll),
                e(this._toresize).unbind("resize", this._proxied_onresize)
            },
            _start: function() {
                this._onscroll(),
                e(t).bind("scroll", this._proxied_onscroll),
                e(this._toresize).bind("resize", this._proxied_onresize)
            },
            _destroy: function() {
                this._replacer.destroy()
            },
            refresh: function() {
                this._saveViewportHeight(),
                this._unfix(),
                this._onscroll()
            }
        }),
        l.prototype = new s,
        e.extend(l.prototype, {
            _start: function() {
                var e = u.getAll(this.child);
                this._childOriginalPosition = e.position,
                this._childOriginalTop = e.top,
                this.child.style.position = p,
                this.refresh()
            },
            _stop: function() {
                this.child.style.position = this._childOriginalPosition,
                this.child.style.top = this._childOriginalTop
            },
            refresh: function() {
                this.child.style.top = this._mindtop() + this.options.top + "px"
            }
        });
        var y = function(e, t, n) {
            return p && !n || p && n && n.useNativeSticky !== !1 ? new l(e,t,n) : g ? (void 0 === d && (d = r()),
            new a(e,t,n)) : "Neither fixed nor sticky positioning supported"
        };
        return m < 8 && (y = function() {
            return "not supported"
        }
        ),
        e.fn.fixTo = function(t, n) {
            var i = e(t)
              , r = 0;
            return this.each(function() {
                var o = e(this).data("fixto-instance");
                if (o) {
                    var s = t;
                    o[s].call(o, n)
                } else
                    e(this).data("fixto-instance", y(this, i[r], n));
                r++
            })
        }
        ,
        {
            FixToContainer: a,
            fixTo: y,
            computedStyle: u,
            mimicNode: c
        }
    }
    )(window.jQuery, window, document);
    /*!
   * jquery.scrollIntoView.js
   * https://github.com/Arwid/jQuery.scrollIntoView/
   */
    /*!
   * $.fn.scrollIntoView - similar to the default browser scrollIntoView
   * The default browser behavior always places the element at the top or bottom of its container. 
   * This override is smart enough to not scroll if the element is already visible.
   *
   * Copyright 2011 Arwid Bancewicz
   * Licensed under the MIT license
   * http://www.opensource.org/licenses/mit-license.php
   * 
   * @date 8 Jan 2013
   * @author Arwid Bancewicz http://arwid.ca
   * @version 0.3
   */
    !function(e) {
        e.fn.scrollIntoView = function(t, n, i) {
            function r(t, n) {
                void 0 === n ? e.isFunction(o.complete) && o.complete.call(t) : o.smooth ? e(t).stop().animate({
                    scrollTop: n
                }, o) : (t.scrollTop = n,
                e.isFunction(o.complete) && o.complete.call(t))
            }
            var o = e.extend({}, e.fn.scrollIntoView.defaults);
            "object" == e.type(t) ? e.extend(o, t) : "number" == e.type(t) ? e.extend(o, {
                duration: t,
                easing: n,
                complete: i
            }) : 0 == t && (o.smooth = !1);
            var s = 1 / 0
              , a = 0;
            1 == this.length ? null == (s = this.get(0).offsetTop) || (a = s + this.get(0).offsetHeight) : this.each(function(e, t) {
                t.offsetTop < s ? s = t.offsetTop : t.offsetTop + t.offsetHeight > a ? a = t.offsetTop + t.offsetHeight : null
            }),
            a -= s;
            for (var l = this.commonAncestor().get(0), u = e(window).height(); l; ) {
                var c = l.scrollTop
                  , d = l.clientHeight;
                if (d > u && (d = u),
                0 == d && "BODY" == l.tagName && (d = u),
                l.scrollTop != (null == (l.scrollTop += 1) || l.scrollTop) && null != (l.scrollTop -= 1) || l.scrollTop != (null == (l.scrollTop -= 1) || l.scrollTop) && null != (l.scrollTop += 1))
                    return void (s <= c ? r(l, s) : s + a > c + d ? r(l, s + a - d) : r(l, void 0));
                l = l.parentNode
            }
            return this
        }
        ,
        e.fn.scrollIntoView.defaults = {
            smooth: !0,
            duration: null,
            easing: e.easing && e.easing.easeOutExpo ? "easeOutExpo" : null,
            complete: e.noop(),
            step: null,
            specialEasing: {}
        },
        e.fn.isOutOfView = function(e) {
            var t = !0;
            return this.each(function() {
                var n = this.parentNode
                  , i = n.scrollTop
                  , r = n.clientHeight
                  , o = this.offsetTop
                  , s = this.offsetHeight;
                (e ? o > i + r : o + s > i + r) || (e ? o + s < i : o < i) || (t = !1)
            }),
            t
        }
        ,
        e.fn.commonAncestor = function() {
            var t = []
              , n = 1 / 0;
            e(this).each(function() {
                var i = e(this).parents();
                t.push(i),
                n = Math.min(n, i.length)
            });
            for (var i = 0; i < t.length; i++)
                t[i] = t[i].slice(t[i].length - n);
            for (var i = 0; i < t[0].length; i++) {
                var r = !0;
                for (var o in t)
                    if (t[o][i] != t[0][i]) {
                        r = !1;
                        break
                    }
                if (r)
                    return e(t[0][i])
            }
            return e([])
        }
    }(t),
    /*!
   * youtubebackground.js
   */
    /*
   * YoutubeBackground - A wrapper for the Youtube API - Great for fullscreen background videos or just regular videos.
   *
   * Licensed under the MIT license:
   *   http://www.opensource.org/licenses/mit-license.php
   *
   *
   * Version:  1.0.5
   *
   */
    "function" != typeof Object.create && (Object.create = function(e) {
        function t() {}
        return t.prototype = e,
        new t
    }
    ),
    function(e, t, n) {
        var i = function(e) {
            var t = n.createElement("script")
              , i = n.getElementsByTagName("head")[0];
            t.src = "//www.youtube.com/iframe_api",
            i.appendChild(t),
            i = null,
            t = null,
            r(e)
        }
          , r = function(n) {
            "undefined" == typeof YT && "undefined" == typeof t.loadingPlayer ? (t.loadingPlayer = !0,
            t.dfd = e.Deferred(),
            t.onYouTubeIframeAPIReady = function() {
                theme.ProductVideo.loadVideos(theme.ProductVideo.hosts.youtube),
                t.onYouTubeIframeAPIReady = null,
                t.dfd.resolve("done"),
                n()
            }
            ) : "object" == typeof YT ? n() : t.dfd.done(function(e) {
                n()
            })
        };
        YTPlayer = {
            player: null,
            defaults: {
                ratio: 16 / 9,
                videoId: "LSmgKRx5pBo",
                mute: !0,
                repeat: !0,
                width: e(t).width(),
                playButtonClass: "YTPlayer-play",
                pauseButtonClass: "YTPlayer-pause",
                muteButtonClass: "YTPlayer-mute",
                volumeUpClass: "YTPlayer-volume-up",
                volumeDownClass: "YTPlayer-volume-down",
                start: 0,
                pauseOnScroll: !1,
                fitToBackground: !0,
                playerVars: {
                    iv_load_policy: 3,
                    modestbranding: 1,
                    autoplay: 1,
                    controls: 0,
                    showinfo: 0,
                    wmode: "opaque",
                    branding: 0,
                    autohide: 0
                },
                events: null
            },
            init: function(n, r) {
                var o = this;
                return o.userOptions = r,
                o.$body = e("body"),
                o.$node = e(n),
                o.$window = e(t),
                o.defaults.events = {
                    onReady: function(e) {
                        o.onPlayerReady(e),
                        o.options.pauseOnScroll && o.pauseOnScroll(),
                        "function" == typeof o.options.callback && o.options.callback.call(this)
                    },
                    onStateChange: function(e) {
                        if (1 === e.data) {
                            o.$node.find("img").fadeOut(400),
                            o.$node.addClass("loaded");
                            var t = o.player.getDuration() - o.player.getCurrentTime();
                            this.rewindTO && clearTimeout(this.rewindTO),
                            this.rewindTO = setTimeout(function() {
                                o.player.seekTo(0)
                            }, 1e3 * (t - .05))
                        } else
                            0 === e.data && o.options.repeat && o.player.seekTo(o.options.start)
                    }
                },
                o.options = e.extend(!0, {}, o.defaults, o.userOptions),
                o.options.height = Math.ceil(o.options.width / o.options.ratio),
                o.ID = (new Date).getTime(),
                o.holderID = "YTPlayer-ID-" + o.ID,
                o.options.fitToBackground ? o.createBackgroundVideo() : o.createContainerVideo(),
                o.$window.on("resize.YTplayer" + o.ID, function() {
                    o.resize(o)
                }),
                i(o.onYouTubeIframeAPIReady.bind(o)),
                o.resize(o),
                o
            },
            pauseOnScroll: function() {
                var e = this;
                e.$window.on("scroll.YTplayer" + e.ID, function() {
                    var t = e.player.getPlayerState();
                    1 === t && e.player.pauseVideo()
                }),
                e.$window.scrollStopped(function() {
                    var t = e.player.getPlayerState();
                    2 === t && e.player.playVideo()
                })
            },
            createContainerVideo: function() {
                var t = this
                  , n = e('<div id="ytplayer-container' + t.ID + '" >                                      <div id="' + t.holderID + '" class="ytplayer-player-inline"></div>                                       </div>                                       <div id="ytplayer-shield" class="ytplayer-shield"></div>');
                t.$node.append(n),
                t.$YTPlayerString = n,
                n = null
            },
            createBackgroundVideo: function() {
                var t = this
                  , n = e('<div id="ytplayer-container' + t.ID + '" class="ytplayer-container background">                                      <div id="' + t.holderID + '" class="ytplayer-player"></div>                                      </div>                                      <div id="ytplayer-shield" class="ytplayer-shield"></div>');
                t.$node.append(n),
                t.$YTPlayerString = n,
                n = null
            },
            resize: function(t) {
                var n = t.$node;
                t.options.fitToBackground || (n = t.$node);
                var i, r, o = n.width(), s = n.height(), a = e("#" + t.holderID);
                o / t.options.ratio < s ? (i = Math.ceil(s * t.options.ratio),
                a.width(i).height(s).css({
                    left: (o - i) / 2,
                    top: 0,
                    position: "absolute"
                })) : (r = Math.ceil(o / t.options.ratio),
                a.width(o).height(r).css({
                    left: 0,
                    top: (s - r) / 2,
                    position: "absolute"
                })),
                a = null,
                n = null
            },
            onYouTubeIframeAPIReady: function() {
                var e = this;
                e.player = new t.YT.Player(e.holderID,e.options)
            },
            onPlayerReady: function(e) {
                this.options.mute && e.target.mute(),
                e.target.playVideo()
            },
            getPlayer: function() {
                return this.player
            },
            destroy: function() {
                var n = this;
                n.$node.removeData("yt-init").removeData("ytPlayer").removeClass("loaded"),
                n.$YTPlayerString.remove(),
                e(t).off("resize.YTplayer" + n.ID),
                e(t).off("scroll.YTplayer" + n.ID),
                n.$body = null,
                n.$node = null,
                n.$YTPlayerString = null,
                n.player.destroy(),
                n.player = null
            }
        },
        e.fn.scrollStopped = function(t) {
            var n = e(this)
              , i = this;
            n.scroll(function() {
                n.data("scrollTimeout") && clearTimeout(n.data("scrollTimeout")),
                n.data("scrollTimeout", setTimeout(t, 250, i))
            })
        }
        ,
        e.fn.YTPlayer = function(t) {
            return this.each(function() {
                var n = this;
                e(n).data("yt-init", !0);
                var i = Object.create(YTPlayer);
                i.init(n, t),
                e.data(n, "ytPlayer", i),
                e(n).data("ytPlayer", i)
            })
        }
    }(t, window, document),
    /*!
   * magnific-popup.js
   */
    /*! Magnific Popup - v1.0.0 - 2014-12-12
  * http://dimsemenov.com/plugins/magnific-popup/
  * Copyright (c) 2014 Dmitry Semenov; */
    function(e) {
        "function" == typeof define && define.amd ? define(["jquery"], e) : e("object" == typeof exports ? require("jquery") : window.jQuery || window.Zepto)
    }(function(e) {
        var t, n, i, r, o, s, a, l = "Close", u = "BeforeClose", c = "AfterClose", d = "BeforeAppend", f = "MarkupParse", h = "Open", p = "Change", m = "mfp", g = "." + m, v = "mfp-ready", y = "mfp-removing", b = "mfp-prevent-close", w = function() {}, x = !!window.jQuery, _ = e(window), C = function(e, n) {
            t.ev.on(m + e + g, n)
        }, E = function(t, n, i, r) {
            var o = document.createElement("div");
            return o.className = "mfp-" + t,
            i && (o.innerHTML = i),
            r ? n && n.appendChild(o) : (o = e(o),
            n && o.appendTo(n)),
            o
        }, S = function(n, i) {
            t.ev.triggerHandler(m + n, i),
            t.st.callbacks && (n = n.charAt(0).toLowerCase() + n.slice(1),
            t.st.callbacks[n] && t.st.callbacks[n].apply(t, e.isArray(i) ? i : [i]))
        }, T = function(n) {
            return n === a && t.currTemplate.closeBtn || (t.currTemplate.closeBtn = e(t.st.closeMarkup.replace("%title%", t.st.tClose)),
            a = n),
            t.currTemplate.closeBtn
        }, k = function() {
            e.magnificPopup.instance || (t = new w,
            t.init(),
            e.magnificPopup.instance = t)
        }, A = function() {
            var e = document.createElement("p").style
              , t = ["ms", "O", "Moz", "Webkit"];
            if (void 0 !== e.transition)
                return !0;
            for (; t.length; )
                if (t.pop() + "Transition"in e)
                    return !0;
            return !1
        };
        w.prototype = {
            constructor: w,
            init: function() {
                var n = navigator.appVersion;
                t.isIE7 = -1 !== n.indexOf("MSIE 7."),
                t.isIE8 = -1 !== n.indexOf("MSIE 8."),
                t.isLowIE = t.isIE7 || t.isIE8,
                t.isAndroid = /android/gi.test(n),
                t.isIOS = /iphone|ipad|ipod/gi.test(n),
                t.supportsTransition = A(),
                t.probablyMobile = t.isAndroid || t.isIOS || /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent),
                r = e(document),
                t.popupsCache = {}
            },
            open: function(n) {
                i || (i = e(document.body));
                var o;
                if (n.isObj === !1) {
                    t.items = n.items.toArray(),
                    t.index = 0;
                    var a, l = n.items;
                    for (o = 0; l.length > o; o++)
                        if (a = l[o],
                        a.parsed && (a = a.el[0]),
                        a === n.el[0]) {
                            t.index = o;
                            break
                        }
                } else
                    t.items = e.isArray(n.items) ? n.items : [n.items],
                    t.index = n.index || 0;
                if (t.isOpen)
                    return void t.updateItemHTML();
                t.types = [],
                s = "",
                t.ev = n.mainEl && n.mainEl.length ? n.mainEl.eq(0) : r,
                n.key ? (t.popupsCache[n.key] || (t.popupsCache[n.key] = {}),
                t.currTemplate = t.popupsCache[n.key]) : t.currTemplate = {},
                t.st = e.extend(!0, {}, e.magnificPopup.defaults, n),
                t.fixedContentPos = "auto" === t.st.fixedContentPos ? !t.probablyMobile : t.st.fixedContentPos,
                t.st.modal && (t.st.closeOnContentClick = !1,
                t.st.closeOnBgClick = !1,
                t.st.showCloseBtn = !1,
                t.st.enableEscapeKey = !1),
                t.bgOverlay || (t.bgOverlay = E("bg").on("click" + g, function() {
                    t.close()
                }),
                t.wrap = E("wrap").attr("tabindex", -1).on("click" + g, function(e) {
                    t._checkIfClose(e.target) && t.close()
                }),
                t.container = E("container", t.wrap)),
                t.contentContainer = E("content"),
                t.st.preloader && (t.preloader = E("preloader", t.container, t.st.tLoading));
                var u = e.magnificPopup.modules;
                for (o = 0; u.length > o; o++) {
                    var c = u[o];
                    c = c.charAt(0).toUpperCase() + c.slice(1),
                    t["init" + c].call(t)
                }
                S("BeforeOpen"),
                t.st.showCloseBtn && (t.st.closeBtnInside ? (C(f, function(e, t, n, i) {
                    n.close_replaceWith = T(i.type)
                }),
                s += " mfp-close-btn-in") : t.wrap.append(T())),
                t.st.alignTop && (s += " mfp-align-top"),
                t.fixedContentPos ? t.wrap.css({
                    overflow: t.st.overflowY,
                    overflowX: "hidden",
                    overflowY: t.st.overflowY
                }) : t.wrap.css({
                    top: _.scrollTop(),
                    position: "absolute"
                }),
                (t.st.fixedBgPos === !1 || "auto" === t.st.fixedBgPos && !t.fixedContentPos) && t.bgOverlay.css({
                    height: r.height(),
                    position: "absolute"
                }),
                t.st.enableEscapeKey && r.on("keyup" + g, function(e) {
                    27 === e.keyCode && t.close()
                }),
                _.on("resize" + g, function() {
                    t.updateSize()
                }),
                t.st.closeOnContentClick || (s += " mfp-auto-cursor"),
                s && t.wrap.addClass(s);
                var d = t.wH = _.height()
                  , p = {};
                if (t.fixedContentPos && t._hasScrollBar(d)) {
                    var m = t._getScrollbarSize();
                    m && (p.marginRight = m)
                }
                t.fixedContentPos && (t.isIE7 ? e("body, html").css("overflow", "hidden") : p.overflow = "hidden");
                var y = t.st.mainClass;
                return t.isIE7 && (y += " mfp-ie7"),
                y && t._addClassToMFP(y),
                t.updateItemHTML(),
                S("BuildControls"),
                e("html").css(p),
                t.bgOverlay.add(t.wrap).prependTo(t.st.prependTo || i),
                t._lastFocusedEl = document.activeElement,
                setTimeout(function() {
                    t.content ? (t._addClassToMFP(v),
                    t._setFocus()) : t.bgOverlay.addClass(v),
                    r.on("focusin" + g, t._onFocusIn)
                }, 16),
                t.isOpen = !0,
                t.updateSize(d),
                S(h),
                n
            },
            close: function() {
                t.isOpen && (S(u),
                t.isOpen = !1,
                t.st.removalDelay && !t.isLowIE && t.supportsTransition ? (t._addClassToMFP(y),
                setTimeout(function() {
                    t._close()
                }, t.st.removalDelay)) : t._close())
            },
            _close: function() {
                S(l);
                var n = y + " " + v + " ";
                if (t.bgOverlay.detach(),
                t.wrap.detach(),
                t.container.empty(),
                t.st.mainClass && (n += t.st.mainClass + " "),
                t._removeClassFromMFP(n),
                t.fixedContentPos) {
                    var i = {
                        marginRight: ""
                    };
                    t.isIE7 ? e("body, html").css("overflow", "") : i.overflow = "",
                    e("html").css(i)
                }
                r.off("keyup" + g + " focusin" + g),
                t.ev.off(g),
                t.wrap.attr("class", "mfp-wrap").removeAttr("style"),
                t.bgOverlay.attr("class", "mfp-bg"),
                t.container.attr("class", "mfp-container"),
                !t.st.showCloseBtn || t.st.closeBtnInside && t.currTemplate[t.currItem.type] !== !0 || t.currTemplate.closeBtn && t.currTemplate.closeBtn.detach(),
                t._lastFocusedEl && e(t._lastFocusedEl).focus(),
                t.currItem = null,
                t.content = null,
                t.currTemplate = null,
                t.prevHeight = 0,
                S(c)
            },
            updateSize: function(e) {
                if (t.isIOS) {
                    var n = document.documentElement.clientWidth / window.innerWidth
                      , i = window.innerHeight * n;
                    t.wrap.css("height", i),
                    t.wH = i
                } else
                    t.wH = e || _.height();
                t.fixedContentPos || t.wrap.css("height", t.wH),
                S("Resize")
            },
            updateItemHTML: function() {
                var n = t.items[t.index];
                t.contentContainer.detach(),
                t.content && t.content.detach(),
                n.parsed || (n = t.parseEl(t.index));
                var i = n.type;
                if (S("BeforeChange", [t.currItem ? t.currItem.type : "", i]),
                t.currItem = n,
                !t.currTemplate[i]) {
                    var r = !!t.st[i] && t.st[i].markup;
                    S("FirstMarkupParse", r),
                    t.currTemplate[i] = !r || e(r)
                }
                o && o !== n.type && t.container.removeClass("mfp-" + o + "-holder");
                var s = t["get" + i.charAt(0).toUpperCase() + i.slice(1)](n, t.currTemplate[i]);
                t.appendContent(s, i),
                n.preloaded = !0,
                S(p, n),
                o = n.type,
                t.container.prepend(t.contentContainer),
                S("AfterChange")
            },
            appendContent: function(e, n) {
                t.content = e,
                e ? t.st.showCloseBtn && t.st.closeBtnInside && t.currTemplate[n] === !0 ? t.content.find(".mfp-close").length || t.content.append(T()) : t.content = e : t.content = "",
                S(d),
                t.container.addClass("mfp-" + n + "-holder"),
                t.contentContainer.append(t.content)
            },
            parseEl: function(n) {
                var i, r = t.items[n];
                if (r.tagName ? r = {
                    el: e(r)
                } : (i = r.type,
                r = {
                    data: r,
                    src: r.src
                }),
                r.el) {
                    for (var o = t.types, s = 0; o.length > s; s++)
                        if (r.el.hasClass("mfp-" + o[s])) {
                            i = o[s];
                            break
                        }
                    r.src = r.el.attr("data-mfp-src"),
                    r.src || (r.src = r.el.attr("href"))
                }
                return r.type = i || t.st.type || "inline",
                r.index = n,
                r.parsed = !0,
                t.items[n] = r,
                S("ElementParse", r),
                t.items[n]
            },
            addGroup: function(e, n) {
                var i = function(i) {
                    i.mfpEl = this,
                    t._openClick(i, e, n)
                };
                n || (n = {});
                var r = "click.magnificPopup";
                n.mainEl = e,
                n.items ? (n.isObj = !0,
                e.off(r).on(r, i)) : (n.isObj = !1,
                n.delegate ? e.off(r).on(r, n.delegate, i) : (n.items = e,
                e.off(r).on(r, i)))
            },
            _openClick: function(n, i, r) {
                var o = void 0 !== r.midClick ? r.midClick : e.magnificPopup.defaults.midClick;
                if (o || 2 !== n.which && !n.ctrlKey && !n.metaKey) {
                    var s = void 0 !== r.disableOn ? r.disableOn : e.magnificPopup.defaults.disableOn;
                    if (s)
                        if (e.isFunction(s)) {
                            if (!s.call(t))
                                return !0
                        } else if (s > _.width())
                            return !0;
                    n.type && (n.preventDefault(),
                    t.isOpen && n.stopPropagation()),
                    r.el = e(n.mfpEl),
                    r.delegate && (r.items = i.find(r.delegate)),
                    t.open(r)
                }
            },
            updateStatus: function(e, i) {
                if (t.preloader) {
                    n !== e && t.container.removeClass("mfp-s-" + n),
                    i || "loading" !== e || (i = t.st.tLoading);
                    var r = {
                        status: e,
                        text: i
                    };
                    S("UpdateStatus", r),
                    e = r.status,
                    i = r.text,
                    t.preloader.html(i),
                    t.preloader.find("a").on("click", function(e) {
                        e.stopImmediatePropagation()
                    }),
                    t.container.addClass("mfp-s-" + e),
                    n = e
                }
            },
            _checkIfClose: function(n) {
                if (!e(n).hasClass(b)) {
                    var i = t.st.closeOnContentClick
                      , r = t.st.closeOnBgClick;
                    if (i && r)
                        return !0;
                    if (!t.content || e(n).hasClass("mfp-close") || t.preloader && n === t.preloader[0])
                        return !0;
                    if (n === t.content[0] || e.contains(t.content[0], n)) {
                        if (i)
                            return !0
                    } else if (r && e.contains(document, n))
                        return !0;
                    return !1
                }
            },
            _addClassToMFP: function(e) {
                t.bgOverlay.addClass(e),
                t.wrap.addClass(e)
            },
            _removeClassFromMFP: function(e) {
                this.bgOverlay.removeClass(e),
                t.wrap.removeClass(e)
            },
            _hasScrollBar: function(e) {
                return (t.isIE7 ? r.height() : document.body.scrollHeight) > (e || _.height())
            },
            _setFocus: function() {
                (t.st.focus ? t.content.find(t.st.focus).eq(0) : t.wrap).focus()
            },
            _onFocusIn: function(n) {
                return n.target === t.wrap[0] || e.contains(t.wrap[0], n.target) ? void 0 : (t._setFocus(),
                !1)
            },
            _parseMarkup: function(t, n, i) {
                var r;
                i.data && (n = e.extend(i.data, n)),
                S(f, [t, n, i]),
                e.each(n, function(e, n) {
                    if (void 0 === n || n === !1)
                        return !0;
                    if (r = e.split("_"),
                    r.length > 1) {
                        var i = t.find(g + "-" + r[0]);
                        if (i.length > 0) {
                            var o = r[1];
                            "replaceWith" === o ? i[0] !== n[0] && i.replaceWith(n) : "img" === o ? i.is("img") ? i.attr("src", n) : i.replaceWith('<img src="' + n + '" class="' + i.attr("class") + '" />') : i.attr(r[1], n)
                        }
                    } else
                        t.find(g + "-" + e).html(n)
                })
            },
            _getScrollbarSize: function() {
                if (void 0 === t.scrollbarSize) {
                    var e = document.createElement("div");
                    e.style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;",
                    document.body.appendChild(e),
                    t.scrollbarSize = e.offsetWidth - e.clientWidth,
                    document.body.removeChild(e)
                }
                return t.scrollbarSize
            }
        },
        e.magnificPopup = {
            instance: null,
            proto: w.prototype,
            modules: [],
            open: function(t, n) {
                return k(),
                t = t ? e.extend(!0, {}, t) : {},
                t.isObj = !0,
                t.index = n || 0,
                this.instance.open(t)
            },
            close: function() {
                return e.magnificPopup.instance && e.magnificPopup.instance.close()
            },
            registerModule: function(t, n) {
                n.options && (e.magnificPopup.defaults[t] = n.options),
                e.extend(this.proto, n.proto),
                this.modules.push(t)
            },
            defaults: {
                disableOn: 0,
                key: null,
                midClick: !1,
                mainClass: "",
                preloader: !0,
                focus: "",
                closeOnContentClick: !1,
                closeOnBgClick: !0,
                closeBtnInside: !0,
                showCloseBtn: !0,
                enableEscapeKey: !0,
                modal: !1,
                alignTop: !1,
                removalDelay: 0,
                prependTo: null,
                fixedContentPos: "auto",
                fixedBgPos: "auto",
                overflowY: "auto",
                closeMarkup: '<button title="%title%" type="button" class="mfp-close">&times;</button>',
                tClose: "Close (Esc)",
                tLoading: "Loading..."
            }
        },
        e.fn.magnificPopup = function(n) {
            k();
            var i = e(this);
            if ("string" == typeof n)
                if ("open" === n) {
                    var r, o = x ? i.data("magnificPopup") : i[0].magnificPopup, s = parseInt(arguments[1], 10) || 0;
                    o.items ? r = o.items[s] : (r = i,
                    o.delegate && (r = r.find(o.delegate)),
                    r = r.eq(s)),
                    t._openClick({
                        mfpEl: r
                    }, i, o)
                } else
                    t.isOpen && t[n].apply(t, Array.prototype.slice.call(arguments, 1));
            else
                n = e.extend(!0, {}, n),
                x ? i.data("magnificPopup", n) : i[0].magnificPopup = n,
                t.addGroup(i, n);
            return i
        }
        ;
        var I, D, L, z = "inline", P = function() {
            L && (D.after(L.addClass(I)).detach(),
            L = null)
        };
        e.magnificPopup.registerModule(z, {
            options: {
                hiddenClass: "hide",
                markup: "",
                tNotFound: "Content not found"
            },
            proto: {
                initInline: function() {
                    t.types.push(z),
                    C(l + "." + z, function() {
                        P()
                    })
                },
                getInline: function(n, i) {
                    if (P(),
                    n.src) {
                        var r = t.st.inline
                          , o = e(n.src);
                        if (o.length) {
                            var s = o[0].parentNode;
                            s && s.tagName && (D || (I = r.hiddenClass,
                            D = E(I),
                            I = "mfp-" + I),
                            L = o.after(D).detach().removeClass(I)),
                            t.updateStatus("ready")
                        } else
                            t.updateStatus("error", r.tNotFound),
                            o = e("<div>");
                        return n.inlineElement = o,
                        o
                    }
                    return t.updateStatus("ready"),
                    t._parseMarkup(i, {}, n),
                    i
                }
            }
        });
        var N, j = "ajax", M = function() {
            N && i.removeClass(N)
        }, O = function() {
            M(),
            t.req && t.req.abort()
        };
        e.magnificPopup.registerModule(j, {
            options: {
                settings: null,
                cursor: "mfp-ajax-cur",
                tError: '<a href="%url%">The content</a> could not be loaded.'
            },
            proto: {
                initAjax: function() {
                    t.types.push(j),
                    N = t.st.ajax.cursor,
                    C(l + "." + j, O),
                    C("BeforeChange." + j, O)
                },
                getAjax: function(n) {
                    N && i.addClass(N),
                    t.updateStatus("loading");
                    var r = e.extend({
                        url: n.src,
                        success: function(i, r, o) {
                            var s = {
                                data: i,
                                xhr: o
                            };
                            S("ParseAjax", s),
                            t.appendContent(e(s.data), j),
                            n.finished = !0,
                            M(),
                            t._setFocus(),
                            setTimeout(function() {
                                t.wrap.addClass(v)
                            }, 16),
                            t.updateStatus("ready"),
                            S("AjaxContentAdded")
                        },
                        error: function() {
                            M(),
                            n.finished = n.loadError = !0,
                            t.updateStatus("error", t.st.ajax.tError.replace("%url%", n.src))
                        }
                    }, t.st.ajax.settings);
                    return t.req = e.ajax(r),
                    ""
                }
            }
        });
        var F, q = function(n) {
            if (n.data && void 0 !== n.data.title)
                return n.data.title;
            var i = t.st.image.titleSrc;
            if (i) {
                if (e.isFunction(i))
                    return i.call(t, n);
                if (n.el)
                    return n.el.attr(i) || ""
            }
            return ""
        };
        e.magnificPopup.registerModule("image", {
            options: {
                markup: '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
                cursor: "mfp-zoom-out-cur",
                titleSrc: "title",
                verticalFit: !0,
                tError: '<a href="%url%">The image</a> could not be loaded.'
            },
            proto: {
                initImage: function() {
                    var e = t.st.image
                      , n = ".image";
                    t.types.push("image"),
                    C(h + n, function() {
                        "image" === t.currItem.type && e.cursor && i.addClass(e.cursor)
                    }),
                    C(l + n, function() {
                        e.cursor && i.removeClass(e.cursor),
                        _.off("resize" + g)
                    }),
                    C("Resize" + n, t.resizeImage),
                    t.isLowIE && C("AfterChange", t.resizeImage)
                },
                resizeImage: function() {
                    var e = t.currItem;
                    if (e && e.img && t.st.image.verticalFit) {
                        var n = 0;
                        t.isLowIE && (n = parseInt(e.img.css("padding-top"), 10) + parseInt(e.img.css("padding-bottom"), 10)),
                        e.img.css("max-height", t.wH - n)
                    }
                },
                _onImageHasSize: function(e) {
                    e.img && (e.hasSize = !0,
                    F && clearInterval(F),
                    e.isCheckingImgSize = !1,
                    S("ImageHasSize", e),
                    e.imgHidden && (t.content && t.content.removeClass("mfp-loading"),
                    e.imgHidden = !1))
                },
                findImageSize: function(e) {
                    var n = 0
                      , i = e.img[0]
                      , r = function(o) {
                        F && clearInterval(F),
                        F = setInterval(function() {
                            return i.naturalWidth > 0 ? void t._onImageHasSize(e) : (n > 200 && clearInterval(F),
                            n++,
                            void (3 === n ? r(10) : 40 === n ? r(50) : 100 === n && r(500)))
                        }, o)
                    };
                    r(1)
                },
                getImage: function(n, i) {
                    var r = 0
                      , o = function() {
                        n && (n.img[0].complete ? (n.img.off(".mfploader"),
                        n === t.currItem && (t._onImageHasSize(n),
                        t.updateStatus("ready")),
                        n.hasSize = !0,
                        n.loaded = !0,
                        S("ImageLoadComplete")) : (r++,
                        200 > r ? setTimeout(o, 100) : s()))
                    }
                      , s = function() {
                        n && (n.img.off(".mfploader"),
                        n === t.currItem && (t._onImageHasSize(n),
                        t.updateStatus("error", a.tError.replace("%url%", n.src))),
                        n.hasSize = !0,
                        n.loaded = !0,
                        n.loadError = !0)
                    }
                      , a = t.st.image
                      , l = i.find(".mfp-img");
                    if (l.length) {
                        var u = document.createElement("img");
                        u.className = "mfp-img",
                        n.el && n.el.find("img").length && (u.alt = n.el.find("img").attr("alt")),
                        n.img = e(u).on("load.mfploader", o).on("error.mfploader", s),
                        u.src = n.src,
                        l.is("img") && (n.img = n.img.clone()),
                        u = n.img[0],
                        u.naturalWidth > 0 ? n.hasSize = !0 : u.width || (n.hasSize = !1)
                    }
                    return t._parseMarkup(i, {
                        title: q(n),
                        img_replaceWith: n.img
                    }, n),
                    t.resizeImage(),
                    n.hasSize ? (F && clearInterval(F),
                    n.loadError ? (i.addClass("mfp-loading"),
                    t.updateStatus("error", a.tError.replace("%url%", n.src))) : (i.removeClass("mfp-loading"),
                    t.updateStatus("ready")),
                    i) : (t.updateStatus("loading"),
                    n.loading = !0,
                    n.hasSize || (n.imgHidden = !0,
                    i.addClass("mfp-loading"),
                    t.findImageSize(n)),
                    i)
                }
            }
        });
        var B, H = function() {
            return void 0 === B && (B = void 0 !== document.createElement("p").style.MozTransform),
            B
        };
        e.magnificPopup.registerModule("zoom", {
            options: {
                enabled: !1,
                easing: "ease-in-out",
                duration: 300,
                opener: function(e) {
                    return e.is("img") ? e : e.find("img")
                }
            },
            proto: {
                initZoom: function() {
                    var e, n = t.st.zoom, i = ".zoom";
                    if (n.enabled && t.supportsTransition) {
                        var r, o, s = n.duration, a = function(e) {
                            var t = e.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image")
                              , i = "all " + n.duration / 1e3 + "s " + n.easing
                              , r = {
                                position: "fixed",
                                zIndex: 9999,
                                left: 0,
                                top: 0,
                                "-webkit-backface-visibility": "hidden"
                            }
                              , o = "transition";
                            return r["-webkit-" + o] = r["-moz-" + o] = r["-o-" + o] = r[o] = i,
                            t.css(r),
                            t
                        }, c = function() {
                            t.content.css("visibility", "visible")
                        };
                        C("BuildControls" + i, function() {
                            if (t._allowZoom()) {
                                if (clearTimeout(r),
                                t.content.css("visibility", "hidden"),
                                e = t._getItemToZoom(),
                                !e)
                                    return void c();
                                o = a(e),
                                o.css(t._getOffset()),
                                t.wrap.append(o),
                                r = setTimeout(function() {
                                    o.css(t._getOffset(!0)),
                                    r = setTimeout(function() {
                                        c(),
                                        setTimeout(function() {
                                            o.remove(),
                                            e = o = null,
                                            S("ZoomAnimationEnded")
                                        }, 16)
                                    }, s)
                                }, 16)
                            }
                        }),
                        C(u + i, function() {
                            if (t._allowZoom()) {
                                if (clearTimeout(r),
                                t.st.removalDelay = s,
                                !e) {
                                    if (e = t._getItemToZoom(),
                                    !e)
                                        return;
                                    o = a(e)
                                }
                                o.css(t._getOffset(!0)),
                                t.wrap.append(o),
                                t.content.css("visibility", "hidden"),
                                setTimeout(function() {
                                    o.css(t._getOffset())
                                }, 16)
                            }
                        }),
                        C(l + i, function() {
                            t._allowZoom() && (c(),
                            o && o.remove(),
                            e = null)
                        })
                    }
                },
                _allowZoom: function() {
                    return "image" === t.currItem.type
                },
                _getItemToZoom: function() {
                    return !!t.currItem.hasSize && t.currItem.img
                },
                _getOffset: function(n) {
                    var i;
                    i = n ? t.currItem.img : t.st.zoom.opener(t.currItem.el || t.currItem);
                    var r = i.offset()
                      , o = parseInt(i.css("padding-top"), 10)
                      , s = parseInt(i.css("padding-bottom"), 10);
                    r.top -= e(window).scrollTop() - o;
                    var a = {
                        width: i.width(),
                        height: (x ? i.innerHeight() : i[0].offsetHeight) - s - o
                    };
                    return H() ? a["-moz-transform"] = a.transform = "translate(" + r.left + "px," + r.top + "px)" : (a.left = r.left,
                    a.top = r.top),
                    a
                }
            }
        });
        var R = "iframe"
          , W = "//about:blank"
          , U = function(e) {
            if (t.currTemplate[R]) {
                var n = t.currTemplate[R].find("iframe");
                n.length && (e || (n[0].src = W),
                t.isIE8 && n.css("display", e ? "block" : "none"))
            }
        };
        e.magnificPopup.registerModule(R, {
            options: {
                markup: '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
                srcAction: "iframe_src",
                patterns: {
                    youtube: {
                        index: "youtube.com",
                        id: "v=",
                        src: "//www.youtube.com/embed/%id%?autoplay=1"
                    },
                    vimeo: {
                        index: "vimeo.com/",
                        id: "/",
                        src: "//player.vimeo.com/video/%id%?autoplay=1"
                    },
                    gmaps: {
                        index: "//maps.google.",
                        src: "%id%&output=embed"
                    }
                }
            },
            proto: {
                initIframe: function() {
                    t.types.push(R),
                    C("BeforeChange", function(e, t, n) {
                        t !== n && (t === R ? U() : n === R && U(!0))
                    }),
                    C(l + "." + R, function() {
                        U()
                    })
                },
                getIframe: function(n, i) {
                    var r = n.src
                      , o = t.st.iframe;
                    e.each(o.patterns, function() {
                        return r.indexOf(this.index) > -1 ? (this.id && (r = "string" == typeof this.id ? r.substr(r.lastIndexOf(this.id) + this.id.length, r.length) : this.id.call(this, r)),
                        r = this.src.replace("%id%", r),
                        !1) : void 0
                    });
                    var s = {};
                    return o.srcAction && (s[o.srcAction] = r),
                    t._parseMarkup(i, s, n),
                    t.updateStatus("ready"),
                    i
                }
            }
        });
        var $ = function(e) {
            var n = t.items.length;
            return e > n - 1 ? e - n : 0 > e ? n + e : e
        }
          , V = function(e, t, n) {
            return e.replace(/%curr%/gi, t + 1).replace(/%total%/gi, n)
        };
        e.magnificPopup.registerModule("gallery", {
            options: {
                enabled: !1,
                arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
                preload: [0, 2],
                navigateByImgClick: !0,
                arrows: !0,
                tPrev: "Previous (Left arrow key)",
                tNext: "Next (Right arrow key)",
                tCounter: "%curr% of %total%"
            },
            proto: {
                initGallery: function() {
                    var n = t.st.gallery
                      , i = ".mfp-gallery"
                      , o = Boolean(e.fn.mfpFastClick);
                    return t.direction = !0,
                    !(!n || !n.enabled) && (s += " mfp-gallery",
                    C(h + i, function() {
                        n.navigateByImgClick && t.wrap.on("click" + i, ".mfp-img", function() {
                            return t.items.length > 1 ? (t.next(),
                            !1) : void 0
                        }),
                        r.on("keydown" + i, function(e) {
                            37 === e.keyCode ? t.prev() : 39 === e.keyCode && t.next()
                        })
                    }),
                    C("UpdateStatus" + i, function(e, n) {
                        n.text && (n.text = V(n.text, t.currItem.index, t.items.length))
                    }),
                    C(f + i, function(e, i, r, o) {
                        var s = t.items.length;
                        r.counter = s > 1 ? V(n.tCounter, o.index, s) : ""
                    }),
                    C("BuildControls" + i, function() {
                        if (t.items.length > 1 && n.arrows && !t.arrowLeft) {
                            var i = n.arrowMarkup
                              , r = t.arrowLeft = e(i.replace(/%title%/gi, n.tPrev).replace(/%dir%/gi, "left")).addClass(b)
                              , s = t.arrowRight = e(i.replace(/%title%/gi, n.tNext).replace(/%dir%/gi, "right")).addClass(b)
                              , a = o ? "mfpFastClick" : "click";
                            r[a](function() {
                                t.prev()
                            }),
                            s[a](function() {
                                t.next()
                            }),
                            t.isIE7 && (E("b", r[0], !1, !0),
                            E("a", r[0], !1, !0),
                            E("b", s[0], !1, !0),
                            E("a", s[0], !1, !0)),
                            t.container.append(r.add(s))
                        }
                    }),
                    C(p + i, function() {
                        t._preloadTimeout && clearTimeout(t._preloadTimeout),
                        t._preloadTimeout = setTimeout(function() {
                            t.preloadNearbyImages(),
                            t._preloadTimeout = null
                        }, 16)
                    }),
                    void C(l + i, function() {
                        r.off(i),
                        t.wrap.off("click" + i),
                        t.arrowLeft && o && t.arrowLeft.add(t.arrowRight).destroyMfpFastClick(),
                        t.arrowRight = t.arrowLeft = null
                    }))
                },
                next: function() {
                    t.direction = !0,
                    t.index = $(t.index + 1),
                    t.updateItemHTML()
                },
                prev: function() {
                    t.direction = !1,
                    t.index = $(t.index - 1),
                    t.updateItemHTML()
                },
                goTo: function(e) {
                    t.direction = e >= t.index,
                    t.index = e,
                    t.updateItemHTML()
                },
                preloadNearbyImages: function() {
                    var e, n = t.st.gallery.preload, i = Math.min(n[0], t.items.length), r = Math.min(n[1], t.items.length);
                    for (e = 1; (t.direction ? r : i) >= e; e++)
                        t._preloadItem(t.index + e);
                    for (e = 1; (t.direction ? i : r) >= e; e++)
                        t._preloadItem(t.index - e)
                },
                _preloadItem: function(n) {
                    if (n = $(n),
                    !t.items[n].preloaded) {
                        var i = t.items[n];
                        i.parsed || (i = t.parseEl(n)),
                        S("LazyLoad", i),
                        "image" === i.type && (i.img = e('<img class="mfp-img" />').on("load.mfploader", function() {
                            i.hasSize = !0
                        }).on("error.mfploader", function() {
                            i.hasSize = !0,
                            i.loadError = !0,
                            S("LazyLoadError", i)
                        }).attr("src", i.src)),
                        i.preloaded = !0
                    }
                }
            }
        });
        var Q = "retina";
        e.magnificPopup.registerModule(Q, {
            options: {
                replaceSrc: function(e) {
                    return e.src.replace(/\.\w+$/, function(e) {
                        return "@2x" + e
                    })
                },
                ratio: 1
            },
            proto: {
                initRetina: function() {
                    if (window.devicePixelRatio > 1) {
                        var e = t.st.retina
                          , n = e.ratio;
                        n = isNaN(n) ? n() : n,
                        n > 1 && (C("ImageHasSize." + Q, function(e, t) {
                            t.img.css({
                                "max-width": t.img[0].naturalWidth / n,
                                width: "100%"
                            })
                        }),
                        C("ElementParse." + Q, function(t, i) {
                            i.src = e.replaceSrc(i, n)
                        }))
                    }
                }
            }
        }),
        function() {
            var t = 1e3
              , n = "ontouchstart"in window
              , i = function() {
                _.off("touchmove" + o + " touchend" + o)
            }
              , r = "mfpFastClick"
              , o = "." + r;
            e.fn.mfpFastClick = function(r) {
                return e(this).each(function() {
                    var s, a = e(this);
                    if (n) {
                        var l, u, c, d, f, h;
                        a.on("touchstart" + o, function(e) {
                            d = !1,
                            h = 1,
                            f = e.originalEvent ? e.originalEvent.touches[0] : e.touches[0],
                            u = f.clientX,
                            c = f.clientY,
                            _.on("touchmove" + o, function(e) {
                                f = e.originalEvent ? e.originalEvent.touches : e.touches,
                                h = f.length,
                                f = f[0],
                                (Math.abs(f.clientX - u) > 10 || Math.abs(f.clientY - c) > 10) && (d = !0,
                                i())
                            }).on("touchend" + o, function(e) {
                                i(),
                                d || h > 1 || (s = !0,
                                e.preventDefault(),
                                clearTimeout(l),
                                l = setTimeout(function() {
                                    s = !1
                                }, t),
                                r())
                            })
                        })
                    }
                    a.on("click" + o, function() {
                        s || r()
                    })
                })
            }
            ,
            e.fn.destroyMfpFastClick = function() {
                e(this).off("touchstart" + o + " click" + o),
                n && _.off("touchmove" + o + " touchend" + o)
            }
        }(),
        k()
    }),
    /*!
   * jquery.easing.js
   */
    /*
   * jQuery Easing v1.3 - http://gsgd.co.uk/sandbox/jquery/easing/
   *
   * Uses the built in easing capabilities added In jQuery 1.1
   * to offer multiple easing options
   *
   * TERMS OF USE - jQuery Easing
   *
   * Open source under the BSD License.
   *
   * Copyright 2008 George McGinley Smith
   * All rights reserved.
   *
   * Redistribution and use in source and binary forms, with or without modification,
   * are permitted provided that the following conditions are met:
   *
   * Redistributions of source code must retain the above copyright notice, this list of
   * conditions and the following disclaimer.
   * Redistributions in binary form must reproduce the above copyright notice, this list
   * of conditions and the following disclaimer in the documentation and/or other materials
   * provided with the distribution.
   *
   * Neither the name of the author nor the names of contributors may be used to endorse
   * or promote products derived from this software without specific prior written permission.
   *
   * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY
   * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
   * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
   * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
   * EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
   * GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED
   * AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
   * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED
   * OF THE POSSIBILITY OF SUCH DAMAGE.
   *
  */
    e.easing.jswing = e.easing.swing,
    e.extend(e.easing, {
        def: "easeOutQuad",
        swing: function(t, n, i, r, o) {
            return e.easing[e.easing.def](t, n, i, r, o)
        },
        easeInQuad: function(e, t, n, i, r) {
            return i * (t /= r) * t + n
        },
        easeOutQuad: function(e, t, n, i, r) {
            return -i * (t /= r) * (t - 2) + n
        },
        easeInOutQuad: function(e, t, n, i, r) {
            return (t /= r / 2) < 1 ? i / 2 * t * t + n : -i / 2 * (--t * (t - 2) - 1) + n
        },
        easeInCubic: function(e, t, n, i, r) {
            return i * (t /= r) * t * t + n
        },
        easeOutCubic: function(e, t, n, i, r) {
            return i * ((t = t / r - 1) * t * t + 1) + n
        },
        easeInOutCubic: function(e, t, n, i, r) {
            return (t /= r / 2) < 1 ? i / 2 * t * t * t + n : i / 2 * ((t -= 2) * t * t + 2) + n
        },
        easeInQuart: function(e, t, n, i, r) {
            return i * (t /= r) * t * t * t + n
        },
        easeOutQuart: function(e, t, n, i, r) {
            return -i * ((t = t / r - 1) * t * t * t - 1) + n
        },
        easeInOutQuart: function(e, t, n, i, r) {
            return (t /= r / 2) < 1 ? i / 2 * t * t * t * t + n : -i / 2 * ((t -= 2) * t * t * t - 2) + n
        },
        easeInQuint: function(e, t, n, i, r) {
            return i * (t /= r) * t * t * t * t + n
        },
        easeOutQuint: function(e, t, n, i, r) {
            return i * ((t = t / r - 1) * t * t * t * t + 1) + n
        },
        easeInOutQuint: function(e, t, n, i, r) {
            return (t /= r / 2) < 1 ? i / 2 * t * t * t * t * t + n : i / 2 * ((t -= 2) * t * t * t * t + 2) + n
        },
        easeInSine: function(e, t, n, i, r) {
            return -i * Math.cos(t / r * (Math.PI / 2)) + i + n
        },
        easeOutSine: function(e, t, n, i, r) {
            return i * Math.sin(t / r * (Math.PI / 2)) + n
        },
        easeInOutSine: function(e, t, n, i, r) {
            return -i / 2 * (Math.cos(Math.PI * t / r) - 1) + n
        },
        easeInExpo: function(e, t, n, i, r) {
            return 0 == t ? n : i * Math.pow(2, 10 * (t / r - 1)) + n
        },
        easeOutExpo: function(e, t, n, i, r) {
            return t == r ? n + i : i * (-Math.pow(2, -10 * t / r) + 1) + n
        },
        easeInOutExpo: function(e, t, n, i, r) {
            return 0 == t ? n : t == r ? n + i : (t /= r / 2) < 1 ? i / 2 * Math.pow(2, 10 * (t - 1)) + n : i / 2 * (-Math.pow(2, -10 * --t) + 2) + n
        },
        easeInCirc: function(e, t, n, i, r) {
            return -i * (Math.sqrt(1 - (t /= r) * t) - 1) + n
        },
        easeOutCirc: function(e, t, n, i, r) {
            return i * Math.sqrt(1 - (t = t / r - 1) * t) + n
        },
        easeInOutCirc: function(e, t, n, i, r) {
            return (t /= r / 2) < 1 ? -i / 2 * (Math.sqrt(1 - t * t) - 1) + n : i / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + n
        },
        easeInElastic: function(e, t, n, i, r) {
            var o = 1.70158
              , s = 0
              , a = i;
            if (0 == t)
                return n;
            if (1 == (t /= r))
                return n + i;
            if (s || (s = .3 * r),
            a < Math.abs(i)) {
                a = i;
                var o = s / 4
            } else
                var o = s / (2 * Math.PI) * Math.asin(i / a);
            return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * r - o) * (2 * Math.PI) / s)) + n
        },
        easeOutElastic: function(e, t, n, i, r) {
            var o = 1.70158
              , s = 0
              , a = i;
            if (0 == t)
                return n;
            if (1 == (t /= r))
                return n + i;
            if (s || (s = .3 * r),
            a < Math.abs(i)) {
                a = i;
                var o = s / 4
            } else
                var o = s / (2 * Math.PI) * Math.asin(i / a);
            return a * Math.pow(2, -10 * t) * Math.sin((t * r - o) * (2 * Math.PI) / s) + i + n
        },
        easeInOutElastic: function(e, t, n, i, r) {
            var o = 1.70158
              , s = 0
              , a = i;
            if (0 == t)
                return n;
            if (2 == (t /= r / 2))
                return n + i;
            if (s || (s = r * (.3 * 1.5)),
            a < Math.abs(i)) {
                a = i;
                var o = s / 4
            } else
                var o = s / (2 * Math.PI) * Math.asin(i / a);
            return t < 1 ? -.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * r - o) * (2 * Math.PI) / s)) + n : a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * r - o) * (2 * Math.PI) / s) * .5 + i + n
        },
        easeInBack: function(e, t, n, i, r, o) {
            return void 0 == o && (o = 1.70158),
            i * (t /= r) * t * ((o + 1) * t - o) + n
        },
        easeOutBack: function(e, t, n, i, r, o) {
            return void 0 == o && (o = 1.70158),
            i * ((t = t / r - 1) * t * ((o + 1) * t + o) + 1) + n
        },
        easeInOutBack: function(e, t, n, i, r, o) {
            return void 0 == o && (o = 1.70158),
            (t /= r / 2) < 1 ? i / 2 * (t * t * (((o *= 1.525) + 1) * t - o)) + n : i / 2 * ((t -= 2) * t * (((o *= 1.525) + 1) * t + o) + 2) + n
        },
        easeInBounce: function(t, n, i, r, o) {
            return r - e.easing.easeOutBounce(t, o - n, 0, r, o) + i
        },
        easeOutBounce: function(e, t, n, i, r) {
            return (t /= r) < 1 / 2.75 ? i * (7.5625 * t * t) + n : t < 2 / 2.75 ? i * (7.5625 * (t -= 1.5 / 2.75) * t + .75) + n : t < 2.5 / 2.75 ? i * (7.5625 * (t -= 2.25 / 2.75) * t + .9375) + n : i * (7.5625 * (t -= 2.625 / 2.75) * t + .984375) + n
        },
        easeInOutBounce: function(t, n, i, r, o) {
            return n < o / 2 ? .5 * e.easing.easeInBounce(t, 2 * n, 0, r, o) + i : .5 * e.easing.easeOutBounce(t, 2 * n - o, 0, r, o) + .5 * r + i
        }
    }),
    /*
   *
   * TERMS OF USE - EASING EQUATIONS
   *
   * Open source under the BSD License.
   *
   * Copyright 2001 Robert Penner
   * All rights reserved.
   *
   * Redistribution and use in source and binary forms, with or without modification,
   * are permitted provided that the following conditions are met:
   *
   * Redistributions of source code must retain the above copyright notice, this list of
   * conditions and the following disclaimer.
   * Redistributions in binary form must reproduce the above copyright notice, this list
   * of conditions and the following disclaimer in the documentation and/or other materials
   * provided with the distribution.
   *
   * Neither the name of the author nor the names of contributors may be used to endorse
   * or promote products derived from this software without specific prior written permission.
   *
   * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY
   * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
   * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
   * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
   * EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
   * GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED
   * AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
   * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED
   * OF THE POSSIBILITY OF SUCH DAMAGE.
   *
   */
    /*!
   * flickity.js
   */
    /*!
   * Flickity PACKAGED v2.1.2
   * Touch, responsive, flickable carousels
   *
   * Licensed GPLv3 for open source use
   * or Flickity Commercial License for commercial use
   *
   * https://flickity.metafizzy.co
   * Copyright 2015-2018 Metafizzy
   */
    /**
   * Bridget makes jQuery widgets
   * v2.0.1
   * MIT license
   */
    function(e, t) {
        "function" == typeof define && define.amd ? define("jquery-bridget/jquery-bridget", ["jquery"], function(n) {
            return t(e, n)
        }) : "object" == typeof module && module.exports ? module.exports = t(e, require("jquery")) : e.jQueryBridget = t(e, e.jQuery)
    }(window, function(e, t) {
        "use strict";
        function n(n, o, a) {
            function l(e, t, i) {
                var r, o = "$()." + n + '("' + t + '")';
                return e.each(function(e, l) {
                    var u = a.data(l, n);
                    if (!u)
                        return void s(n + " not initialized. Cannot call methods, i.e. " + o);
                    var c = u[t];
                    if (!c || "_" == t.charAt(0))
                        return void s(o + " is not a valid method");
                    var d = c.apply(u, i);
                    r = void 0 === r ? d : r
                }),
                void 0 !== r ? r : e
            }
            function u(e, t) {
                e.each(function(e, i) {
                    var r = a.data(i, n);
                    r ? (r.option(t),
                    r._init()) : (r = new o(i,t),
                    a.data(i, n, r))
                })
            }
            a = a || t || e.jQuery,
            a && (o.prototype.option || (o.prototype.option = function(e) {
                a.isPlainObject(e) && (this.options = a.extend(!0, this.options, e))
            }
            ),
            a.fn[n] = function(e) {
                if ("string" == typeof e) {
                    var t = r.call(arguments, 1);
                    return l(this, e, t)
                }
                return u(this, e),
                this
            }
            ,
            i(a))
        }
        function i(e) {
            !e || e && e.bridget || (e.bridget = n)
        }
        var r = Array.prototype.slice
          , o = e.console
          , s = "undefined" == typeof o ? function() {}
        : function(e) {
            o.error(e)
        }
        ;
        return i(t || e.jQuery),
        n
    }),
    /**
   * EvEmitter v1.1.0
   * Lil' event emitter
   * MIT License
   */
    function(e, t) {
        "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", t) : "object" == typeof module && module.exports ? module.exports = t() : e.EvEmitter = t()
    }("undefined" != typeof window ? window : this, function() {
        function e() {}
        var t = e.prototype;
        return t.on = function(e, t) {
            if (e && t) {
                var n = this._events = this._events || {}
                  , i = n[e] = n[e] || [];
                return i.indexOf(t) == -1 && i.push(t),
                this
            }
        }
        ,
        t.once = function(e, t) {
            if (e && t) {
                this.on(e, t);
                var n = this._onceEvents = this._onceEvents || {}
                  , i = n[e] = n[e] || {};
                return i[t] = !0,
                this
            }
        }
        ,
        t.off = function(e, t) {
            var n = this._events && this._events[e];
            if (n && n.length) {
                var i = n.indexOf(t);
                return i != -1 && n.splice(i, 1),
                this
            }
        }
        ,
        t.emitEvent = function(e, t) {
            var n = this._events && this._events[e];
            if (n && n.length) {
                n = n.slice(0),
                t = t || [];
                for (var i = this._onceEvents && this._onceEvents[e], r = 0; r < n.length; r++) {
                    var o = n[r]
                      , s = i && i[o];
                    s && (this.off(e, o),
                    delete i[o]),
                    o.apply(this, t)
                }
                return this
            }
        }
        ,
        t.allOff = function() {
            delete this._events,
            delete this._onceEvents
        }
        ,
        e
    }),
    /*!
   * getSize v2.0.3
   * measure size of elements
   * MIT license
   */
    function(e, t) {
        "function" == typeof define && define.amd ? define("get-size/get-size", t) : "object" == typeof module && module.exports ? module.exports = t() : e.getSize = t()
    }(window, function() {
        "use strict";
        function e(e) {
            var t = parseFloat(e)
              , n = e.indexOf("%") == -1 && !isNaN(t);
            return n && t
        }
        function t() {}
        function n() {
            for (var e = {
                width: 0,
                height: 0,
                innerWidth: 0,
                innerHeight: 0,
                outerWidth: 0,
                outerHeight: 0
            }, t = 0; t < u; t++) {
                var n = l[t];
                e[n] = 0
            }
            return e
        }
        function i(e) {
            var t = getComputedStyle(e);
            return t || a("Style returned " + t + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"),
            t
        }
        function r() {
            if (!c) {
                c = !0;
                var t = document.createElement("div");
                t.style.width = "200px",
                t.style.padding = "1px 2px 3px 4px",
                t.style.borderStyle = "solid",
                t.style.borderWidth = "1px 2px 3px 4px",
                t.style.boxSizing = "border-box";
                var n = document.body || document.documentElement;
                n.appendChild(t);
                var r = i(t);
                s = 200 == Math.round(e(r.width)),
                o.isBoxSizeOuter = s,
                n.removeChild(t)
            }
        }
        function o(t) {
            if (r(),
            "string" == typeof t && (t = document.querySelector(t)),
            t && "object" == typeof t && t.nodeType) {
                var o = i(t);
                if ("none" == o.display)
                    return n();
                var a = {};
                a.width = t.offsetWidth,
                a.height = t.offsetHeight;
                for (var c = a.isBorderBox = "border-box" == o.boxSizing, d = 0; d < u; d++) {
                    var f = l[d]
                      , h = o[f]
                      , p = parseFloat(h);
                    a[f] = isNaN(p) ? 0 : p
                }
                var m = a.paddingLeft + a.paddingRight
                  , g = a.paddingTop + a.paddingBottom
                  , v = a.marginLeft + a.marginRight
                  , y = a.marginTop + a.marginBottom
                  , b = a.borderLeftWidth + a.borderRightWidth
                  , w = a.borderTopWidth + a.borderBottomWidth
                  , x = c && s
                  , _ = e(o.width);
                _ !== !1 && (a.width = _ + (x ? 0 : m + b));
                var C = e(o.height);
                return C !== !1 && (a.height = C + (x ? 0 : g + w)),
                a.innerWidth = a.width - (m + b),
                a.innerHeight = a.height - (g + w),
                a.outerWidth = a.width + v,
                a.outerHeight = a.height + y,
                a
            }
        }
        var s, a = "undefined" == typeof console ? t : function(e) {
            console.error(e)
        }
        , l = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"], u = l.length, c = !1;
        return o
    }),
    /**
   * matchesSelector v2.0.2
   * matchesSelector( element, '.selector' )
   * MIT license
   */
    function(e, t) {
        "use strict";
        "function" == typeof define && define.amd ? define("desandro-matches-selector/matches-selector", t) : "object" == typeof module && module.exports ? module.exports = t() : e.matchesSelector = t()
    }(window, function() {
        "use strict";
        var e = function() {
            var e = window.Element.prototype;
            if (e.matches)
                return "matches";
            if (e.matchesSelector)
                return "matchesSelector";
            for (var t = ["webkit", "moz", "ms", "o"], n = 0; n < t.length; n++) {
                var i = t[n]
                  , r = i + "MatchesSelector";
                if (e[r])
                    return r
            }
        }();
        return function(t, n) {
            return t[e](n)
        }
    }),
    /**
   * Fizzy UI utils v2.0.7
   * MIT license
   */
    function(e, t) {
        "function" == typeof define && define.amd ? define("fizzy-ui-utils/utils", ["desandro-matches-selector/matches-selector"], function(n) {
            return t(e, n)
        }) : "object" == typeof module && module.exports ? module.exports = t(e, require("desandro-matches-selector")) : e.fizzyUIUtils = t(e, e.matchesSelector)
    }(window, function(e, t) {
        var n = {};
        n.extend = function(e, t) {
            for (var n in t)
                e[n] = t[n];
            return e
        }
        ,
        n.modulo = function(e, t) {
            return (e % t + t) % t
        }
        ;
        var i = Array.prototype.slice;
        n.makeArray = function(e) {
            if (Array.isArray(e))
                return e;
            if (null === e || void 0 === e)
                return [];
            var t = "object" == typeof e && "number" == typeof e.length;
            return t ? i.call(e) : [e]
        }
        ,
        n.removeFrom = function(e, t) {
            var n = e.indexOf(t);
            n != -1 && e.splice(n, 1)
        }
        ,
        n.getParent = function(e, n) {
            for (; e.parentNode && e != document.body; )
                if (e = e.parentNode,
                t(e, n))
                    return e
        }
        ,
        n.getQueryElement = function(e) {
            return "string" == typeof e ? document.querySelector(e) : e
        }
        ,
        n.handleEvent = function(e) {
            var t = "on" + e.type;
            this[t] && this[t](e)
        }
        ,
        n.filterFindElements = function(e, i) {
            e = n.makeArray(e);
            var r = [];
            return e.forEach(function(e) {
                if (e instanceof HTMLElement) {
                    if (!i)
                        return void r.push(e);
                    t(e, i) && r.push(e);
                    for (var n = e.querySelectorAll(i), o = 0; o < n.length; o++)
                        r.push(n[o])
                }
            }),
            r
        }
        ,
        n.debounceMethod = function(e, t, n) {
            n = n || 100;
            var i = e.prototype[t]
              , r = t + "Timeout";
            e.prototype[t] = function() {
                var e = this[r];
                clearTimeout(e);
                var t = arguments
                  , o = this;
                this[r] = setTimeout(function() {
                    i.apply(o, t),
                    delete o[r]
                }, n)
            }
        }
        ,
        n.docReady = function(e) {
            var t = document.readyState;
            "complete" == t || "interactive" == t ? setTimeout(e) : document.addEventListener("DOMContentLoaded", e)
        }
        ,
        n.toDashed = function(e) {
            return e.replace(/(.)([A-Z])/g, function(e, t, n) {
                return t + "-" + n
            }).toLowerCase()
        }
        ;
        var r = e.console;
        return n.htmlInit = function(t, i) {
            n.docReady(function() {
                var o = n.toDashed(i)
                  , s = "data-" + o
                  , a = document.querySelectorAll("[" + s + "]")
                  , l = document.querySelectorAll(".js-" + o)
                  , u = n.makeArray(a).concat(n.makeArray(l))
                  , c = s + "-options"
                  , d = e.jQuery;
                u.forEach(function(e) {
                    var n, o = e.getAttribute(s) || e.getAttribute(c);
                    try {
                        n = o && JSON.parse(o)
                    } catch (t) {
                        return void (r && r.error("Error parsing " + s + " on " + e.className + ": " + t))
                    }
                    var a = new t(e,n);
                    d && d.data(e, i, a)
                })
            })
        }
        ,
        n
    }),
    function(e, t) {
        "function" == typeof define && define.amd ? define("flickity/js/cell", ["get-size/get-size"], function(n) {
            return t(e, n)
        }) : "object" == typeof module && module.exports ? module.exports = t(e, require("get-size")) : (e.Flickity = e.Flickity || {},
        e.Flickity.Cell = t(e, e.getSize))
    }(window, function(e, t) {
        function n(e, t) {
            this.element = e,
            this.parent = t,
            this.create()
        }
        var i = n.prototype;
        return i.create = function() {
            this.element.style.position = "absolute",
            this.element.setAttribute("aria-selected", "false"),
            this.x = 0,
            this.shift = 0
        }
        ,
        i.destroy = function() {
            this.element.style.position = "";
            var e = this.parent.originSide;
            this.element.removeAttribute("aria-selected"),
            this.element.style[e] = ""
        }
        ,
        i.getSize = function() {
            this.size = t(this.element)
        }
        ,
        i.setPosition = function(e) {
            this.x = e,
            this.updateTarget(),
            this.renderPosition(e)
        }
        ,
        i.updateTarget = i.setDefaultTarget = function() {
            var e = "left" == this.parent.originSide ? "marginLeft" : "marginRight";
            this.target = this.x + this.size[e] + this.size.width * this.parent.cellAlign
        }
        ,
        i.renderPosition = function(e) {
            var t = this.parent.originSide;
            this.element.style[t] = this.parent.getPositionValue(e)
        }
        ,
        i.wrapShift = function(e) {
            this.shift = e,
            this.renderPosition(this.x + this.parent.slideableWidth * e)
        }
        ,
        i.remove = function() {
            this.element.parentNode.removeChild(this.element)
        }
        ,
        n
    }),
    function(e, t) {
        "function" == typeof define && define.amd ? define("flickity/js/slide", t) : "object" == typeof module && module.exports ? module.exports = t() : (e.Flickity = e.Flickity || {},
        e.Flickity.Slide = t())
    }(window, function() {
        "use strict";
        function e(e) {
            this.parent = e,
            this.isOriginLeft = "left" == e.originSide,
            this.cells = [],
            this.outerWidth = 0,
            this.height = 0
        }
        var t = e.prototype;
        return t.addCell = function(e) {
            if (this.cells.push(e),
            this.outerWidth += e.size.outerWidth,
            this.height = Math.max(e.size.outerHeight, this.height),
            1 == this.cells.length) {
                this.x = e.x;
                var t = this.isOriginLeft ? "marginLeft" : "marginRight";
                this.firstMargin = e.size[t]
            }
        }
        ,
        t.updateTarget = function() {
            var e = this.isOriginLeft ? "marginRight" : "marginLeft"
              , t = this.getLastCell()
              , n = t ? t.size[e] : 0
              , i = this.outerWidth - (this.firstMargin + n);
            this.target = this.x + this.firstMargin + i * this.parent.cellAlign
        }
        ,
        t.getLastCell = function() {
            return this.cells[this.cells.length - 1]
        }
        ,
        t.select = function() {
            this.changeSelected(!0)
        }
        ,
        t.unselect = function() {
            this.changeSelected(!1)
        }
        ,
        t.changeSelected = function(e) {
            var t = e ? "add" : "remove";
            this.cells.forEach(function(n) {
                n.element.classList[t]("is-selected"),
                n.element.setAttribute("aria-selected", e.toString())
            })
        }
        ,
        t.getCellElements = function() {
            return this.cells.map(function(e) {
                return e.element
            })
        }
        ,
        e
    }),
    function(e, t) {
        "function" == typeof define && define.amd ? define("flickity/js/animate", ["fizzy-ui-utils/utils"], function(n) {
            return t(e, n)
        }) : "object" == typeof module && module.exports ? module.exports = t(e, require("fizzy-ui-utils")) : (e.Flickity = e.Flickity || {},
        e.Flickity.animatePrototype = t(e, e.fizzyUIUtils))
    }(window, function(e, t) {
        var n = {};
        return n.startAnimation = function() {
            this.isAnimating || (this.isAnimating = !0,
            this.restingFrames = 0,
            this.animate())
        }
        ,
        n.animate = function() {
            this.applyDragForce(),
            this.applySelectedAttraction();
            var e = this.x;
            if (this.integratePhysics(),
            this.positionSlider(),
            this.settle(e),
            this.isAnimating) {
                var t = this;
                requestAnimationFrame(function() {
                    t.animate()
                })
            }
        }
        ,
        n.positionSlider = function() {
            var e = this.x;
            this.options.wrapAround && this.cells.length > 1 && (e = t.modulo(e, this.slideableWidth),
            e -= this.slideableWidth,
            this.shiftWrapCells(e)),
            e += this.cursorPosition,
            e = this.options.rightToLeft ? -e : e;
            var n = this.getPositionValue(e);
            this.slider.style.transform = this.isAnimating ? "translate3d(" + n + ",0,0)" : "translateX(" + n + ")";
            var i = this.slides[0];
            if (i) {
                var r = -this.x - i.target
                  , o = r / this.slidesWidth;
                this.dispatchEvent("scroll", null, [o, r])
            }
        }
        ,
        n.positionSliderAtSelected = function() {
            this.cells.length && (this.x = -this.selectedSlide.target,
            this.velocity = 0,
            this.positionSlider())
        }
        ,
        n.getPositionValue = function(e) {
            return this.options.percentPosition ? .01 * Math.round(e / this.size.innerWidth * 1e4) + "%" : Math.round(e) + "px"
        }
        ,
        n.settle = function(e) {
            this.isPointerDown || Math.round(100 * this.x) != Math.round(100 * e) || this.restingFrames++,
            this.restingFrames > 2 && (this.isAnimating = !1,
            delete this.isFreeScrolling,
            this.positionSlider(),
            this.dispatchEvent("settle", null, [this.selectedIndex]))
        }
        ,
        n.shiftWrapCells = function(e) {
            var t = this.cursorPosition + e;
            this._shiftCells(this.beforeShiftCells, t, -1);
            var n = this.size.innerWidth - (e + this.slideableWidth + this.cursorPosition);
            this._shiftCells(this.afterShiftCells, n, 1)
        }
        ,
        n._shiftCells = function(e, t, n) {
            for (var i = 0; i < e.length; i++) {
                var r = e[i]
                  , o = t > 0 ? n : 0;
                r.wrapShift(o),
                t -= r.size.outerWidth
            }
        }
        ,
        n._unshiftCells = function(e) {
            if (e && e.length)
                for (var t = 0; t < e.length; t++)
                    e[t].wrapShift(0)
        }
        ,
        n.integratePhysics = function() {
            this.x += this.velocity,
            this.velocity *= this.getFrictionFactor()
        }
        ,
        n.applyForce = function(e) {
            this.velocity += e
        }
        ,
        n.getFrictionFactor = function() {
            return 1 - this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"]
        }
        ,
        n.getRestingPosition = function() {
            return this.x + this.velocity / (1 - this.getFrictionFactor())
        }
        ,
        n.applyDragForce = function() {
            if (this.isDraggable && this.isPointerDown) {
                var e = this.dragX - this.x
                  , t = e - this.velocity;
                this.applyForce(t)
            }
        }
        ,
        n.applySelectedAttraction = function() {
            var e = this.isDraggable && this.isPointerDown;
            if (!e && !this.isFreeScrolling && this.slides.length) {
                var t = this.selectedSlide.target * -1 - this.x
                  , n = t * this.options.selectedAttraction;
                this.applyForce(n)
            }
        }
        ,
        n
    }),
    function(e, t) {
        if ("function" == typeof define && define.amd)
            define("flickity/js/flickity", ["ev-emitter/ev-emitter", "get-size/get-size", "fizzy-ui-utils/utils", "./cell", "./slide", "./animate"], function(n, i, r, o, s, a) {
                return t(e, n, i, r, o, s, a)
            });
        else if ("object" == typeof module && module.exports)
            module.exports = t(e, require("ev-emitter"), require("get-size"), require("fizzy-ui-utils"), require("./cell"), require("./slide"), require("./animate"));
        else {
            var n = e.Flickity;
            e.Flickity = t(e, e.EvEmitter, e.getSize, e.fizzyUIUtils, n.Cell, n.Slide, n.animatePrototype)
        }
    }(window, function(e, t, n, i, r, o, s) {
        function a(e, t) {
            for (e = i.makeArray(e); e.length; )
                t.appendChild(e.shift())
        }
        function l(e, t) {
            var n = i.getQueryElement(e);
            if (!n)
                return void (d && d.error("Bad element for Flickity: " + (n || e)));
            if (this.element = n,
            this.element.flickityGUID) {
                var r = h[this.element.flickityGUID];
                return r.option(t),
                r
            }
            u && (this.$element = u(this.element)),
            this.options = i.extend({}, this.constructor.defaults),
            this.option(t),
            this._create()
        }
        var u = e.jQuery
          , c = e.getComputedStyle
          , d = e.console
          , f = 0
          , h = {};
        l.defaults = {
            accessibility: !0,
            cellAlign: "center",
            freeScrollFriction: .075,
            friction: .28,
            namespaceJQueryEvents: !0,
            percentPosition: !0,
            resize: !0,
            selectedAttraction: .025,
            setGallerySize: !0
        },
        l.createMethods = [];
        var p = l.prototype;
        i.extend(p, t.prototype),
        p._create = function() {
            var t = this.guid = ++f;
            this.element.flickityGUID = t,
            h[t] = this,
            this.selectedIndex = 0,
            this.restingFrames = 0,
            this.x = 0,
            this.velocity = 0,
            this.originSide = this.options.rightToLeft ? "right" : "left",
            this.viewport = document.createElement("div"),
            this.viewport.className = "flickity-viewport",
            this._createSlider(),
            (this.options.resize || this.options.watchCSS) && e.addEventListener("resize", this);
            for (var n in this.options.on) {
                var i = this.options.on[n];
                this.on(n, i)
            }
            l.createMethods.forEach(function(e) {
                this[e]()
            }, this),
            this.options.watchCSS ? this.watchCSS() : this.activate()
        }
        ,
        p.option = function(e) {
            i.extend(this.options, e)
        }
        ,
        p.activate = function() {
            if (!this.isActive) {
                this.isActive = !0,
                this.element.classList.add("flickity-enabled"),
                this.options.rightToLeft && this.element.classList.add("flickity-rtl"),
                this.getSize();
                var e = this._filterFindCellElements(this.element.children);
                a(e, this.slider),
                this.viewport.appendChild(this.slider),
                this.element.appendChild(this.viewport),
                this.reloadCells(),
                this.options.accessibility && (this.element.tabIndex = 0,
                this.element.addEventListener("keydown", this)),
                this.emitEvent("activate");
                var t, n = this.options.initialIndex;
                t = this.isInitActivated ? this.selectedIndex : void 0 !== n && this.cells[n] ? n : 0,
                this.select(t, !1, !0),
                this.isInitActivated = !0,
                this.dispatchEvent("ready")
            }
        }
        ,
        p._createSlider = function() {
            var e = document.createElement("div");
            e.className = "flickity-slider",
            e.style[this.originSide] = 0,
            this.slider = e
        }
        ,
        p._filterFindCellElements = function(e) {
            return i.filterFindElements(e, this.options.cellSelector)
        }
        ,
        p.reloadCells = function() {
            this.cells = this._makeCells(this.slider.children),
            this.positionCells(),
            this._getWrapShiftCells(),
            this.setGallerySize()
        }
        ,
        p._makeCells = function(e) {
            var t = this._filterFindCellElements(e)
              , n = t.map(function(e) {
                return new r(e,this)
            }, this);
            return n
        }
        ,
        p.getLastCell = function() {
            return this.cells[this.cells.length - 1]
        }
        ,
        p.getLastSlide = function() {
            return this.slides[this.slides.length - 1]
        }
        ,
        p.positionCells = function() {
            this._sizeCells(this.cells),
            this._positionCells(0)
        }
        ,
        p._positionCells = function(e) {
            e = e || 0,
            this.maxCellHeight = e ? this.maxCellHeight || 0 : 0;
            var t = 0;
            if (e > 0) {
                var n = this.cells[e - 1];
                t = n.x + n.size.outerWidth
            }
            for (var i = this.cells.length, r = e; r < i; r++) {
                var o = this.cells[r];
                o.setPosition(t),
                t += o.size.outerWidth,
                this.maxCellHeight = Math.max(o.size.outerHeight, this.maxCellHeight)
            }
            this.slideableWidth = t,
            this.updateSlides(),
            this._containSlides(),
            this.slidesWidth = i ? this.getLastSlide().target - this.slides[0].target : 0
        }
        ,
        p._sizeCells = function(e) {
            e.forEach(function(e) {
                e.getSize()
            })
        }
        ,
        p.updateSlides = function() {
            if (this.slides = [],
            this.cells.length) {
                var e = new o(this);
                this.slides.push(e);
                var t = "left" == this.originSide
                  , n = t ? "marginRight" : "marginLeft"
                  , i = this._getCanCellFit();
                this.cells.forEach(function(t, r) {
                    if (!e.cells.length)
                        return void e.addCell(t);
                    var s = e.outerWidth - e.firstMargin + (t.size.outerWidth - t.size[n]);
                    i.call(this, r, s) ? e.addCell(t) : (e.updateTarget(),
                    e = new o(this),
                    this.slides.push(e),
                    e.addCell(t))
                }, this),
                e.updateTarget(),
                this.updateSelectedSlide()
            }
        }
        ,
        p._getCanCellFit = function() {
            var e = this.options.groupCells;
            if (!e)
                return function() {
                    return !1
                }
                ;
            if ("number" == typeof e) {
                var t = parseInt(e, 10);
                return function(e) {
                    return e % t !== 0
                }
            }
            var n = "string" == typeof e && e.match(/^(\d+)%$/)
              , i = n ? parseInt(n[1], 10) / 100 : 1;
            return function(e, t) {
                return t <= (this.size.innerWidth + 1) * i
            }
        }
        ,
        p._init = p.reposition = function() {
            this.positionCells(),
            this.positionSliderAtSelected()
        }
        ,
        p.getSize = function() {
            this.size = n(this.element),
            this.setCellAlign(),
            this.cursorPosition = this.size.innerWidth * this.cellAlign
        }
        ;
        var m = {
            center: {
                left: .5,
                right: .5
            },
            left: {
                left: 0,
                right: 1
            },
            right: {
                right: 0,
                left: 1
            }
        };
        return p.setCellAlign = function() {
            var e = m[this.options.cellAlign];
            this.cellAlign = e ? e[this.originSide] : this.options.cellAlign
        }
        ,
        p.setGallerySize = function() {
            if (this.options.setGallerySize) {
                var e = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
                this.viewport.style.height = e + "px"
            }
        }
        ,
        p._getWrapShiftCells = function() {
            if (this.options.wrapAround) {
                this._unshiftCells(this.beforeShiftCells),
                this._unshiftCells(this.afterShiftCells);
                var e = this.cursorPosition
                  , t = this.cells.length - 1;
                this.beforeShiftCells = this._getGapCells(e, t, -1),
                e = this.size.innerWidth - this.cursorPosition,
                this.afterShiftCells = this._getGapCells(e, 0, 1)
            }
        }
        ,
        p._getGapCells = function(e, t, n) {
            for (var i = []; e > 0; ) {
                var r = this.cells[t];
                if (!r)
                    break;
                i.push(r),
                t += n,
                e -= r.size.outerWidth
            }
            return i
        }
        ,
        p._containSlides = function() {
            if (this.options.contain && !this.options.wrapAround && this.cells.length) {
                var e = this.options.rightToLeft
                  , t = e ? "marginRight" : "marginLeft"
                  , n = e ? "marginLeft" : "marginRight"
                  , i = this.slideableWidth - this.getLastCell().size[n]
                  , r = i < this.size.innerWidth
                  , o = this.cursorPosition + this.cells[0].size[t]
                  , s = i - this.size.innerWidth * (1 - this.cellAlign);
                this.slides.forEach(function(e) {
                    r ? e.target = i * this.cellAlign : (e.target = Math.max(e.target, o),
                    e.target = Math.min(e.target, s))
                }, this)
            }
        }
        ,
        p.dispatchEvent = function(e, t, n) {
            var i = t ? [t].concat(n) : n;
            if (this.emitEvent(e, i),
            u && this.$element) {
                e += this.options.namespaceJQueryEvents ? ".flickity" : "";
                var r = e;
                if (t) {
                    var o = u.Event(t);
                    o.type = e,
                    r = o
                }
                this.$element.trigger(r, n)
            }
        }
        ,
        p.select = function(e, t, n) {
            if (this.isActive && (e = parseInt(e, 10),
            this._wrapSelect(e),
            (this.options.wrapAround || t) && (e = i.modulo(e, this.slides.length)),
            this.slides[e])) {
                var r = this.selectedIndex;
                this.selectedIndex = e,
                this.updateSelectedSlide(),
                n ? this.positionSliderAtSelected() : this.startAnimation(),
                this.options.adaptiveHeight && this.setGallerySize(),
                this.dispatchEvent("select", null, [e]),
                e != r && this.dispatchEvent("change", null, [e]),
                this.dispatchEvent("cellSelect")
            }
        }
        ,
        p._wrapSelect = function(e) {
            var t = this.slides.length
              , n = this.options.wrapAround && t > 1;
            if (!n)
                return e;
            var r = i.modulo(e, t)
              , o = Math.abs(r - this.selectedIndex)
              , s = Math.abs(r + t - this.selectedIndex)
              , a = Math.abs(r - t - this.selectedIndex);
            !this.isDragSelect && s < o ? e += t : !this.isDragSelect && a < o && (e -= t),
            e < 0 ? this.x -= this.slideableWidth : e >= t && (this.x += this.slideableWidth)
        }
        ,
        p.previous = function(e, t) {
            this.select(this.selectedIndex - 1, e, t)
        }
        ,
        p.next = function(e, t) {
            this.select(this.selectedIndex + 1, e, t)
        }
        ,
        p.updateSelectedSlide = function() {
            var e = this.slides[this.selectedIndex];
            e && (this.unselectSelectedSlide(),
            this.selectedSlide = e,
            e.select(),
            this.selectedCells = e.cells,
            this.selectedElements = e.getCellElements(),
            this.selectedCell = e.cells[0],
            this.selectedElement = this.selectedElements[0])
        }
        ,
        p.unselectSelectedSlide = function() {
            this.selectedSlide && this.selectedSlide.unselect()
        }
        ,
        p.selectCell = function(e, t, n) {
            var i = this.queryCell(e);
            if (i) {
                var r = this.getCellSlideIndex(i);
                this.select(r, t, n)
            }
        }
        ,
        p.getCellSlideIndex = function(e) {
            for (var t = 0; t < this.slides.length; t++) {
                var n = this.slides[t]
                  , i = n.cells.indexOf(e);
                if (i != -1)
                    return t
            }
        }
        ,
        p.getCell = function(e) {
            for (var t = 0; t < this.cells.length; t++) {
                var n = this.cells[t];
                if (n.element == e)
                    return n
            }
        }
        ,
        p.getCells = function(e) {
            e = i.makeArray(e);
            var t = [];
            return e.forEach(function(e) {
                var n = this.getCell(e);
                n && t.push(n)
            }, this),
            t
        }
        ,
        p.getCellElements = function() {
            return this.cells.map(function(e) {
                return e.element
            })
        }
        ,
        p.getParentCell = function(e) {
            var t = this.getCell(e);
            return t ? t : (e = i.getParent(e, ".flickity-slider > *"),
            this.getCell(e))
        }
        ,
        p.getAdjacentCellElements = function(e, t) {
            if (!e)
                return this.selectedSlide.getCellElements();
            t = void 0 === t ? this.selectedIndex : t;
            var n = this.slides.length;
            if (1 + 2 * e >= n)
                return this.getCellElements();
            for (var r = [], o = t - e; o <= t + e; o++) {
                var s = this.options.wrapAround ? i.modulo(o, n) : o
                  , a = this.slides[s];
                a && (r = r.concat(a.getCellElements()))
            }
            return r
        }
        ,
        p.queryCell = function(e) {
            return "number" == typeof e ? this.cells[e] : ("string" == typeof e && (e = this.element.querySelector(e)),
            this.getCell(e))
        }
        ,
        p.uiChange = function() {
            this.emitEvent("uiChange")
        }
        ,
        p.childUIPointerDown = function(e) {
            this.emitEvent("childUIPointerDown", [e])
        }
        ,
        p.onresize = function() {
            this.watchCSS(),
            this.resize()
        }
        ,
        i.debounceMethod(l, "onresize", 150),
        p.resize = function() {
            if (this.isActive) {
                this.getSize(),
                this.options.wrapAround && (this.x = i.modulo(this.x, this.slideableWidth)),
                this.positionCells(),
                this._getWrapShiftCells(),
                this.setGallerySize(),
                this.emitEvent("resize");
                var e = this.selectedElements && this.selectedElements[0];
                this.selectCell(e, !1, !0)
            }
        }
        ,
        p.watchCSS = function() {
            var e = this.options.watchCSS;
            if (e) {
                var t = c(this.element, ":after").content;
                t.indexOf("flickity") != -1 ? this.activate() : this.deactivate()
            }
        }
        ,
        p.onkeydown = function(e) {
            var t = document.activeElement && document.activeElement != this.element;
            if (this.options.accessibility && !t) {
                var n = l.keyboardHandlers[e.keyCode];
                n && n.call(this)
            }
        }
        ,
        l.keyboardHandlers = {
            37: function() {
                var e = this.options.rightToLeft ? "next" : "previous";
                this.uiChange(),
                this[e]()
            },
            39: function() {
                var e = this.options.rightToLeft ? "previous" : "next";
                this.uiChange(),
                this[e]()
            }
        },
        p.focus = function() {
            var t = e.pageYOffset;
            this.element.focus({
                preventScroll: !0
            }),
            e.pageYOffset != t && e.scrollTo(e.pageXOffset, t)
        }
        ,
        p.deactivate = function() {
            this.isActive && (this.element.classList.remove("flickity-enabled"),
            this.element.classList.remove("flickity-rtl"),
            this.unselectSelectedSlide(),
            this.cells.forEach(function(e) {
                e.destroy()
            }),
            this.element.removeChild(this.viewport),
            a(this.slider.children, this.element),
            this.options.accessibility && (this.element.removeAttribute("tabIndex"),
            this.element.removeEventListener("keydown", this)),
            this.isActive = !1,
            this.emitEvent("deactivate"))
        }
        ,
        p.destroy = function() {
            this.deactivate(),
            e.removeEventListener("resize", this),
            this.emitEvent("destroy"),
            u && this.$element && u.removeData(this.element, "flickity"),
            delete this.element.flickityGUID,
            delete h[this.guid]
        }
        ,
        i.extend(p, s),
        l.data = function(e) {
            e = i.getQueryElement(e);
            var t = e && e.flickityGUID;
            return t && h[t]
        }
        ,
        i.htmlInit(l, "flickity"),
        u && u.bridget && u.bridget("flickity", l),
        l.setJQuery = function(e) {
            u = e
        }
        ,
        l.Cell = r,
        l
    }),
    /*!
   * Unipointer v2.3.0
   * base class for doing one thing with pointer event
   * MIT license
   */
    function(e, t) {
        "function" == typeof define && define.amd ? define("unipointer/unipointer", ["ev-emitter/ev-emitter"], function(n) {
            return t(e, n)
        }) : "object" == typeof module && module.exports ? module.exports = t(e, require("ev-emitter")) : e.Unipointer = t(e, e.EvEmitter)
    }(window, function(e, t) {
        function n() {}
        function i() {}
        var r = i.prototype = Object.create(t.prototype);
        r.bindStartEvent = function(e) {
            this._bindStartEvent(e, !0)
        }
        ,
        r.unbindStartEvent = function(e) {
            this._bindStartEvent(e, !1)
        }
        ,
        r._bindStartEvent = function(t, n) {
            n = void 0 === n || n;
            var i = n ? "addEventListener" : "removeEventListener"
              , r = "mousedown";
            e.PointerEvent ? r = "pointerdown" : "ontouchstart"in e && (r = "touchstart"),
            t[i](r, this)
        }
        ,
        r.handleEvent = function(e) {
            var t = "on" + e.type;
            this[t] && this[t](e)
        }
        ,
        r.getTouch = function(e) {
            for (var t = 0; t < e.length; t++) {
                var n = e[t];
                if (n.identifier == this.pointerIdentifier)
                    return n
            }
        }
        ,
        r.onmousedown = function(e) {
            var t = e.button;
            t && 0 !== t && 1 !== t || this._pointerDown(e, e)
        }
        ,
        r.ontouchstart = function(e) {
            this._pointerDown(e, e.changedTouches[0])
        }
        ,
        r.onpointerdown = function(e) {
            this._pointerDown(e, e)
        }
        ,
        r._pointerDown = function(e, t) {
            e.button || this.isPointerDown || (this.isPointerDown = !0,
            this.pointerIdentifier = void 0 !== t.pointerId ? t.pointerId : t.identifier,
            this.pointerDown(e, t))
        }
        ,
        r.pointerDown = function(e, t) {
            this._bindPostStartEvents(e),
            this.emitEvent("pointerDown", [e, t])
        }
        ;
        var o = {
            mousedown: ["mousemove", "mouseup"],
            touchstart: ["touchmove", "touchend", "touchcancel"],
            pointerdown: ["pointermove", "pointerup", "pointercancel"]
        };
        return r._bindPostStartEvents = function(t) {
            if (t) {
                var n = o[t.type];
                n.forEach(function(t) {
                    e.addEventListener(t, this)
                }, this),
                this._boundPointerEvents = n
            }
        }
        ,
        r._unbindPostStartEvents = function() {
            this._boundPointerEvents && (this._boundPointerEvents.forEach(function(t) {
                e.removeEventListener(t, this)
            }, this),
            delete this._boundPointerEvents)
        }
        ,
        r.onmousemove = function(e) {
            this._pointerMove(e, e)
        }
        ,
        r.onpointermove = function(e) {
            e.pointerId == this.pointerIdentifier && this._pointerMove(e, e)
        }
        ,
        r.ontouchmove = function(e) {
            var t = this.getTouch(e.changedTouches);
            t && this._pointerMove(e, t)
        }
        ,
        r._pointerMove = function(e, t) {
            this.pointerMove(e, t)
        }
        ,
        r.pointerMove = function(e, t) {
            this.emitEvent("pointerMove", [e, t])
        }
        ,
        r.onmouseup = function(e) {
            this._pointerUp(e, e)
        }
        ,
        r.onpointerup = function(e) {
            e.pointerId == this.pointerIdentifier && this._pointerUp(e, e)
        }
        ,
        r.ontouchend = function(e) {
            var t = this.getTouch(e.changedTouches);
            t && this._pointerUp(e, t)
        }
        ,
        r._pointerUp = function(e, t) {
            this._pointerDone(),
            this.pointerUp(e, t)
        }
        ,
        r.pointerUp = function(e, t) {
            this.emitEvent("pointerUp", [e, t])
        }
        ,
        r._pointerDone = function() {
            this._pointerReset(),
            this._unbindPostStartEvents(),
            this.pointerDone()
        }
        ,
        r._pointerReset = function() {
            this.isPointerDown = !1,
            delete this.pointerIdentifier
        }
        ,
        r.pointerDone = n,
        r.onpointercancel = function(e) {
            e.pointerId == this.pointerIdentifier && this._pointerCancel(e, e)
        }
        ,
        r.ontouchcancel = function(e) {
            var t = this.getTouch(e.changedTouches);
            t && this._pointerCancel(e, t)
        }
        ,
        r._pointerCancel = function(e, t) {
            this._pointerDone(),
            this.pointerCancel(e, t)
        }
        ,
        r.pointerCancel = function(e, t) {
            this.emitEvent("pointerCancel", [e, t])
        }
        ,
        i.getPointerPoint = function(e) {
            return {
                x: e.pageX,
                y: e.pageY
            }
        }
        ,
        i
    }),
    /*!
   * Unidragger v2.3.0
   * Draggable base class
   * MIT license
   */
    function(e, t) {
        "function" == typeof define && define.amd ? define("unidragger/unidragger", ["unipointer/unipointer"], function(n) {
            return t(e, n)
        }) : "object" == typeof module && module.exports ? module.exports = t(e, require("unipointer")) : e.Unidragger = t(e, e.Unipointer)
    }(window, function(e, t) {
        function n() {}
        var i = n.prototype = Object.create(t.prototype);
        i.bindHandles = function() {
            this._bindHandles(!0)
        }
        ,
        i.unbindHandles = function() {
            this._bindHandles(!1)
        }
        ,
        i._bindHandles = function(t) {
            t = void 0 === t || t;
            for (var n = t ? "addEventListener" : "removeEventListener", i = (t ? this._touchActionValue : "",
            0); i < this.handles.length; i++) {
                var r = this.handles[i];
                this._bindStartEvent(r, t),
                r[n]("click", this),
                e.PointerEvent
            }
        }
        ,
        i._touchActionValue = "none",
        i.pointerDown = function(e, t) {
            var n = this.okayPointerDown(e);
            n && (this.pointerDownPointer = t,
            e.preventDefault(),
            this.pointerDownBlur(),
            this._bindPostStartEvents(e),
            this.emitEvent("pointerDown", [e, t]))
        }
        ;
        var r = {
            TEXTAREA: !0,
            INPUT: !0,
            SELECT: !0,
            OPTION: !0
        }
          , o = {
            radio: !0,
            checkbox: !0,
            button: !0,
            submit: !0,
            image: !0,
            file: !0
        };
        return i.okayPointerDown = function(e) {
            var t = r[e.target.nodeName]
              , n = o[e.target.type]
              , i = !t || n;
            return i || this._pointerReset(),
            i
        }
        ,
        i.pointerDownBlur = function() {
            var e = document.activeElement
              , t = e && e.blur && e != document.body;
            t && e.blur()
        }
        ,
        i.pointerMove = function(e, t) {
            var n = this._dragPointerMove(e, t);
            this.emitEvent("pointerMove", [e, t, n]),
            this._dragMove(e, t, n)
        }
        ,
        i._dragPointerMove = function(e, t) {
            var n = {
                x: t.pageX - this.pointerDownPointer.pageX,
                y: t.pageY - this.pointerDownPointer.pageY
            };
            return !this.isDragging && this.hasDragStarted(n) && this._dragStart(e, t),
            n
        }
        ,
        i.hasDragStarted = function(e) {
            return Math.abs(e.x) > 3 || Math.abs(e.y) > 3
        }
        ,
        i.pointerUp = function(e, t) {
            this.emitEvent("pointerUp", [e, t]),
            this._dragPointerUp(e, t)
        }
        ,
        i._dragPointerUp = function(e, t) {
            this.isDragging ? this._dragEnd(e, t) : this._staticClick(e, t)
        }
        ,
        i._dragStart = function(e, t) {
            this.isDragging = !0,
            this.isPreventingClicks = !0,
            this.dragStart(e, t)
        }
        ,
        i.dragStart = function(e, t) {
            this.emitEvent("dragStart", [e, t])
        }
        ,
        i._dragMove = function(e, t, n) {
            this.isDragging && this.dragMove(e, t, n)
        }
        ,
        i.dragMove = function(e, t, n) {
            e.preventDefault(),
            this.emitEvent("dragMove", [e, t, n])
        }
        ,
        i._dragEnd = function(e, t) {
            this.isDragging = !1,
            setTimeout(function() {
                delete this.isPreventingClicks
            }
            .bind(this)),
            this.dragEnd(e, t)
        }
        ,
        i.dragEnd = function(e, t) {
            this.emitEvent("dragEnd", [e, t])
        }
        ,
        i.onclick = function(e) {
            this.isPreventingClicks && e.preventDefault()
        }
        ,
        i._staticClick = function(e, t) {
            this.isIgnoringMouseUp && "mouseup" == e.type || (this.staticClick(e, t),
            "mouseup" != e.type && (this.isIgnoringMouseUp = !0,
            setTimeout(function() {
                delete this.isIgnoringMouseUp
            }
            .bind(this), 400)))
        }
        ,
        i.staticClick = function(e, t) {
            this.emitEvent("staticClick", [e, t])
        }
        ,
        n.getPointerPoint = t.getPointerPoint,
        n
    }),
    function(e, t) {
        "function" == typeof define && define.amd ? define("flickity/js/drag", ["./flickity", "unidragger/unidragger", "fizzy-ui-utils/utils"], function(n, i, r) {
            return t(e, n, i, r)
        }) : "object" == typeof module && module.exports ? module.exports = t(e, require("./flickity"), require("unidragger"), require("fizzy-ui-utils")) : e.Flickity = t(e, e.Flickity, e.Unidragger, e.fizzyUIUtils)
    }(window, function(e, t, n, i) {
        function r() {
            return {
                x: e.pageXOffset,
                y: e.pageYOffset
            }
        }
        i.extend(t.defaults, {
            draggable: ">1",
            dragThreshold: 3
        }),
        t.createMethods.push("_createDrag");
        var o = t.prototype;
        i.extend(o, n.prototype),
        o._touchActionValue = "pan-y";
        var s = "createTouch"in document
          , a = !1;
        o._createDrag = function() {
            this.on("activate", this.onActivateDrag),
            this.on("uiChange", this._uiChangeDrag),
            this.on("childUIPointerDown", this._childUIPointerDownDrag),
            this.on("deactivate", this.onDeactivateDrag),
            this.on("cellChange", this.updateDraggable),
            s && !a && (e.addEventListener("touchmove", function() {}),
            a = !0)
        }
        ,
        o.onActivateDrag = function() {
            this.handles = [this.viewport],
            this.bindHandles(),
            this.updateDraggable()
        }
        ,
        o.onDeactivateDrag = function() {
            this.unbindHandles(),
            this.element.classList.remove("is-draggable")
        }
        ,
        o.updateDraggable = function() {
            ">1" == this.options.draggable ? this.isDraggable = this.slides.length > 1 : this.isDraggable = this.options.draggable,
            this.isDraggable ? this.element.classList.add("is-draggable") : this.element.classList.remove("is-draggable")
        }
        ,
        o.bindDrag = function() {
            this.options.draggable = !0,
            this.updateDraggable()
        }
        ,
        o.unbindDrag = function() {
            this.options.draggable = !1,
            this.updateDraggable()
        }
        ,
        o._uiChangeDrag = function() {
            delete this.isFreeScrolling
        }
        ,
        o._childUIPointerDownDrag = function(e) {
            e.preventDefault(),
            this.pointerDownFocus(e)
        }
        ,
        o.pointerDown = function(t, n) {
            if (!this.isDraggable)
                return void this._pointerDownDefault(t, n);
            var i = this.okayPointerDown(t);
            i && (this._pointerDownPreventDefault(t),
            this.pointerDownFocus(t),
            document.activeElement != this.element && this.pointerDownBlur(),
            this.dragX = this.x,
            this.viewport.classList.add("is-pointer-down"),
            this.pointerDownScroll = r(),
            e.addEventListener("scroll", this),
            this._pointerDownDefault(t, n))
        }
        ,
        o._pointerDownDefault = function(e, t) {
            this.pointerDownPointer = t,
            this._bindPostStartEvents(e),
            this.dispatchEvent("pointerDown", e, [t])
        }
        ;
        var l = {
            INPUT: !0,
            TEXTAREA: !0,
            SELECT: !0
        };
        return o.pointerDownFocus = function(e) {
            var t = l[e.target.nodeName];
            t || this.focus()
        }
        ,
        o._pointerDownPreventDefault = function(e) {
            var t = "touchstart" == e.type
              , n = "touch" == e.pointerType
              , i = l[e.target.nodeName];
            t || n || i || e.preventDefault()
        }
        ,
        o.hasDragStarted = function(e) {
            return Math.abs(e.x) > this.options.dragThreshold
        }
        ,
        o.pointerUp = function(e, t) {
            delete this.isTouchScrolling,
            this.viewport.classList.remove("is-pointer-down"),
            this.dispatchEvent("pointerUp", e, [t]),
            this._dragPointerUp(e, t)
        }
        ,
        o.pointerDone = function() {
            e.removeEventListener("scroll", this),
            delete this.pointerDownScroll
        }
        ,
        o.dragStart = function(t, n) {
            this.isDraggable && (this.dragStartPosition = this.x,
            this.startAnimation(),
            e.removeEventListener("scroll", this),
            this.dispatchEvent("dragStart", t, [n]))
        }
        ,
        o.pointerMove = function(e, t) {
            var n = this._dragPointerMove(e, t);
            this.dispatchEvent("pointerMove", e, [t, n]),
            this._dragMove(e, t, n)
        }
        ,
        o.dragMove = function(e, t, n) {
            if (this.isDraggable) {
                e.preventDefault(),
                this.previousDragX = this.dragX;
                var i = this.options.rightToLeft ? -1 : 1;
                this.options.wrapAround && (n.x = n.x % this.slideableWidth);
                var r = this.dragStartPosition + n.x * i;
                if (!this.options.wrapAround && this.slides.length) {
                    var o = Math.max(-this.slides[0].target, this.dragStartPosition);
                    r = r > o ? .5 * (r + o) : r;
                    var s = Math.min(-this.getLastSlide().target, this.dragStartPosition);
                    r = r < s ? .5 * (r + s) : r
                }
                this.dragX = r,
                this.dragMoveTime = new Date,
                this.dispatchEvent("dragMove", e, [t, n])
            }
        }
        ,
        o.dragEnd = function(e, t) {
            if (this.isDraggable) {
                this.options.freeScroll && (this.isFreeScrolling = !0);
                var n = this.dragEndRestingSelect();
                if (this.options.freeScroll && !this.options.wrapAround) {
                    var i = this.getRestingPosition();
                    this.isFreeScrolling = -i > this.slides[0].target && -i < this.getLastSlide().target
                } else
                    this.options.freeScroll || n != this.selectedIndex || (n += this.dragEndBoostSelect());
                delete this.previousDragX,
                this.isDragSelect = this.options.wrapAround,
                this.select(n),
                delete this.isDragSelect,
                this.dispatchEvent("dragEnd", e, [t])
            }
        }
        ,
        o.dragEndRestingSelect = function() {
            var e = this.getRestingPosition()
              , t = Math.abs(this.getSlideDistance(-e, this.selectedIndex))
              , n = this._getClosestResting(e, t, 1)
              , i = this._getClosestResting(e, t, -1)
              , r = n.distance < i.distance ? n.index : i.index;
            return r
        }
        ,
        o._getClosestResting = function(e, t, n) {
            for (var i = this.selectedIndex, r = 1 / 0, o = this.options.contain && !this.options.wrapAround ? function(e, t) {
                return e <= t
            }
            : function(e, t) {
                return e < t
            }
            ; o(t, r) && (i += n,
            r = t,
            t = this.getSlideDistance(-e, i),
            null !== t); )
                t = Math.abs(t);
            return {
                distance: r,
                index: i - n
            }
        }
        ,
        o.getSlideDistance = function(e, t) {
            var n = this.slides.length
              , r = this.options.wrapAround && n > 1
              , o = r ? i.modulo(t, n) : t
              , s = this.slides[o];
            if (!s)
                return null;
            var a = r ? this.slideableWidth * Math.floor(t / n) : 0;
            return e - (s.target + a)
        }
        ,
        o.dragEndBoostSelect = function() {
            if (void 0 === this.previousDragX || !this.dragMoveTime || new Date - this.dragMoveTime > 100)
                return 0;
            var e = this.getSlideDistance(-this.dragX, this.selectedIndex)
              , t = this.previousDragX - this.dragX;
            return e > 0 && t > 0 ? 1 : e < 0 && t < 0 ? -1 : 0
        }
        ,
        o.staticClick = function(e, t) {
            var n = this.getParentCell(e.target)
              , i = n && n.element
              , r = n && this.cells.indexOf(n);
            this.dispatchEvent("staticClick", e, [t, i, r])
        }
        ,
        o.onscroll = function() {
            var e = r()
              , t = this.pointerDownScroll.x - e.x
              , n = this.pointerDownScroll.y - e.y;
            (Math.abs(t) > 3 || Math.abs(n) > 3) && this._pointerDone()
        }
        ,
        t
    }),
    /*!
   * Tap listener v2.0.0
   * listens to taps
   * MIT license
   */
    function(e, t) {
        "function" == typeof define && define.amd ? define("tap-listener/tap-listener", ["unipointer/unipointer"], function(n) {
            return t(e, n)
        }) : "object" == typeof module && module.exports ? module.exports = t(e, require("unipointer")) : e.TapListener = t(e, e.Unipointer)
    }(window, function(e, t) {
        function n(e) {
            this.bindTap(e)
        }
        var i = n.prototype = Object.create(t.prototype);
        return i.bindTap = function(e) {
            e && (this.unbindTap(),
            this.tapElement = e,
            this._bindStartEvent(e, !0))
        }
        ,
        i.unbindTap = function() {
            this.tapElement && (this._bindStartEvent(this.tapElement, !0),
            delete this.tapElement)
        }
        ,
        i.pointerUp = function(n, i) {
            if (!this.isIgnoringMouseUp || "mouseup" != n.type) {
                var r = t.getPointerPoint(i)
                  , o = this.tapElement.getBoundingClientRect()
                  , s = e.pageXOffset
                  , a = e.pageYOffset
                  , l = r.x >= o.left + s && r.x <= o.right + s && r.y >= o.top + a && r.y <= o.bottom + a;
                if (l && this.emitEvent("tap", [n, i]),
                "mouseup" != n.type) {
                    this.isIgnoringMouseUp = !0;
                    var u = this;
                    setTimeout(function() {
                        delete u.isIgnoringMouseUp
                    }, 400)
                }
            }
        }
        ,
        i.destroy = function() {
            this.pointerDone(),
            this.unbindTap()
        }
        ,
        n
    }),
    function(e, t) {
        "function" == typeof define && define.amd ? define("flickity/js/prev-next-button", ["./flickity", "tap-listener/tap-listener", "fizzy-ui-utils/utils"], function(n, i, r) {
            return t(e, n, i, r)
        }) : "object" == typeof module && module.exports ? module.exports = t(e, require("./flickity"), require("tap-listener"), require("fizzy-ui-utils")) : t(e, e.Flickity, e.TapListener, e.fizzyUIUtils)
    }(window, function(e, t, n, i) {
        "use strict";
        function r(e, t) {
            this.direction = e,
            this.parent = t,
            this._create()
        }
        function o(e) {
            return "string" == typeof e ? e : "M " + e.x0 + ",50 L " + e.x1 + "," + (e.y1 + 50) + " L " + e.x2 + "," + (e.y2 + 50) + " L " + e.x3 + ",50  L " + e.x2 + "," + (50 - e.y2) + " L " + e.x1 + "," + (50 - e.y1) + " Z"
        }
        var s = "http://www.w3.org/2000/svg";
        r.prototype = Object.create(n.prototype),
        r.prototype._create = function() {
            this.isEnabled = !0,
            this.isPrevious = this.direction == -1;
            var e = this.parent.options.rightToLeft ? 1 : -1;
            this.isLeft = this.direction == e;
            var t = this.element = document.createElement("button");
            t.className = "flickity-button flickity-prev-next-button",
            t.className += this.isPrevious ? " previous" : " next",
            t.setAttribute("type", "button"),
            this.disable(),
            t.setAttribute("aria-label", this.isPrevious ? "Previous" : "Next");
            var n = this.createSVG();
            t.appendChild(n),
            this.on("tap", this.onTap),
            this.parent.on("select", this.update.bind(this)),
            this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent))
        }
        ,
        r.prototype.activate = function() {
            this.bindTap(this.element),
            this.element.addEventListener("click", this),
            this.parent.element.appendChild(this.element)
        }
        ,
        r.prototype.deactivate = function() {
            this.parent.element.removeChild(this.element),
            n.prototype.destroy.call(this),
            this.element.removeEventListener("click", this)
        }
        ,
        r.prototype.createSVG = function() {
            var e = document.createElementNS(s, "svg");
            e.setAttribute("class", "flickity-button-icon"),
            e.setAttribute("viewBox", "0 0 100 100");
            var t = document.createElementNS(s, "path")
              , n = o(this.parent.options.arrowShape);
            return t.setAttribute("d", n),
            t.setAttribute("class", "arrow"),
            this.isLeft || t.setAttribute("transform", "translate(100, 100) rotate(180) "),
            e.appendChild(t),
            e
        }
        ,
        r.prototype.onTap = function() {
            if (this.isEnabled) {
                this.parent.uiChange();
                var e = this.isPrevious ? "previous" : "next";
                this.parent[e]()
            }
        }
        ,
        r.prototype.handleEvent = i.handleEvent,
        r.prototype.onclick = function(e) {
            var t = document.activeElement;
            t && t == this.element && this.onTap(e, e)
        }
        ,
        r.prototype.enable = function() {
            this.isEnabled || (this.element.disabled = !1,
            this.isEnabled = !0)
        }
        ,
        r.prototype.disable = function() {
            this.isEnabled && (this.element.disabled = !0,
            this.isEnabled = !1)
        }
        ,
        r.prototype.update = function() {
            var e = this.parent.slides;
            if (this.parent.options.wrapAround && e.length > 1)
                return void this.enable();
            var t = e.length ? e.length - 1 : 0
              , n = this.isPrevious ? 0 : t
              , i = this.parent.selectedIndex == n ? "disable" : "enable";
            this[i]()
        }
        ,
        r.prototype.destroy = function() {
            this.deactivate()
        }
        ,
        i.extend(t.defaults, {
            prevNextButtons: !0,
            arrowShape: {
                x0: 10,
                x1: 60,
                y1: 50,
                x2: 70,
                y2: 40,
                x3: 30
            }
        }),
        t.createMethods.push("_createPrevNextButtons");
        var a = t.prototype;
        return a._createPrevNextButtons = function() {
            this.options.prevNextButtons && (this.prevButton = new r((-1),this),
            this.nextButton = new r(1,this),
            this.on("activate", this.activatePrevNextButtons))
        }
        ,
        a.activatePrevNextButtons = function() {
            this.prevButton.activate(),
            this.nextButton.activate(),
            this.on("deactivate", this.deactivatePrevNextButtons)
        }
        ,
        a.deactivatePrevNextButtons = function() {
            this.prevButton.deactivate(),
            this.nextButton.deactivate(),
            this.off("deactivate", this.deactivatePrevNextButtons)
        }
        ,
        t.PrevNextButton = r,
        t
    }),
    function(e, t) {
        "function" == typeof define && define.amd ? define("flickity/js/page-dots", ["./flickity", "tap-listener/tap-listener", "fizzy-ui-utils/utils"], function(n, i, r) {
            return t(e, n, i, r)
        }) : "object" == typeof module && module.exports ? module.exports = t(e, require("./flickity"), require("tap-listener"), require("fizzy-ui-utils")) : t(e, e.Flickity, e.TapListener, e.fizzyUIUtils)
    }(window, function(e, t, n, i) {
        function r(e) {
            this.parent = e,
            this._create()
        }
        r.prototype = new n,
        r.prototype._create = function() {
            this.holder = document.createElement("ol"),
            this.holder.className = "flickity-page-dots",
            this.dots = [],
            this.on("tap", this.onTap),
            this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent))
        }
        ,
        r.prototype.activate = function() {
            this.setDots(),
            this.bindTap(this.holder),
            this.parent.element.appendChild(this.holder)
        }
        ,
        r.prototype.deactivate = function() {
            this.parent.element.removeChild(this.holder),
            n.prototype.destroy.call(this)
        }
        ,
        r.prototype.setDots = function() {
            var e = this.parent.slides.length - this.dots.length;
            e > 0 ? this.addDots(e) : e < 0 && this.removeDots(-e)
        }
        ,
        r.prototype.addDots = function(e) {
            for (var t = document.createDocumentFragment(), n = [], i = this.dots.length, r = i + e, o = i; o < r; o++) {
                var s = document.createElement("li");
                s.className = "dot",
                s.setAttribute("aria-label", "Page dot " + (o + 1)),
                t.appendChild(s),
                n.push(s)
            }
            this.holder.appendChild(t),
            this.dots = this.dots.concat(n)
        }
        ,
        r.prototype.removeDots = function(e) {
            var t = this.dots.splice(this.dots.length - e, e);
            t.forEach(function(e) {
                this.holder.removeChild(e)
            }, this)
        }
        ,
        r.prototype.updateSelected = function() {
            this.selectedDot && (this.selectedDot.className = "dot",
            this.selectedDot.removeAttribute("aria-current")),
            this.dots.length && (this.selectedDot = this.dots[this.parent.selectedIndex],
            this.selectedDot.className = "dot is-selected",
            this.selectedDot.setAttribute("aria-current", "step"))
        }
        ,
        r.prototype.onTap = function(e) {
            var t = e.target;
            if ("LI" == t.nodeName) {
                this.parent.uiChange();
                var n = this.dots.indexOf(t);
                this.parent.select(n)
            }
        }
        ,
        r.prototype.destroy = function() {
            this.deactivate()
        }
        ,
        t.PageDots = r,
        i.extend(t.defaults, {
            pageDots: !0
        }),
        t.createMethods.push("_createPageDots");
        var o = t.prototype;
        return o._createPageDots = function() {
            this.options.pageDots && (this.pageDots = new r(this),
            this.on("activate", this.activatePageDots),
            this.on("select", this.updateSelectedPageDots),
            this.on("cellChange", this.updatePageDots),
            this.on("resize", this.updatePageDots),
            this.on("deactivate", this.deactivatePageDots))
        }
        ,
        o.activatePageDots = function() {
            this.pageDots.activate()
        }
        ,
        o.updateSelectedPageDots = function() {
            this.pageDots.updateSelected()
        }
        ,
        o.updatePageDots = function() {
            this.pageDots.setDots()
        }
        ,
        o.deactivatePageDots = function() {
            this.pageDots.deactivate()
        }
        ,
        t.PageDots = r,
        t
    }),
    function(e, t) {
        "function" == typeof define && define.amd ? define("flickity/js/player", ["ev-emitter/ev-emitter", "fizzy-ui-utils/utils", "./flickity"], function(e, n, i) {
            return t(e, n, i)
        }) : "object" == typeof module && module.exports ? module.exports = t(require("ev-emitter"), require("fizzy-ui-utils"), require("./flickity")) : t(e.EvEmitter, e.fizzyUIUtils, e.Flickity)
    }(window, function(e, t, n) {
        function i(e) {
            this.parent = e,
            this.state = "stopped",
            this.onVisibilityChange = this.visibilityChange.bind(this),
            this.onVisibilityPlay = this.visibilityPlay.bind(this)
        }
        i.prototype = Object.create(e.prototype),
        i.prototype.play = function() {
            if ("playing" != this.state) {
                var e = document.hidden;
                if (e)
                    return void document.addEventListener("visibilitychange", this.onVisibilityPlay);
                this.state = "playing",
                document.addEventListener("visibilitychange", this.onVisibilityChange),
                this.tick()
            }
        }
        ,
        i.prototype.tick = function() {
            if ("playing" == this.state) {
                var e = this.parent.options.autoPlay;
                e = "number" == typeof e ? e : 3e3;
                var t = this;
                this.clear(),
                this.timeout = setTimeout(function() {
                    t.parent.next(!0),
                    t.tick()
                }, e)
            }
        }
        ,
        i.prototype.stop = function() {
            this.state = "stopped",
            this.clear(),
            document.removeEventListener("visibilitychange", this.onVisibilityChange)
        }
        ,
        i.prototype.clear = function() {
            clearTimeout(this.timeout)
        }
        ,
        i.prototype.pause = function() {
            "playing" == this.state && (this.state = "paused",
            this.clear())
        }
        ,
        i.prototype.unpause = function() {
            "paused" == this.state && this.play()
        }
        ,
        i.prototype.visibilityChange = function() {
            var e = document.hidden;
            this[e ? "pause" : "unpause"]()
        }
        ,
        i.prototype.visibilityPlay = function() {
            this.play(),
            document.removeEventListener("visibilitychange", this.onVisibilityPlay)
        }
        ,
        t.extend(n.defaults, {
            pauseAutoPlayOnHover: !0
        }),
        n.createMethods.push("_createPlayer");
        var r = n.prototype;
        return r._createPlayer = function() {
            this.player = new i(this),
            this.on("activate", this.activatePlayer),
            this.on("uiChange", this.stopPlayer),
            this.on("pointerDown", this.stopPlayer),
            this.on("deactivate", this.deactivatePlayer)
        }
        ,
        r.activatePlayer = function() {
            this.options.autoPlay && (this.player.play(),
            this.element.addEventListener("mouseenter", this))
        }
        ,
        r.playPlayer = function() {
            this.player.play()
        }
        ,
        r.stopPlayer = function() {
            this.player.stop()
        }
        ,
        r.pausePlayer = function() {
            this.player.pause()
        }
        ,
        r.unpausePlayer = function() {
            this.player.unpause()
        }
        ,
        r.deactivatePlayer = function() {
            this.player.stop(),
            this.element.removeEventListener("mouseenter", this)
        }
        ,
        r.onmouseenter = function() {
            this.options.pauseAutoPlayOnHover && (this.player.pause(),
            this.element.addEventListener("mouseleave", this))
        }
        ,
        r.onmouseleave = function() {
            this.player.unpause(),
            this.element.removeEventListener("mouseleave", this)
        }
        ,
        n.Player = i,
        n
    }),
    function(e, t) {
        "function" == typeof define && define.amd ? define("flickity/js/add-remove-cell", ["./flickity", "fizzy-ui-utils/utils"], function(n, i) {
            return t(e, n, i)
        }) : "object" == typeof module && module.exports ? module.exports = t(e, require("./flickity"), require("fizzy-ui-utils")) : t(e, e.Flickity, e.fizzyUIUtils)
    }(window, function(e, t, n) {
        function i(e) {
            var t = document.createDocumentFragment();
            return e.forEach(function(e) {
                t.appendChild(e.element)
            }),
            t
        }
        var r = t.prototype;
        return r.insert = function(e, t) {
            var n = this._makeCells(e);
            if (n && n.length) {
                var r = this.cells.length;
                t = void 0 === t ? r : t;
                var o = i(n)
                  , s = t == r;
                if (s)
                    this.slider.appendChild(o);
                else {
                    var a = this.cells[t].element;
                    this.slider.insertBefore(o, a)
                }
                if (0 === t)
                    this.cells = n.concat(this.cells);
                else if (s)
                    this.cells = this.cells.concat(n);
                else {
                    var l = this.cells.splice(t, r - t);
                    this.cells = this.cells.concat(n).concat(l)
                }
                this._sizeCells(n),
                this.cellChange(t, !0)
            }
        }
        ,
        r.append = function(e) {
            this.insert(e, this.cells.length)
        }
        ,
        r.prepend = function(e) {
            this.insert(e, 0)
        }
        ,
        r.remove = function(e) {
            var t = this.getCells(e);
            if (t && t.length) {
                var i = this.cells.length - 1;
                t.forEach(function(e) {
                    e.remove();
                    var t = this.cells.indexOf(e);
                    i = Math.min(t, i),
                    n.removeFrom(this.cells, e)
                }, this),
                this.cellChange(i, !0)
            }
        }
        ,
        r.cellSizeChange = function(e) {
            var t = this.getCell(e);
            if (t) {
                t.getSize();
                var n = this.cells.indexOf(t);
                this.cellChange(n)
            }
        }
        ,
        r.cellChange = function(e, t) {
            var n = this.selectedElement;
            this._positionCells(e),
            this._getWrapShiftCells(),
            this.setGallerySize();
            var i = this.getCell(n);
            i && (this.selectedIndex = this.getCellSlideIndex(i)),
            this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex),
            this.emitEvent("cellChange", [e]),
            this.select(this.selectedIndex),
            t && this.positionSliderAtSelected()
        }
        ,
        t
    }),
    function(e, t) {
        "function" == typeof define && define.amd ? define("flickity/js/lazyload", ["./flickity", "fizzy-ui-utils/utils"], function(n, i) {
            return t(e, n, i)
        }) : "object" == typeof module && module.exports ? module.exports = t(e, require("./flickity"), require("fizzy-ui-utils")) : t(e, e.Flickity, e.fizzyUIUtils)
    }(window, function(e, t, n) {
        "use strict";
        function i(e) {
            if ("IMG" == e.nodeName) {
                var t = e.getAttribute("data-flickity-lazyload")
                  , i = e.getAttribute("data-flickity-lazyload-src")
                  , r = e.getAttribute("data-flickity-lazyload-srcset");
                if (t || i || r)
                    return [e]
            }
            var o = "img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]"
              , s = e.querySelectorAll(o);
            return n.makeArray(s)
        }
        function r(e, t) {
            this.img = e,
            this.flickity = t,
            this.load()
        }
        t.createMethods.push("_createLazyload");
        var o = t.prototype;
        return o._createLazyload = function() {
            this.on("select", this.lazyLoad)
        }
        ,
        o.lazyLoad = function() {
            var e = this.options.lazyLoad;
            if (e) {
                var t = "number" == typeof e ? e : 0
                  , n = this.getAdjacentCellElements(t)
                  , o = [];
                n.forEach(function(e) {
                    var t = i(e);
                    o = o.concat(t)
                }),
                o.forEach(function(e) {
                    new r(e,this)
                }, this)
            }
        }
        ,
        r.prototype.handleEvent = n.handleEvent,
        r.prototype.load = function() {
            this.img.addEventListener("load", this),
            this.img.addEventListener("error", this);
            var e = this.img.getAttribute("data-flickity-lazyload") || this.img.getAttribute("data-flickity-lazyload-src")
              , t = this.img.getAttribute("data-flickity-lazyload-srcset");
            this.img.src = e,
            t && this.img.setAttribute("srcset", t),
            this.img.removeAttribute("data-flickity-lazyload"),
            this.img.removeAttribute("data-flickity-lazyload-src"),
            this.img.removeAttribute("data-flickity-lazyload-srcset")
        }
        ,
        r.prototype.onload = function(e) {
            this.complete(e, "flickity-lazyloaded")
        }
        ,
        r.prototype.onerror = function(e) {
            this.complete(e, "flickity-lazyerror")
        }
        ,
        r.prototype.complete = function(e, t) {
            this.img.removeEventListener("load", this),
            this.img.removeEventListener("error", this);
            var n = this.flickity.getParentCell(this.img)
              , i = n && n.element;
            this.flickity.cellSizeChange(i),
            this.img.classList.add(t),
            this.flickity.dispatchEvent("lazyLoad", e, i)
        }
        ,
        t.LazyLoader = r,
        t
    }),
    /*!
   * Flickity v2.1.2
   * Touch, responsive, flickable carousels
   *
   * Licensed GPLv3 for open source use
   * or Flickity Commercial License for commercial use
   *
   * https://flickity.metafizzy.co
   * Copyright 2015-2018 Metafizzy
   */
    function(e, t) {
        "function" == typeof define && define.amd ? define("flickity/js/index", ["./flickity", "./drag", "./prev-next-button", "./page-dots", "./player", "./add-remove-cell", "./lazyload"], t) : "object" == typeof module && module.exports && (module.exports = t(require("./flickity"), require("./drag"), require("./prev-next-button"), require("./page-dots"), require("./player"), require("./add-remove-cell"), require("./lazyload")))
    }(window, function(e) {
        return e
    }),
    /*!
   * Flickity asNavFor v2.0.1
   * enable asNavFor for Flickity
   */
    function(e, t) {
        "function" == typeof define && define.amd ? define("flickity-as-nav-for/as-nav-for", ["flickity/js/index", "fizzy-ui-utils/utils"], t) : "object" == typeof module && module.exports ? module.exports = t(require("flickity"), require("fizzy-ui-utils")) : e.Flickity = t(e.Flickity, e.fizzyUIUtils)
    }(window, function(e, t) {
        function n(e, t, n) {
            return (t - e) * n + e
        }
        e.createMethods.push("_createAsNavFor");
        var i = e.prototype;
        return i._createAsNavFor = function() {
            this.on("activate", this.activateAsNavFor),
            this.on("deactivate", this.deactivateAsNavFor),
            this.on("destroy", this.destroyAsNavFor);
            var e = this.options.asNavFor;
            if (e) {
                var t = this;
                setTimeout(function() {
                    t.setNavCompanion(e)
                })
            }
        }
        ,
        i.setNavCompanion = function(n) {
            n = t.getQueryElement(n);
            var i = e.data(n);
            if (i && i != this) {
                this.navCompanion = i;
                var r = this;
                this.onNavCompanionSelect = function() {
                    r.navCompanionSelect()
                }
                ,
                i.on("select", this.onNavCompanionSelect),
                this.on("staticClick", this.onNavStaticClick),
                this.navCompanionSelect(!0)
            }
        }
        ,
        i.navCompanionSelect = function(e) {
            if (this.navCompanion) {
                var t = this.navCompanion.selectedCells[0]
                  , i = this.navCompanion.cells.indexOf(t)
                  , r = i + this.navCompanion.selectedCells.length - 1
                  , o = Math.floor(n(i, r, this.navCompanion.cellAlign));
                if (this.selectCell(o, !1, e),
                this.removeNavSelectedElements(),
                !(o >= this.cells.length)) {
                    var s = this.cells.slice(i, r + 1);
                    this.navSelectedElements = s.map(function(e) {
                        return e.element
                    }),
                    this.changeNavSelectedClass("add")
                }
            }
        }
        ,
        i.changeNavSelectedClass = function(e) {
            this.navSelectedElements.forEach(function(t) {
                t.classList[e]("is-nav-selected")
            })
        }
        ,
        i.activateAsNavFor = function() {
            this.navCompanionSelect(!0)
        }
        ,
        i.removeNavSelectedElements = function() {
            this.navSelectedElements && (this.changeNavSelectedClass("remove"),
            delete this.navSelectedElements)
        }
        ,
        i.onNavStaticClick = function(e, t, n, i) {
            "number" == typeof i && this.navCompanion.selectCell(i)
        }
        ,
        i.deactivateAsNavFor = function() {
            this.removeNavSelectedElements()
        }
        ,
        i.destroyAsNavFor = function() {
            this.navCompanion && (this.navCompanion.off("select", this.onNavCompanionSelect),
            this.off("staticClick", this.onNavStaticClick),
            delete this.navCompanion)
        }
        ,
        e
    }),
    /*!
   * imagesLoaded v4.1.4
   * JavaScript is all like "You images are done yet or what?"
   * MIT License
   */
    function(e, t) {
        "use strict";
        "function" == typeof define && define.amd ? define("imagesloaded/imagesloaded", ["ev-emitter/ev-emitter"], function(n) {
            return t(e, n)
        }) : "object" == typeof module && module.exports ? module.exports = t(e, require("ev-emitter")) : e.imagesLoaded = t(e, e.EvEmitter)
    }("undefined" != typeof window ? window : this, function(e, t) {
        function n(e, t) {
            for (var n in t)
                e[n] = t[n];
            return e
        }
        function i(e) {
            if (Array.isArray(e))
                return e;
            var t = "object" == typeof e && "number" == typeof e.length;
            return t ? u.call(e) : [e]
        }
        function r(e, t, o) {
            if (!(this instanceof r))
                return new r(e,t,o);
            var s = e;
            return "string" == typeof e && (s = document.querySelectorAll(e)),
            s ? (this.elements = i(s),
            this.options = n({}, this.options),
            "function" == typeof t ? o = t : n(this.options, t),
            o && this.on("always", o),
            this.getImages(),
            a && (this.jqDeferred = new a.Deferred),
            void setTimeout(this.check.bind(this))) : void l.error("Bad element for imagesLoaded " + (s || e))
        }
        function o(e) {
            this.img = e
        }
        function s(e, t) {
            this.url = e,
            this.element = t,
            this.img = new Image
        }
        var a = e.jQuery
          , l = e.console
          , u = Array.prototype.slice;
        r.prototype = Object.create(t.prototype),
        r.prototype.options = {},
        r.prototype.getImages = function() {
            this.images = [],
            this.elements.forEach(this.addElementImages, this)
        }
        ,
        r.prototype.addElementImages = function(e) {
            "IMG" == e.nodeName && this.addImage(e),
            this.options.background === !0 && this.addElementBackgroundImages(e);
            var t = e.nodeType;
            if (t && c[t]) {
                for (var n = e.querySelectorAll("img"), i = 0; i < n.length; i++) {
                    var r = n[i];
                    this.addImage(r)
                }
                if ("string" == typeof this.options.background) {
                    var o = e.querySelectorAll(this.options.background);
                    for (i = 0; i < o.length; i++) {
                        var s = o[i];
                        this.addElementBackgroundImages(s)
                    }
                }
            }
        }
        ;
        var c = {
            1: !0,
            9: !0,
            11: !0
        };
        return r.prototype.addElementBackgroundImages = function(e) {
            var t = getComputedStyle(e);
            if (t)
                for (var n = /url\((['"])?(.*?)\1\)/gi, i = n.exec(t.backgroundImage); null !== i; ) {
                    var r = i && i[2];
                    r && this.addBackground(r, e),
                    i = n.exec(t.backgroundImage)
                }
        }
        ,
        r.prototype.addImage = function(e) {
            var t = new o(e);
            this.images.push(t)
        }
        ,
        r.prototype.addBackground = function(e, t) {
            var n = new s(e,t);
            this.images.push(n)
        }
        ,
        r.prototype.check = function() {
            function e(e, n, i) {
                setTimeout(function() {
                    t.progress(e, n, i)
                })
            }
            var t = this;
            return this.progressedCount = 0,
            this.hasAnyBroken = !1,
            this.images.length ? void this.images.forEach(function(t) {
                t.once("progress", e),
                t.check()
            }) : void this.complete()
        }
        ,
        r.prototype.progress = function(e, t, n) {
            this.progressedCount++,
            this.hasAnyBroken = this.hasAnyBroken || !e.isLoaded,
            this.emitEvent("progress", [this, e, t]),
            this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, e),
            this.progressedCount == this.images.length && this.complete(),
            this.options.debug && l && l.log("progress: " + n, e, t)
        }
        ,
        r.prototype.complete = function() {
            var e = this.hasAnyBroken ? "fail" : "done";
            if (this.isComplete = !0,
            this.emitEvent(e, [this]),
            this.emitEvent("always", [this]),
            this.jqDeferred) {
                var t = this.hasAnyBroken ? "reject" : "resolve";
                this.jqDeferred[t](this)
            }
        }
        ,
        o.prototype = Object.create(t.prototype),
        o.prototype.check = function() {
            var e = this.getIsImageComplete();
            return e ? void this.confirm(0 !== this.img.naturalWidth, "naturalWidth") : (this.proxyImage = new Image,
            this.proxyImage.addEventListener("load", this),
            this.proxyImage.addEventListener("error", this),
            this.img.addEventListener("load", this),
            this.img.addEventListener("error", this),
            void (this.proxyImage.src = this.img.src))
        }
        ,
        o.prototype.getIsImageComplete = function() {
            return this.img.complete && this.img.naturalWidth
        }
        ,
        o.prototype.confirm = function(e, t) {
            this.isLoaded = e,
            this.emitEvent("progress", [this, this.img, t])
        }
        ,
        o.prototype.handleEvent = function(e) {
            var t = "on" + e.type;
            this[t] && this[t](e)
        }
        ,
        o.prototype.onload = function() {
            this.confirm(!0, "onload"),
            this.unbindEvents()
        }
        ,
        o.prototype.onerror = function() {
            this.confirm(!1, "onerror"),
            this.unbindEvents()
        }
        ,
        o.prototype.unbindEvents = function() {
            this.proxyImage.removeEventListener("load", this),
            this.proxyImage.removeEventListener("error", this),
            this.img.removeEventListener("load", this),
            this.img.removeEventListener("error", this)
        }
        ,
        s.prototype = Object.create(o.prototype),
        s.prototype.check = function() {
            this.img.addEventListener("load", this),
            this.img.addEventListener("error", this),
            this.img.src = this.url;
            var e = this.getIsImageComplete();
            e && (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"),
            this.unbindEvents())
        }
        ,
        s.prototype.unbindEvents = function() {
            this.img.removeEventListener("load", this),
            this.img.removeEventListener("error", this)
        }
        ,
        s.prototype.confirm = function(e, t) {
            this.isLoaded = e,
            this.emitEvent("progress", [this, this.element, t])
        }
        ,
        r.makeJQueryPlugin = function(t) {
            t = t || e.jQuery,
            t && (a = t,
            a.fn.imagesLoaded = function(e, t) {
                var n = new r(this,e,t);
                return n.jqDeferred.promise(a(this))
            }
            )
        }
        ,
        r.makeJQueryPlugin(),
        r
    }),
    /*!
   * Flickity imagesLoaded v2.0.0
   * enables imagesLoaded option for Flickity
   */
    function(e, t) {
        "function" == typeof define && define.amd ? define(["flickity/js/index", "imagesloaded/imagesloaded"], function(n, i) {
            return t(e, n, i)
        }) : "object" == typeof module && module.exports ? module.exports = t(e, require("flickity"), require("imagesloaded")) : e.Flickity = t(e, e.Flickity, e.imagesLoaded)
    }(window, function(e, t, n) {
        "use strict";
        t.createMethods.push("_createImagesLoaded");
        var i = t.prototype;
        return i._createImagesLoaded = function() {
            this.on("activate", this.imagesLoaded)
        }
        ,
        i.imagesLoaded = function() {
            function e(e, n) {
                var i = t.getParentCell(n.img);
                t.cellSizeChange(i && i.element),
                t.options.freeScroll || t.positionSliderAtSelected()
            }
            if (this.options.imagesLoaded) {
                var t = this;
                n(this.slider).on("progress", e)
            }
        }
        ,
        t
    }),
    /*!
   * flickity.fullscreen.js
   */
    /*!
   * Flickity fullscreen v1.1.0
   * Enable fullscreen view for Flickity
   */
    function(e, t) {
        "function" == typeof define && define.amd ? define(["flickity/js/index"], t) : "object" == typeof module && module.exports ? module.exports = t(require("flickity")) : t(e.Flickity)
    }(window, function(e) {
        "use strict";
        function t(e, t) {
            this.name = e,
            this.createButton(),
            this.createIcon(),
            this.onClick = function() {
                t[e + "Fullscreen"]()
            }
            ,
            this.clickHandler = this.onClick.bind(this)
        }
        function n(e) {
            return e[0].toUpperCase() + e.slice(1)
        }
        e.createMethods.push("_createFullscreen");
        var i = e.prototype;
        i._createFullscreen = function() {
            this.isFullscreen = !1,
            this.options.fullscreen && (this.viewFullscreenButton = new t("view",this),
            this.exitFullscreenButton = new t("exit",this),
            this.on("activate", this._changeFullscreenActive),
            this.on("deactivate", this._changeFullscreenActive))
        }
        ,
        i._changeFullscreenActive = function() {
            var e = this.isActive ? "appendChild" : "removeChild";
            this.element[e](this.viewFullscreenButton.element),
            this.element[e](this.exitFullscreenButton.element);
            var t = this.isActive ? "activate" : "deactivate";
            this.viewFullscreenButton[t](),
            this.exitFullscreenButton[t]()
        }
        ,
        i.viewFullscreen = function() {
            this._changeFullscreen(!0),
            this.focus()
        }
        ,
        i.exitFullscreen = function() {
            this._changeFullscreen(!1)
        }
        ,
        i._changeFullscreen = function(e) {
            if (this.isFullscreen != e) {
                this.isFullscreen = e;
                var t = e ? "add" : "remove";
                document.documentElement.classList[t]("is-flickity-fullscreen"),
                this.element.classList[t]("is-fullscreen"),
                this.resize(),
                this.isFullscreen && this.reposition(),
                this.dispatchEvent("fullscreenChange", null, [e])
            }
        }
        ,
        i.toggleFullscreen = function() {
            this._changeFullscreen(!this.isFullscreen)
        }
        ;
        var r = i.setGallerySize;
        i.setGallerySize = function() {
            this.options.setGallerySize && (this.isFullscreen ? this.viewport.style.height = "" : r.call(this))
        }
        ,
        e.keyboardHandlers[27] = function() {
            this.exitFullscreen()
        }
        ,
        t.prototype.createButton = function() {
            var e = this.element = document.createElement("button");
            e.className = "flickity-button flickity-fullscreen-button flickity-fullscreen-button-" + this.name;
            var t = n(this.name + " full-screen");
            e.setAttribute("aria-label", t),
            e.title = t
        }
        ;
        var o = "http://www.w3.org/2000/svg"
          , s = {
            view: "M209,131.74269 L209,153.699805 C209,158.22846 205.2875,161.933723 200.75,161.933723 L162.25,161.933723 L162.25,200.358674 C162.25,204.887329 158.5375,208.592593 154,208.592593 L132,208.592593 C127.4625,208.592593 123.75,204.887329 123.75,200.358674 L123.75,161.933723 L85.25,161.933723 C80.7125,161.933723 77,158.22846 77,153.699805 L77,131.74269 C77,127.214035 80.7125,123.508772 85.25,123.508772 L123.75,123.508772 L123.75,85.0838207 C123.75,80.5551657 127.4625,76.8499025 132,76.8499025 L154,76.8499025 C158.5375,76.8499025 162.25,80.5551657 162.25,85.0838207 L162.25,123.508772 L200.75,123.508772 C205.2875,123.508772 209,127.214035 209,131.74269 Z M347.1875,327.092398 L327.73125,346.510721 C321.26875,352.960624 310.81875,352.960624 304.425,346.510721 L235.8125,278.100585 C232.71875,275.012865 231,270.82729 231,266.435867 L231,255.251462 C206.73125,274.189474 176.20625,285.442495 143,285.442495 C64.00625,285.442495 0,221.561014 0,142.721248 C0,63.8814815 64.00625,0 143,0 C221.99375,0 286,63.8814815 286,142.721248 C286,175.862768 274.725,206.328265 255.75,230.549708 L266.95625,230.549708 C271.35625,230.549708 275.55,232.265107 278.64375,235.352827 L347.1875,303.762963 C353.58125,310.212865 353.58125,320.642495 347.1875,327.092398 Z M236.5,142.721248 C236.5,91.1220273 194.7,49.4035088 143,49.4035088 C91.3,49.4035088 49.5,91.1220273 49.5,142.721248 C49.5,194.320468 91.3,236.038986 143,236.038986 C194.7,236.038986 236.5,194.320468 236.5,142.721248 Z",
            exit: "M242.72,176 L342.79,75.93 C355.07,63.65 355.07,43.74 342.79,31.45 L320.55,9.21 C308.27,-3.07 288.36,-3.07 276.07,9.21 L176,109.28 L75.93,9.21 C63.65,-3.07 43.74,-3.07 31.45,9.21 L9.21,31.45 C-3.07,43.73 -3.07,63.64 9.21,75.93 L109.28,176 L9.21,276.07 C-3.07,288.35 -3.07,308.26 9.21,320.55 L31.45,342.79 C43.73,355.07 63.65,355.07 75.93,342.79 L176,242.72 L276.07,342.79 C288.35,355.07 308.27,355.07 320.55,342.79 L342.79,320.55 C355.07,308.27 355.07,288.36 342.79,276.07 L242.72,176 Z"
        };
        return t.prototype.createIcon = function() {
            var e = document.createElementNS(o, "svg");
            e.setAttribute("class", "flickity-button-icon"),
            e.setAttribute("viewBox", "0 0 352 352");
            var t = document.createElementNS(o, "path")
              , n = s[this.name];
            t.setAttribute("d", n),
            e.appendChild(t),
            this.element.appendChild(e)
        }
        ,
        t.prototype.activate = function() {
            this.element.addEventListener("click", this.clickHandler)
        }
        ,
        t.prototype.deactivate = function() {
            this.element.removeEventListener("click", this.clickHandler)
        }
        ,
        e.FullscreenButton = t,
        e
    }),
    /*!
   * jquery-cookie.js
   */
    /*!
   * jQuery Cookie Plugin v1.4.1
   * https://github.com/carhartl/jquery-cookie
   *
   * Copyright 2006, 2014 Klaus Hartl
   * Released under the MIT license
   */
    function(e) {
        "function" == typeof define && define.amd ? define(["jquery"], e) : "object" == typeof exports ? module.exports = e(require("jquery")) : e(t)
    }(function(e) {
        function t(e) {
            return a.raw ? e : encodeURIComponent(e)
        }
        function n(e) {
            return a.raw ? e : decodeURIComponent(e)
        }
        function i(e) {
            return t(a.json ? JSON.stringify(e) : String(e))
        }
        function r(e) {
            0 === e.indexOf('"') && (e = e.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, "\\"));
            try {
                return e = decodeURIComponent(e.replace(s, " ")),
                a.json ? JSON.parse(e) : e
            } catch (e) {}
        }
        function o(t, n) {
            var i = a.raw ? t : r(t);
            return e.isFunction(n) ? n(i) : i
        }
        var s = /\+/g
          , a = e.cookie = function(r, s, l) {
            if (arguments.length > 1 && !e.isFunction(s)) {
                if (l = e.extend({}, a.defaults, l),
                "number" == typeof l.expires) {
                    var u = l.expires
                      , c = l.expires = new Date;
                    c.setMilliseconds(c.getMilliseconds() + 864e5 * u)
                }
                return document.cookie = [t(r), "=", i(s), l.expires ? "; expires=" + l.expires.toUTCString() : "", l.path ? "; path=" + l.path : "", l.domain ? "; domain=" + l.domain : "", l.secure ? "; secure" : ""].join("")
            }
            for (var d = r ? void 0 : {}, f = document.cookie ? document.cookie.split("; ") : [], h = 0, p = f.length; h < p; h++) {
                var m = f[h].split("=")
                  , g = n(m.shift())
                  , v = m.join("=");
                if (r === g) {
                    d = o(v, s);
                    break
                }
                r || void 0 === (v = o(v)) || (d[g] = v)
            }
            return d
        }
        ;
        a.defaults = {},
        e.removeCookie = function(t, n) {
            return e.cookie(t, "", e.extend({}, n, {
                expires: -1
            })),
            !e.cookie(t)
        }
    }),
    function(e) {
        "use strict";
        e.fn.fitVids = function(t) {
            var n = {
                customSelector: null,
                ignore: null
            };
            if (!document.getElementById("fit-vids-style")) {
                var i = document.head || document.getElementsByTagName("head")[0]
                  , r = ".fluid-width-video-wrapper{width:100%;position:relative;padding:0;}.fluid-width-video-wrapper iframe,.fluid-width-video-wrapper object,.fluid-width-video-wrapper embed {position:absolute;top:0;left:0;width:100%;height:100%;}"
                  , o = document.createElement("div");
                o.innerHTML = '<p>x</p><style id="fit-vids-style">' + r + "</style>",
                i.appendChild(o.childNodes[1])
            }
            return t && e.extend(n, t),
            this.each(function() {
                var t = ['iframe[src*="player.vimeo.com"]', 'iframe[src*="youtube.com"]', 'iframe[src*="youtube-nocookie.com"]', 'iframe[src*="kickstarter.com"][src*="video.html"]', 'iframe[src*="wistia.com"]', 'iframe[src*="wistia.net"]', "object", "embed"];
                n.customSelector && t.push(n.customSelector);
                var i = ".fitvidsignore";
                n.ignore && (i = i + ", " + n.ignore);
                var r = e(this).find(t.join(","));
                r = r.not("object object"),
                r = r.not(i),
                r.each(function(t) {
                    var n = e(this);
                    if (!(n.parents(i).length > 0 || "embed" === this.tagName.toLowerCase() && n.parent("object").length || n.parent(".fluid-width-video-wrapper").length)) {
                        n.css("height") || n.css("width") || !isNaN(n.attr("height")) && !isNaN(n.attr("width")) || (n.attr("height", 9),
                        n.attr("width", 16));
                        var r = "object" === this.tagName.toLowerCase() || n.attr("height") && !isNaN(parseInt(n.attr("height"), 10)) ? parseInt(n.attr("height"), 10) : n.height()
                          , o = isNaN(parseInt(n.attr("width"), 10)) ? n.width() : parseInt(n.attr("width"), 10)
                          , s = r / o;
                        if (!n.attr("id")) {
                            var a = "fitvid" + t;
                            n.attr("id", a)
                        }
                        n.wrap('<div class="fluid-width-video-wrapper"></div>').parent(".fluid-width-video-wrapper").css("padding-top", 100 * s + "%"),
                        n.removeAttr("height").removeAttr("width")
                    }
                })
            })
        }
    }(window.jQuery || window.Zepto),
    /*!
   * rivets-cart.js
   */
    function() {
        var e, n, i, r, o, s, a = function(e, t) {
            return function() {
                return e.apply(t, arguments)
            }
        };
        n = function() {
            function e() {
                this.update = a(this.update, this)
            }
            return e.prototype.update = function(e) {
                var t, n, i;
                for (n in e)
                    i = e[n],
                    "items" !== n && (this[n] = i);
                return this.items = function() {
                    var n, i, o, s;
                    for (o = e.items,
                    s = [],
                    n = 0,
                    i = o.length; n < i; n++)
                        t = o[n],
                        s.push(new r(t));
                    return s
                }()
            }
            ,
            e
        }(),
        r = function() {
            function e(e) {
                this.propertyArray = a(this.propertyArray, this),
                this.update = a(this.update, this),
                this.update(e)
            }
            return e.prototype.update = function(e) {
                var t, n;
                for (t in e)
                    n = e[t],
                    "properties" !== t && (this[t] = n);
                return this.properties = i.Utils.extend({}, e.properties)
            }
            ,
            e.prototype.propertyArray = function() {
                var e, t, n, i;
                n = this.properties,
                i = [];
                for (e in n)
                    t = n[e],
                    i.push({
                        name: e,
                        value: t
                    });
                return i
            }
            ,
            e
        }(),
        i = {
            settings: {
                debug: !1,
                dataAPI: !0,
                requestBodyClass: null,
                rivetsModels: {},
                currency: null,
                moneyFormat: null,
                moneyWithCurrencyFormat: null,
                weightUnit: "g",
                weightPrecision: 0
            },
            cart: new n
        },
        i.init = function(e, n) {
            return null == n && (n = {}),
            i.configure(n),
            i.Utils.log("Initialising CartJS."),
            i.cart.update(e),
            i.settings.dataAPI && (i.Utils.log('"dataAPI" setting is true, initialising Data API.'),
            i.Data.init()),
            i.settings.requestBodyClass && (i.Utils.log('"requestBodyClass" set, adding event listeners.'),
            t(document).on("cart.requestStarted", function() {
                return t("body").addClass(i.settings.requestBodyClass)
            }),
            t(document).on("cart.requestComplete", function() {
                return t("body").removeClass(i.settings.requestBodyClass)
            })),
            i.Rivets.init(),
            t(document).trigger("cart.ready", [i.cart])
        }
        ,
        i.configure = function(e) {
            return null == e && (e = {}),
            i.Utils.extend(i.settings, e)
        }
        ,
        null == window.console && (window.console = {},
        window.console.log = function() {}
        ),
        i.Utils = {
            log: function() {
                return i.Utils.console(console.log, arguments)
            },
            error: function() {
                return i.Utils.console(console.error, arguments)
            },
            console: function(e, t) {
                if (i.settings.debug && "undefined" != typeof console && null !== console)
                    return t = Array.prototype.slice.call(t),
                    t.unshift("[CartJS]:"),
                    e.apply(console, t)
            },
            wrapKeys: function(e, t, n) {
                var i, r, o;
                null == t && (t = "properties"),
                o = {};
                for (i in e)
                    r = e[i],
                    o["" + t + "[" + i + "]"] = null != n ? n : r;
                return o
            },
            unwrapKeys: function(e, t, n) {
                var i, r, o, s;
                null == t && (t = "properties"),
                r = {};
                for (i in e)
                    s = e[i],
                    o = i.replace("" + t + "[", "").replace("]", ""),
                    r[o] = null != n ? n : s;
                return r
            },
            extend: function(e, t) {
                var n, i;
                for (n in t)
                    i = t[n],
                    e[n] = i;
                return e
            },
            clone: function(e) {
                var t, n;
                if (null == e || "object" != typeof e)
                    return e;
                n = new e.constructor;
                for (t in e)
                    n[t] = clone(e[t]);
                return n
            },
            isArray: Array.isArray || function(e) {
                return "[object Array]" === {}.toString.call(e)
            }
            ,
            ensureArray: function(e) {
                return i.Utils.isArray(e) ? e : null != e ? [e] : []
            },
            formatMoney: function(e, t, n, r) {
                var o, s;
                return null == r && (r = ""),
                r || (r = i.settings.currency),
                null != window.Currency && r !== i.settings.currency && (e = Currency.convert(e, i.settings.currency, r),
                null != (null != (o = window.Currency) ? o.moneyFormats : void 0) && r in window.Currency.moneyFormats && (t = window.Currency.moneyFormats[r][n])),
                null != (null != (s = window.Shopify) ? s.formatMoney : void 0) ? Shopify.formatMoney(e, t) : e
            },
            getSizedImageUrl: function(e, t) {
                var n, i;
                return null != (null != (n = window.Shopify) && null != (i = n.Image) ? i.getSizedImageUrl : void 0) ? e ? Shopify.Image.getSizedImageUrl(e, t) : Shopify.Image.getSizedImageUrl("https://cdn.shopify.com/s/images/admin/no-image-.gif", t).replace("-_", "-") : e ? e : "https://cdn.shopify.com/s/images/admin/no-image-large.gif"
            }
        },
        s = [],
        o = !1,
        i.Queue = {
            add: function(e, n, r) {
                var a;
                if (null == r && (r = {}),
                a = {
                    url: e,
                    data: n,
                    type: r.type || "POST",
                    dataType: r.dataType || "json",
                    success: i.Utils.ensureArray(r.success),
                    error: i.Utils.ensureArray(r.error),
                    complete: i.Utils.ensureArray(r.complete)
                },
                r.updateCart && a.success.push(i.cart.update),
                s.push(a),
                !o)
                    return t(document).trigger("cart.requestStarted", [i.cart]),
                    i.Queue.process()
            },
            process: function() {
                var e;
                return s.length ? (o = !0,
                e = s.shift(),
                e.complete = i.Queue.process,
                t.ajax(e)) : (o = !1,
                void t(document).trigger("cart.requestComplete", [i.cart]))
            }
        },
        i.Core = {
            getCart: function(e) {
                return null == e && (e = {}),
                e.type = "GET",
                e.updateCart = !0,
                i.Queue.add(StyleHatch.routes.cart_url + ".js", {}, e)
            },
            addItem: function(e, t, n, r) {
                var o;
                return null == t && (t = 1),
                null == n && (n = {}),
                null == r && (r = {}),
                o = i.Utils.wrapKeys(n),
                o.id = e,
                o.quantity = t,
                i.Queue.add(StyleHatch.routes.cart_add_url + ".js", o, r),
                i.Core.getCart()
            },
            updateItem: function(e, t, n, r) {
                var o;
                return null == n && (n = {}),
                null == r && (r = {}),
                o = i.Utils.wrapKeys(n),
                o.line = e,
                null != t && (o.quantity = t),
                r.updateCart = !0,
                i.Queue.add(StyleHatch.routes.cart_change_url + ".js", o, r)
            },
            removeItem: function(e, t) {
                return null == t && (t = {}),
                i.Core.updateItem(e, 0, {}, t)
            },
            updateItemById: function(e, t, n, r) {
                var o;
                return null == n && (n = {}),
                null == r && (r = {}),
                o = i.Utils.wrapKeys(n),
                o.id = e,
                null != t && (o.quantity = t),
                r.updateCart = !0,
                i.Queue.add(StyleHatch.routes.cart_change_url + ".js", o, r)
            },
            updateItemQuantitiesById: function(e, t) {
                return null == e && (e = {}),
                null == t && (t = {}),
                t.updateCart = !0,
                i.Queue.add(StyleHatch.routes.cart_url + "/update.js", {
                    updates: e
                }, t)
            },
            removeItemById: function(e, t) {
                var n;
                return null == t && (t = {}),
                n = {
                    id: e,
                    quantity: 0
                },
                t.updateCart = !0,
                i.Queue.add(StyleHatch.routes.cart_change_url + ".js", n, t)
            },
            clear: function(e) {
                return null == e && (e = {}),
                e.updateCart = !0,
                i.Queue.add(StyleHatch.routes.cart_clear_url + ".js", {}, e)
            },
            getAttribute: function(e, t) {
                return e in i.cart.attributes ? i.cart.attributes[e] : t
            },
            setAttribute: function(e, t, n) {
                var r;
                return null == n && (n = {}),
                r = {},
                r[e] = t,
                i.Core.setAttributes(r, n)
            },
            getAttributes: function() {
                return i.cart.attributes
            },
            setAttributes: function(e, t) {
                return null == e && (e = {}),
                null == t && (t = {}),
                t.updateCart = !0,
                i.Queue.add(StyleHatch.routes.cart_url + "/update.js", i.Utils.wrapKeys(e, "attributes"), t)
            },
            clearAttributes: function(e) {
                return null == e && (e = {}),
                e.updateCart = !0,
                i.Queue.add(StyleHatch.routes.cart_url + "/update.js", i.Utils.wrapKeys(i.Core.getAttributes(), "attributes", ""), e)
            },
            getNote: function() {
                return i.cart.note
            },
            setNote: function(e, t) {
                return null == t && (t = {}),
                t.updateCart = !0,
                i.Queue.add(StyleHatch.routes.cart_url + "/update.js", {
                    note: e
                }, t)
            }
        },
        e = null,
        i.Data = {
            init: function() {
                return e = t(document),
                i.Data.setEventListeners("on"),
                i.Data.render(null, i.cart)
            },
            destroy: function() {
                return i.Data.setEventListeners("off")
            },
            setEventListeners: function(t) {
                return e[t]("click", "[data-cart-add]", i.Data.add),
                e[t]("click", "[data-cart-remove]", i.Data.remove),
                e[t]("click", "[data-cart-remove-id]", i.Data.removeById),
                e[t]("click", "[data-cart-update]", i.Data.update),
                e[t]("click", "[data-cart-update-id]", i.Data.updateById),
                e[t]("click", "[data-cart-clear]", i.Data.clear),
                e[t]("change", "[data-cart-toggle]", i.Data.toggle),
                e[t]("change", "[data-cart-toggle-attribute]", i.Data.toggleAttribute),
                e[t]("submit", "[data-cart-submit]", i.Data.submit),
                e[t]("cart.requestComplete", i.Data.render)
            },
            add: function(e) {
                var n;
                return e.preventDefault(),
                n = t(this),
                i.Core.addItem(n.attr("data-cart-add"), n.attr("data-cart-quantity"))
            },
            remove: function(e) {
                var n;
                return e.preventDefault(),
                n = t(this),
                i.Core.removeItem(n.attr("data-cart-remove"))
            },
            removeById: function(e) {
                var n;
                return e.preventDefault(),
                n = t(this),
                i.Core.removeItemById(n.attr("data-cart-remove-id"))
            },
            update: function(e) {
                var n;
                return e.preventDefault(),
                n = t(this),
                i.Core.updateItem(n.attr("data-cart-update"), n.attr("data-cart-quantity"))
            },
            updateById: function(e) {
                var n;
                return e.preventDefault(),
                n = t(this),
                i.Core.updateItemById(n.attr("data-cart-update-id"), n.attr("data-cart-quantity"))
            },
            clear: function(e) {
                return e.preventDefault(),
                i.Core.clear()
            },
            toggle: function(e) {
                var n, r;
                return n = t(this),
                r = n.attr("data-cart-toggle"),
                n.is(":checked") ? i.Core.addItem(r) : i.Core.removeItemById(r)
            },
            toggleAttribute: function(e) {
                var n, r;
                return n = t(this),
                r = n.attr("data-cart-toggle-attribute"),
                i.Core.setAttribute(r, n.is(":checked") ? "Yes" : "")
            },
            submit: function(e) {
                var n, r, o, s;
                return e.preventDefault(),
                n = t(this).serializeArray(),
                r = void 0,
                s = void 0,
                o = {},
                t.each(n, function(e, t) {
                    return "id" === t.name ? r = t.value : "quantity" === t.name ? s = t.value : t.name.match(/^properties\[\w+\]$/) ? o[t.name] = t.value : void 0
                }),
                i.Core.addItem(r, s, i.Utils.unwrapKeys(o))
            },
            render: function(e, n) {
                var r;
                return r = {
                    item_count: n.item_count,
                    total_price: n.total_price,
                    total_price_money: i.Utils.formatMoney(n.total_price, i.settings.moneyFormat, "money_format", null != ("undefined" != typeof Currency && null !== Currency ? Currency.currentCurrency : void 0) ? Currency.currentCurrency : void 0),
                    total_price_money_with_currency: i.Utils.formatMoney(n.total_price, i.settings.moneyWithCurrencyFormat, "money_with_currency_format", null != ("undefined" != typeof Currency && null !== Currency ? Currency.currentCurrency : void 0) ? Currency.currentCurrency : void 0)
                },
                t("[data-cart-render]").each(function() {
                    var e;
                    return e = t(this),
                    e.html(r[e.attr("data-cart-render")])
                })
            }
        },
        "rivets"in window ? (i.Rivets = {
            model: null,
            boundViews: [],
            init: function() {
                return i.Rivets.bindViews()
            },
            destroy: function() {
                return i.Rivets.unbindViews()
            },
            bindViews: function() {
                return i.Utils.log("Rivets.js is present, binding views."),
                i.Rivets.unbindViews(),
                i.Rivets.model = i.Utils.extend({
                    cart: i.cart
                }, i.settings.rivetsModels),
                null != window.Currency && (i.Rivets.model.Currency = window.Currency),
                t("[data-cart-view]").each(function() {
                    var e;
                    return e = rivets.bind(t(this), i.Rivets.model),
                    i.Rivets.boundViews.push(e)
                })
            },
            unbindViews: function() {
                var e, t, n, r;
                for (r = i.Rivets.boundViews,
                t = 0,
                n = r.length; t < n; t++)
                    e = r[t],
                    e.unbind();
                return i.Rivets.boundViews = []
            }
        },
        rivets.formatters.eq = function(e, t) {
            return e === t
        }
        ,
        rivets.formatters.includes = function(e, t) {
            return e.indexOf(t) >= 0
        }
        ,
        rivets.formatters.match = function(e, t, n) {
            return e.match(new RegExp(t,n))
        }
        ,
        rivets.formatters.lt = function(e, t) {
            return e < t
        }
        ,
        rivets.formatters.gt = function(e, t) {
            return e > t
        }
        ,
        rivets.formatters.not = function(e) {
            return !e
        }
        ,
        rivets.formatters.empty = function(e) {
            return !e.length
        }
        ,
        rivets.formatters.plus = function(e, t) {
            return parseInt(e) + parseInt(t)
        }
        ,
        rivets.formatters.minus = function(e, t) {
            return parseInt(e) - parseInt(t)
        }
        ,
        rivets.formatters.times = function(e, t) {
            return e * t
        }
        ,
        rivets.formatters.divided_by = function(e, t) {
            return e / t
        }
        ,
        rivets.formatters.modulo = function(e, t) {
            return e % t
        }
        ,
        rivets.formatters.prepend = function(e, t) {
            return t + e
        }
        ,
        rivets.formatters.append = function(e, t) {
            return e + t
        }
        ,
        rivets.formatters.slice = function(e, t, n) {
            return e.slice(t, n)
        }
        ,
        rivets.formatters.pluralize = function(e, t, n) {
            return null == n && (n = t + "s"),
            i.Utils.isArray(e) && (e = e.length),
            1 === e ? t : n
        }
        ,
        rivets.formatters.array_element = function(e, t) {
            return e[t]
        }
        ,
        rivets.formatters.array_first = function(e) {
            return e[0]
        }
        ,
        rivets.formatters.array_last = function(e) {
            return e[e.length - 1]
        }
        ,
        rivets.formatters.money = function(e, t) {
            return i.Utils.formatMoney(e, i.settings.moneyFormat, "money_format", t)
        }
        ,
        rivets.formatters.money_with_currency = function(e, t) {
            return i.Utils.formatMoney(e, i.settings.moneyWithCurrencyFormat, "money_with_currency_format", t)
        }
        ,
        rivets.formatters.weight = function(e) {
            switch (i.settings.weightUnit) {
            case "kg":
                return (e / 1e3).toFixed(i.settings.weightPrecision);
            case "oz":
                return (.035274 * e).toFixed(i.settings.weightPrecision);
            case "lb":
                return (.00220462 * e).toFixed(i.settings.weightPrecision);
            default:
                return e.toFixed(i.settings.weightPrecision)
            }
        }
        ,
        rivets.formatters.weight_with_unit = function(e) {
            return rivets.formatters.weight(e) + i.settings.weightUnit
        }
        ,
        rivets.formatters.product_image_size = function(e, t) {
            return i.Utils.getSizedImageUrl(e, t)
        }
        ,
        rivets.formatters.moneyWithCurrency = rivets.formatters.money_with_currency,
        rivets.formatters.weightWithUnit = rivets.formatters.weight_with_unit,
        rivets.formatters.productImageSize = rivets.formatters.product_image_size) : i.Rivets = {
            init: function() {},
            destroy: function() {}
        },
        i.factory = function(e) {
            return e.init = i.init,
            e.configure = i.configure,
            e.cart = i.cart,
            e.settings = i.settings,
            e.getCart = i.Core.getCart,
            e.addItem = i.Core.addItem,
            e.updateItem = i.Core.updateItem,
            e.updateItemById = i.Core.updateItemById,
            e.updateItemQuantitiesById = i.Core.updateItemQuantitiesById,
            e.removeItem = i.Core.removeItem,
            e.removeItemById = i.Core.removeItemById,
            e.clear = i.Core.clear,
            e.getAttribute = i.Core.getAttribute,
            e.setAttribute = i.Core.setAttribute,
            e.getAttributes = i.Core.getAttributes,
            e.setAttributes = i.Core.setAttributes,
            e.clearAttributes = i.Core.clearAttributes,
            e.getNote = i.Core.getNote,
            e.setNote = i.Core.setNote,
            e.render = i.Data.render
        }
        ,
        "object" == typeof exports ? i.factory(exports) : "function" == typeof define && define.amd ? define(["exports"], function(e) {
            return i.factory(this.CartJS = e),
            e
        }) : i.factory(this.CartJS = {})
    }
    .call(this),
    /*!
   * easyzoom.js
   */
    /*!
   * @name        EasyZoom
   * @author      Matt Hinchliffe <>
   * @modified    Wednesday, November 4th, 2015
   * @version     2.3.1
   */
    !function(e) {
        "use strict";
        function t(t, n) {
            this.$target = e(t),
            this.opts = e.extend({}, l, n, this.$target.data()),
            void 0 === this.isOpen && this._init()
        }
        var n, i, r, o, s, a, l = {
            loadingNotice: "Loading image",
            errorNotice: "The image could not be loaded",
            errorDuration: 2500,
            preventClicks: !0,
            onShow: e.noop,
            onHide: e.noop,
            onMove: e.noop
        };
        t.prototype._init = function() {
            this.$link = this.$target.find("a"),
            this.$image = this.$target.find("img"),
            this.$flyout = e('<div class="easyzoom-flyout" />'),
            this.$notice = e('<div class="easyzoom-notice" />'),
            this.$target.on({
                "mousemove.easyzoom touchmove.easyzoom": e.proxy(this._onMove, this),
                "mouseleave.easyzoom touchend.easyzoom": e.proxy(this._onLeave, this),
                "mouseenter.easyzoom touchstart.easyzoom": e.proxy(this._onEnter, this)
            }),
            this.opts.preventClicks && this.$target.on("click.easyzoom", function(e) {
                e.preventDefault()
            })
        }
        ,
        t.prototype.show = function(e, t) {
            var s, a, l, u, c = this;
            return this.isReady ? (this.$target.append(this.$flyout),
            s = this.$target.width(),
            a = this.$target.height(),
            l = this.$flyout.width(),
            u = this.$flyout.height(),
            n = this.$zoom.width() - l,
            i = this.$zoom.height() - u,
            r = n / s,
            o = i / a,
            this.isOpen = !0,
            this.opts.onShow.call(this),
            void (e && this._move(e))) : this._loadImage(this.$link.attr("href"), function() {
                (c.isMouseOver || !t) && c.show(e)
            })
        }
        ,
        t.prototype._onEnter = function(e) {
            var t = e.originalEvent.touches;
            this.isMouseOver = !0,
            t && 1 != t.length || (e.preventDefault(),
            this.show(e, !0))
        }
        ,
        t.prototype._onMove = function(e) {
            this.isOpen && (e.preventDefault(),
            this._move(e))
        }
        ,
        t.prototype._onLeave = function() {
            this.isMouseOver = !1,
            this.isOpen && this.hide()
        }
        ,
        t.prototype._onLoad = function(e) {
            e.currentTarget.width && (this.isReady = !0,
            this.$notice.detach(),
            this.$flyout.html(this.$zoom),
            this.$target.removeClass("is-loading").addClass("is-ready"),
            e.data.call && e.data())
        }
        ,
        t.prototype._onError = function() {
            var e = this;
            this.$notice.text(this.opts.errorNotice),
            this.$target.removeClass("is-loading").addClass("is-error"),
            this.detachNotice = setTimeout(function() {
                e.$notice.detach(),
                e.detachNotice = null
            }, this.opts.errorDuration)
        }
        ,
        t.prototype._loadImage = function(t, n) {
            var i = new Image;
            this.$target.addClass("is-loading").append(this.$notice.text(this.opts.loadingNotice)),
            this.$zoom = e(i).on("error", e.proxy(this._onError, this)).on("load", n, e.proxy(this._onLoad, this)),
            i.style.position = "absolute",
            i.src = t
        }
        ,
        t.prototype._move = function(e) {
            if (0 === e.type.indexOf("touch")) {
                var t = e.touches || e.originalEvent.touches;
                s = t[0].pageX,
                a = t[0].pageY
            } else
                s = e.pageX || s,
                a = e.pageY || a;
            var l = this.$target.offset()
              , u = a - l.top
              , c = s - l.left
              , d = Math.ceil(u * o)
              , f = Math.ceil(c * r);
            if (0 > f || 0 > d || f > n || d > i)
                this.hide();
            else {
                var h = -1 * d
                  , p = -1 * f;
                this.$zoom.css({
                    top: h,
                    left: p
                }),
                this.opts.onMove.call(this, h, p)
            }
        }
        ,
        t.prototype.hide = function() {
            this.isOpen && (this.$flyout.detach(),
            this.isOpen = !1,
            this.opts.onHide.call(this))
        }
        ,
        t.prototype.swap = function(t, n, i) {
            this.hide(),
            this.isReady = !1,
            this.detachNotice && clearTimeout(this.detachNotice),
            this.$notice.parent().length && this.$notice.detach(),
            this.$target.removeClass("is-loading is-ready is-error"),
            this.$image.attr({
                src: t,
                srcset: e.isArray(i) ? i.join() : i
            }),
            this.$link.attr("href", n)
        }
        ,
        t.prototype.teardown = function() {
            this.hide(),
            this.$target.off(".easyzoom").removeClass("is-loading is-ready is-error"),
            this.detachNotice && clearTimeout(this.detachNotice),
            delete this.$link,
            delete this.$zoom,
            delete this.$image,
            delete this.$notice,
            delete this.$flyout,
            delete this.isOpen,
            delete this.isReady
        }
        ,
        e.fn.easyZoom = function(n) {
            return this.each(function() {
                var i = e.data(this, "easyZoom");
                i ? void 0 === i.isOpen && i._init() : e.data(this, "easyZoom", new t(this,n))
            })
        }
        ,
        "function" == typeof define && define.amd ? define(function() {
            return t
        }) : "undefined" != typeof module && module.exports && (module.exports = t)
    }(t),
    /*!
   * jquery.remove-data-attribute.js
   */
    e.fn.extend({
        removeDataAttributes: function() {
            var t, n = e(this), i = [], r = n.get(0).attributes, o = r.length;
            for (t = 0; t < o; t++)
                "data-" === r[t].name.substring(0, 5) && i.push(r[t].name);
            e.each(i, function(e, t) {
                n.removeAttr(t)
            })
        }
    })
}(jq223);
var getQueryString = function(e, t) {
    var n = t ? t : window.location.href
      , i = new RegExp("[?&]" + e + "=([^&#]*)","i")
      , r = i.exec(n);
    return r ? r[1] : null
};
!function(e, t) {
    "object" == typeof exports && "undefined" != typeof module ? t() : "function" == typeof define && define.amd ? define("inert", t) : t()
}(this, function() {
    "use strict";
    function e(e, t) {
        if (!(e instanceof t))
            throw new TypeError("Cannot call a class as a function")
    }
    function t(e, n, i) {
        if (e.nodeType == Node.ELEMENT_NODE) {
            var r = e;
            n && n(r);
            var o = r.shadowRoot;
            if (o)
                return void t(o, n, o);
            if ("content" == r.localName) {
                for (var s = r, a = s.getDistributedNodes ? s.getDistributedNodes() : [], l = 0; l < a.length; l++)
                    t(a[l], n, i);
                return
            }
            if ("slot" == r.localName) {
                for (var u = r, c = u.assignedNodes ? u.assignedNodes({
                    flatten: !0
                }) : [], d = 0; d < c.length; d++)
                    t(c[d], n, i);
                return
            }
        }
        for (var f = e.firstChild; null != f; )
            t(f, n, i),
            f = f.nextSibling
    }
    function n(e) {
        if (!e.querySelector("style#inert-style")) {
            var t = document.createElement("style");
            t.setAttribute("id", "inert-style"),
            t.textContent = "\n[inert] {\n  pointer-events: none;\n  cursor: default;\n}\n\n[inert], [inert] * {\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n}\n",
            e.appendChild(t)
        }
    }
    var i = function() {
        function e(e, t) {
            for (var n = 0; n < t.length; n++) {
                var i = t[n];
                i.enumerable = i.enumerable || !1,
                i.configurable = !0,
                "value"in i && (i.writable = !0),
                Object.defineProperty(e, i.key, i)
            }
        }
        return function(t, n, i) {
            return n && e(t.prototype, n),
            i && e(t, i),
            t
        }
    }()
      , r = Array.prototype.slice
      , o = Element.prototype.matches || Element.prototype.msMatchesSelector
      , s = ["a[href]", "area[href]", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])", "button:not([disabled])", "details", "summary", "iframe", "object", "embed", "[contenteditable]"].join(",")
      , a = function() {
        function n(t, i) {
            e(this, n),
            this._inertManager = i,
            this._rootElement = t,
            this._managedNodes = new Set,
            this._rootElement.hasAttribute("aria-hidden") ? this._savedAriaHidden = this._rootElement.getAttribute("aria-hidden") : this._savedAriaHidden = null,
            this._rootElement.setAttribute("aria-hidden", "true"),
            this._makeSubtreeUnfocusable(this._rootElement),
            this._observer = new MutationObserver(this._onMutation.bind(this)),
            this._observer.observe(this._rootElement, {
                attributes: !0,
                childList: !0,
                subtree: !0
            })
        }
        return i(n, [{
            key: "destructor",
            value: function() {
                this._observer.disconnect(),
                this._rootElement && (null !== this._savedAriaHidden ? this._rootElement.setAttribute("aria-hidden", this._savedAriaHidden) : this._rootElement.removeAttribute("aria-hidden")),
                this._managedNodes.forEach(function(e) {
                    this._unmanageNode(e.node)
                }, this),
                this._observer = null,
                this._rootElement = null,
                this._managedNodes = null,
                this._inertManager = null
            }
        }, {
            key: "_makeSubtreeUnfocusable",
            value: function(e) {
                var n = this;
                t(e, function(e) {
                    return n._visitNode(e)
                });
                var i = document.activeElement;
                if (!document.body.contains(e)) {
                    for (var r = e, o = void 0; r; ) {
                        if (r.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                            o = r;
                            break
                        }
                        r = r.parentNode
                    }
                    o && (i = o.activeElement)
                }
                e.contains(i) && (i.blur(),
                i === document.activeElement && document.body.focus())
            }
        }, {
            key: "_visitNode",
            value: function(e) {
                if (e.nodeType === Node.ELEMENT_NODE) {
                    var t = e;
                    t !== this._rootElement && t.hasAttribute("inert") && this._adoptInertRoot(t),
                    (o.call(t, s) || t.hasAttribute("tabindex")) && this._manageNode(t)
                }
            }
        }, {
            key: "_manageNode",
            value: function(e) {
                var t = this._inertManager.register(e, this);
                this._managedNodes.add(t)
            }
        }, {
            key: "_unmanageNode",
            value: function(e) {
                var t = this._inertManager.deregister(e, this);
                t && this._managedNodes.delete(t)
            }
        }, {
            key: "_unmanageSubtree",
            value: function(e) {
                var n = this;
                t(e, function(e) {
                    return n._unmanageNode(e)
                })
            }
        }, {
            key: "_adoptInertRoot",
            value: function(e) {
                var t = this._inertManager.getInertRoot(e);
                t || (this._inertManager.setInert(e, !0),
                t = this._inertManager.getInertRoot(e)),
                t.managedNodes.forEach(function(e) {
                    this._manageNode(e.node)
                }, this)
            }
        }, {
            key: "_onMutation",
            value: function(e, t) {
                e.forEach(function(e) {
                    var t = e.target;
                    if ("childList" === e.type)
                        r.call(e.addedNodes).forEach(function(e) {
                            this._makeSubtreeUnfocusable(e)
                        }, this),
                        r.call(e.removedNodes).forEach(function(e) {
                            this._unmanageSubtree(e)
                        }, this);
                    else if ("attributes" === e.type)
                        if ("tabindex" === e.attributeName)
                            this._manageNode(t);
                        else if (t !== this._rootElement && "inert" === e.attributeName && t.hasAttribute("inert")) {
                            this._adoptInertRoot(t);
                            var n = this._inertManager.getInertRoot(t);
                            this._managedNodes.forEach(function(e) {
                                t.contains(e.node) && n._manageNode(e.node)
                            })
                        }
                }, this)
            }
        }, {
            key: "managedNodes",
            get: function() {
                return new Set(this._managedNodes)
            }
        }, {
            key: "hasSavedAriaHidden",
            get: function() {
                return null !== this._savedAriaHidden
            }
        }, {
            key: "savedAriaHidden",
            set: function(e) {
                this._savedAriaHidden = e
            },
            get: function() {
                return this._savedAriaHidden
            }
        }]),
        n
    }()
      , l = function() {
        function t(n, i) {
            e(this, t),
            this._node = n,
            this._overrodeFocusMethod = !1,
            this._inertRoots = new Set([i]),
            this._savedTabIndex = null,
            this._destroyed = !1,
            this.ensureUntabbable()
        }
        return i(t, [{
            key: "destructor",
            value: function() {
                if (this._throwIfDestroyed(),
                this._node && this._node.nodeType === Node.ELEMENT_NODE) {
                    var e = this._node;
                    null !== this._savedTabIndex ? e.setAttribute("tabindex", this._savedTabIndex) : e.removeAttribute("tabindex"),
                    this._overrodeFocusMethod && delete e.focus
                }
                this._node = null,
                this._inertRoots = null,
                this._destroyed = !0
            }
        }, {
            key: "_throwIfDestroyed",
            value: function() {
                if (this.destroyed)
                    throw new Error("Trying to access destroyed InertNode")
            }
        }, {
            key: "ensureUntabbable",
            value: function() {
                if (this.node.nodeType === Node.ELEMENT_NODE) {
                    var e = this.node;
                    if (o.call(e, s)) {
                        if (e.tabIndex === -1 && this.hasSavedTabIndex)
                            return;
                        e.hasAttribute("tabindex") && (this._savedTabIndex = e.tabIndex),
                        e.setAttribute("tabindex", "-1"),
                        e.nodeType === Node.ELEMENT_NODE && (e.focus = function() {}
                        ,
                        this._overrodeFocusMethod = !0)
                    } else
                        e.hasAttribute("tabindex") && (this._savedTabIndex = e.tabIndex,
                        e.removeAttribute("tabindex"))
                }
            }
        }, {
            key: "addInertRoot",
            value: function(e) {
                this._throwIfDestroyed(),
                this._inertRoots.add(e)
            }
        }, {
            key: "removeInertRoot",
            value: function(e) {
                this._throwIfDestroyed(),
                this._inertRoots.delete(e),
                0 === this._inertRoots.size && this.destructor()
            }
        }, {
            key: "destroyed",
            get: function() {
                return this._destroyed
            }
        }, {
            key: "hasSavedTabIndex",
            get: function() {
                return null !== this._savedTabIndex
            }
        }, {
            key: "node",
            get: function() {
                return this._throwIfDestroyed(),
                this._node
            }
        }, {
            key: "savedTabIndex",
            set: function(e) {
                this._throwIfDestroyed(),
                this._savedTabIndex = e
            },
            get: function() {
                return this._throwIfDestroyed(),
                this._savedTabIndex
            }
        }]),
        t
    }()
      , u = function() {
        function t(i) {
            if (e(this, t),
            !i)
                throw new Error("Missing required argument; InertManager needs to wrap a document.");
            this._document = i,
            this._managedNodes = new Map,
            this._inertRoots = new Map,
            this._observer = new MutationObserver(this._watchForInert.bind(this)),
            n(i.head || i.body || i.documentElement),
            "loading" === i.readyState ? i.addEventListener("DOMContentLoaded", this._onDocumentLoaded.bind(this)) : this._onDocumentLoaded()
        }
        return i(t, [{
            key: "setInert",
            value: function(e, t) {
                if (t) {
                    if (this._inertRoots.has(e))
                        return;
                    var i = new a(e,this);
                    if (e.setAttribute("inert", ""),
                    this._inertRoots.set(e, i),
                    !this._document.body.contains(e))
                        for (var r = e.parentNode; r; )
                            11 === r.nodeType && n(r),
                            r = r.parentNode
                } else {
                    if (!this._inertRoots.has(e))
                        return;
                    var o = this._inertRoots.get(e);
                    o.destructor(),
                    this._inertRoots.delete(e),
                    e.removeAttribute("inert")
                }
            }
        }, {
            key: "getInertRoot",
            value: function(e) {
                return this._inertRoots.get(e)
            }
        }, {
            key: "register",
            value: function(e, t) {
                var n = this._managedNodes.get(e);
                return void 0 !== n ? n.addInertRoot(t) : n = new l(e,t),
                this._managedNodes.set(e, n),
                n
            }
        }, {
            key: "deregister",
            value: function(e, t) {
                var n = this._managedNodes.get(e);
                return n ? (n.removeInertRoot(t),
                n.destroyed && this._managedNodes.delete(e),
                n) : null
            }
        }, {
            key: "_onDocumentLoaded",
            value: function() {
                var e = r.call(this._document.querySelectorAll("[inert]"));
                e.forEach(function(e) {
                    this.setInert(e, !0)
                }, this),
                this._observer.observe(this._document.body || this._document.documentElement, {
                    attributes: !0,
                    subtree: !0,
                    childList: !0
                })
            }
        }, {
            key: "_watchForInert",
            value: function(e, t) {
                var n = this;
                e.forEach(function(e) {
                    switch (e.type) {
                    case "childList":
                        r.call(e.addedNodes).forEach(function(e) {
                            if (e.nodeType === Node.ELEMENT_NODE) {
                                var t = r.call(e.querySelectorAll("[inert]"));
                                o.call(e, "[inert]") && t.unshift(e),
                                t.forEach(function(e) {
                                    this.setInert(e, !0)
                                }, n)
                            }
                        }, n);
                        break;
                    case "attributes":
                        if ("inert" !== e.attributeName)
                            return;
                        var t = e.target
                          , i = t.hasAttribute("inert");
                        n.setInert(t, i)
                    }
                }, this)
            }
        }]),
        t
    }()
      , c = new u(document);
    Element.prototype.hasOwnProperty("inert") || Object.defineProperty(Element.prototype, "inert", {
        enumerable: !0,
        get: function() {
            return this.hasAttribute("inert")
        },
        set: function(e) {
            c.setInert(this, e)
        }
    })
}),
/*!
 * store.js
 */
/*
https://github.com/marcuswestin/store.js/
The MIT License (MIT)
Copyright (c) 2010-2016 Marcus Westin */
function(e) {
    if ("object" == typeof exports && "undefined" != typeof module)
        module.exports = e();
    else if ("function" == typeof define && define.amd)
        define([], e);
    else {
        var t;
        t = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this,
        t.store = e()
    }
}(function() {
    return function e(t, n, i) {
        function r(s, a) {
            if (!n[s]) {
                if (!t[s]) {
                    var l = "function" == typeof require && require;
                    if (!a && l)
                        return l(s, !0);
                    if (o)
                        return o(s, !0);
                    var u = new Error("Cannot find module '" + s + "'");
                    throw u.code = "MODULE_NOT_FOUND",
                    u
                }
                var c = n[s] = {
                    exports: {}
                };
                t[s][0].call(c.exports, function(e) {
                    var n = t[s][1][e];
                    return r(n ? n : e)
                }, c, c.exports, e, t, n, i)
            }
            return n[s].exports
        }
        for (var o = "function" == typeof require && require, s = 0; s < i.length; s++)
            r(i[s]);
        return r
    }({
        1: [function(e, t, n) {
            (function(e) {
                "use strict";
                t.exports = function() {
                    function t() {
                        try {
                            return s in r && r[s]
                        } catch (e) {
                            return !1
                        }
                    }
                    var n, i = {}, r = "undefined" != typeof window ? window : e, o = r.document, s = "localStorage", a = "script";
                    if (i.disabled = !1,
                    i.version = "1.3.20",
                    i.set = function(e, t) {}
                    ,
                    i.get = function(e, t) {}
                    ,
                    i.has = function(e) {
                        return void 0 !== i.get(e)
                    }
                    ,
                    i.remove = function(e) {}
                    ,
                    i.clear = function() {}
                    ,
                    i.transact = function(e, t, n) {
                        null == n && (n = t,
                        t = null),
                        null == t && (t = {});
                        var r = i.get(e, t);
                        n(r),
                        i.set(e, r)
                    }
                    ,
                    i.getAll = function() {}
                    ,
                    i.forEach = function() {}
                    ,
                    i.serialize = function(e) {
                        return JSON.stringify(e)
                    }
                    ,
                    i.deserialize = function(e) {
                        if ("string" == typeof e)
                            try {
                                return JSON.parse(e)
                            } catch (t) {
                                return e || void 0
                            }
                    }
                    ,
                    t())
                        n = r[s],
                        i.set = function(e, t) {
                            return void 0 === t ? i.remove(e) : (n.setItem(e, i.serialize(t)),
                            t)
                        }
                        ,
                        i.get = function(e, t) {
                            var r = i.deserialize(n.getItem(e));
                            return void 0 === r ? t : r
                        }
                        ,
                        i.remove = function(e) {
                            n.removeItem(e)
                        }
                        ,
                        i.clear = function() {
                            n.clear()
                        }
                        ,
                        i.getAll = function() {
                            var e = {};
                            return i.forEach(function(t, n) {
                                e[t] = n
                            }),
                            e
                        }
                        ,
                        i.forEach = function(e) {
                            for (var t = 0; t < n.length; t++) {
                                var r = n.key(t);
                                e(r, i.get(r))
                            }
                        }
                        ;
                    else if (o && o.documentElement.addBehavior) {
                        var l, u;
                        try {
                            u = new ActiveXObject("htmlfile"),
                            u.open(),
                            u.write("<" + a + ">document.w=window</" + a + '><iframe src="/favicon.ico"></iframe>'),
                            u.close(),
                            l = u.w.frames[0].document,
                            n = l.createElement("div")
                        } catch (e) {
                            n = o.createElement("div"),
                            l = o.body
                        }
                        var c = function(e) {
                            return function() {
                                var t = Array.prototype.slice.call(arguments, 0);
                                t.unshift(n),
                                l.appendChild(n),
                                n.addBehavior("#default#userData"),
                                n.load(s);
                                var r = e.apply(i, t);
                                return l.removeChild(n),
                                r
                            }
                        }
                          , d = new RegExp("[!\"#$%&'()*+,/\\\\:;<=>?@[\\]^`{|}~]","g")
                          , f = function(e) {
                            return e.replace(/^d/, "___$&").replace(d, "___")
                        };
                        i.set = c(function(e, t, n) {
                            return t = f(t),
                            void 0 === n ? i.remove(t) : (e.setAttribute(t, i.serialize(n)),
                            e.save(s),
                            n)
                        }),
                        i.get = c(function(e, t, n) {
                            t = f(t);
                            var r = i.deserialize(e.getAttribute(t));
                            return void 0 === r ? n : r
                        }),
                        i.remove = c(function(e, t) {
                            t = f(t),
                            e.removeAttribute(t),
                            e.save(s)
                        }),
                        i.clear = c(function(e) {
                            var t = e.XMLDocument.documentElement.attributes;
                            e.load(s);
                            for (var n = t.length - 1; n >= 0; n--)
                                e.removeAttribute(t[n].name);
                            e.save(s)
                        }),
                        i.getAll = function(e) {
                            var t = {};
                            return i.forEach(function(e, n) {
                                t[e] = n
                            }),
                            t
                        }
                        ,
                        i.forEach = c(function(e, t) {
                            for (var n, r = e.XMLDocument.documentElement.attributes, o = 0; n = r[o]; ++o)
                                t(n.name, i.deserialize(e.getAttribute(n.name)))
                        })
                    }
                    try {
                        var h = "__storejs__";
                        i.set(h, h),
                        i.get(h) != h && (i.disabled = !0),
                        i.remove(h)
                    } catch (e) {
                        i.disabled = !0
                    }
                    return i.enabled = !i.disabled,
                    i
                }()
            }
            ).call(this, "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {})
        }
        , {}]
    }, {}, [1])(1)
});
var storeWithExpiration = {
    set: function(e, t, n) {
        store.set(e, {
            val: t,
            exp: n,
            time: (new Date).getTime()
        })
    },
    get: function(e) {
        var t = store.get(e);
        return t ? (new Date).getTime() - t.time > t.exp ? null : t.val : null
    }
};
